
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnDestroy, TemplateRef, ViewChild, DOCUMENT } from '@angular/core';
import { environment } from 'environments/environment';
import { UntypedFormBuilder, UntypedFormControl, FormsModule } from '@angular/forms';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarConfig, MatSnackBarRef } from '@angular/material/snack-bar';
import { Clipboard } from '@angular/cdk/clipboard';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CognitoUser } from 'app/core/auth-shim';
import { UpdateAccountDefaultsComponent } from 'app/shared/account/update-account-defaults/update-account-defaults.component';
import { UpdateAccountComponent } from 'app/shared/account/update-account/update-account.component';
import { AddEmployeeBulkComponent } from 'app/shared/employee/add-employee-bulk/add-employee-bulk.component';
import { AdminActionsComponent } from 'app/shared/help/admin-actions/admin-actions.component';
import { fetchAllUsersByAccount } from 'app/shared/account/users-by-account-pagination';
import {
  fetchAllAccountMemberActivities,
  fetchAllMembersByTeam,
  fetchAllProductServices,
  fetchAllPropertiesByAccountAndType
} from 'app/shared/pagination/paginated-api-queries';
import { UserActionsComponent } from 'app/shared/help/user-actions/user-actions.component';
import { SupportComponent } from 'app/shared/support/support/support.component';
import { UploadComponent } from 'app/shared/upload/upload.component';
import parseISO from 'date-fns/parseISO';
import _, { Dictionary } from 'lodash-es';
import { filter as _filter, map as _map, cloneDeep, find, findIndex, keyBy, orderBy, remove } from 'lodash-es';
import { DialogService } from 'app/shared/dialog';
import { Entity } from 'app/shared/models/evilo-models';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, Subject, Subscription, combineLatest, firstValueFrom, from, fromEvent, merge, of, timer } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, startWith, switchMap, take, takeUntil, timeout } from 'rxjs/operators';
import { resetFavicon } from 'services/favicon/favicon-remove';
import { AuthService } from '../../../app/auth/auth.service';
import { ChatLabel, DealDefinition, DocumentCategoryType, LeadSourceType, LeadTag, TaskDefinition, WebCall, aggMetricsCache, allPeriods, valueViewValue, valueViewValueType } from '../../../globals/constants';
import { TicketStageDefinition, TicketCategoryDefinition, TicketStageType } from 'app/shared/tickets/ticket.model';
import * as globalFunctions from '../../../globals/functions';
import { LoaderService } from '../../../services/loader/loader.service';
import { navItems } from '../../_nav';
import { navItems as navItemsAnalysis } from '../../_navAnalysis';
import { navItems as navItemsRep } from '../../_navRep';
import { navItems as navItemsSalesmax } from '../../_navSm';
import { CreateTeamAccountComponent } from '../../shared/account/create-team-account/create-team-account.component';
import { AddCompanyComponent } from '../../shared/add-company/add-company.component';
import { getUniqueWabaPhoneNumbers, getUsableWabaAccounts } from 'app/shared/integrations/waba-account-utils';
import { AddContactComponent } from '../../shared/add-contact/add-contact.component';
import { CreateTasksComponent } from '../../shared/create-tasks/create-tasks.component';
import { GlobalFilterComponent } from '../../shared/global-filter/global-filter.component';
import { InCallComponent } from '../../shared/in-call/in-call.component';
import { LogCallComponent } from '../../shared/log-call/log-call.component';
import {
  classifyWebCallOutcomeError,
  createdDealIdFromResponse,
  initialWebCallOutcomeAttemptAt,
  nextWebCallOutcomeAttemptAt,
  PendingWebCallOutcome,
  remainingWebCallOutcomeSteps,
  WEB_CALL_OUTCOME_QUEUE_FALLBACK_DELAY_MS,
  WEB_CALL_OUTCOME_RETRY_OFFSETS_MS,
  WEB_CALL_OUTCOME_RETRY_WINDOW_MS,
  WebCallOutcomeFailureType,
  webCallOutcomeErrorText,
  webCallOutcomeExpiryTime,
  webCallOutcomeIsExpired
} from '../../shared/log-call/web-call-outcome-reconciliation';
import { LogMeetingOutcomeComponent } from '../../shared/log-meeting-outcome/log-meeting-outcome.component';
import { LogMeetingComponent } from '../../shared/log-meeting/log-meeting.component';
import { LogUpdateComponent } from '../../shared/log-update/log-update.component';
import { NotificationsComponent } from '../../shared/notifications/notifications.component';
import { TaskPreviewComponent } from '../../shared/previews/task-preview/task-preview.component';
import { SearchComponent } from '../../shared/search/search.component';
import { buildContactSearchVisibilityFilter, getDirectlyManagedTeamIds } from '../../shared/search/contact-search-visibility';
import { SidebarContainerComponent } from '../../shared/sidebar-container/sidebar-container.component';
import { UploadDoneService } from '../../shared/upload/upload-done-service';
import { SpeedDialFabPosition, SpeedDialFabComponent } from '../../speed-dial-fab/speed-dial-fab.component';
import { DataShareService } from './../../../services/data-share.service';
import { generateFavicon } from './../../../services/favicon/favicon-generator';
import { WebCallPlacementCoordinatorService } from './../../../services/web-call-placement-coordinator.service';
import { SignalService } from './../../../services/signal.service';
import { getDaysOver, shouldBlockForPayment } from 'app/shared/billing/payment-grace';
import { APIService, AccountMemberActivity, AccountMembership, AccountStatus, AccountType, Activity, ActivityListQueryType, ActivityType, AuthorizationLevel, CallDirection, ChatParticipant, CloudTelephonyAccount, Contact, ContactAssignmentStatus, CreateEngagementInput, CreateEntityActionDefinitionInput, CreateMissedOpportunitiesInput, CreateSubmittedFormValueInput, CustomPropertyDefinitions, Engagement, EngagementListQueryType, EngagementStatus, EngagementType, EntityActionDefinition, EntityType, LeadLifecycleStage, MentionUserMembership, MissedOpportunities, MissedOpportunitiesListQueryType, MissedOpportunityType, ModelEngagementFilterInput, ModelIDKeyConditionInput, ModelMentionUserMembershipByMentionedUserIdCompositeKeyConditionInput, ModelSortDirection, MutationIntegrationActionsBodyInput, ProductService, SearchableActivityFilterInput, SearchableActivitySortInput, SearchableActivitySortableFields, SearchableChatParticipantFilterInput, SearchableChatParticipantSortInput, SearchableChatParticipantSortableFields, SearchableContactFilterInput, SearchableContactSortInput, SearchableContactSortableFields, SearchableEngagementFilterInput, SearchableEngagementSortInput, SearchableEngagementSortableFields, SearchableEntityActionDefinitionFilterInput, SearchableEntityActionDefinitionSortInput, SearchableEntityActionDefinitionSortableFields, SearchableProductServiceFilterInput, SearchableSavedTableViewsFilterInput, SearchableSavedTableViewsSortInput, SearchableSavedTableViewsSortableFields, SearchableSortDirection, SearchableUploadedFileFilterInput, SearchableUploadedFileSortInput, SearchableUploadedFileSortableFields, Segment, Team, TeamMember, TeamRole, UpdateAccountMembershipAction, UpdateAccountMembershipInput, UpdateEngagementInput, UpdateMissedOpportunitiesInput, UpdateSubmittedFormValueInput, UpdateUserInput, UploadedFile, User, UserAuthorization, UserStatus, WabaAccount, WabaPhoneNumber, SearchableSavedChartViewsFilterInput, CloudTelephonyUser, DataExportOutput, ModelDataExportOutputExportsByUserCompositeKeyConditionInput, ModelDataExportOutputFilterInput, EntityList, ModelEntityListFilterInput } from './../../API.service.custom';
import { GraphqlSubscriptionManagerService, ManagedSubscriptionHandle } from 'services/graphql-subscription-manager.service';
import localforage from 'localforage';
import { isExpiredAggCacheRecord, staleRetentionMs } from '../../../globals/agg-metrics-cache';
import { CreateTemplateComponent } from 'app/shared/templates/create-template/create-template.component';
import { CreateFormComponent } from 'app/shared/account/create-form/create-form.component';
import { BulkUploadStepsComponent } from 'app/shared/contacts/bulk-upload-steps/bulk-upload-steps.component';
import { DefineDistributionComponent } from 'app/shared/define-distribution/define-distribution.component';
import { SharedInboxComponent } from 'app/shared/conversation/shared-inbox/shared-inbox.component';
import { TeamInboxComponent } from 'app/shared/conversation/team-inbox/team-inbox.component';
import { GlobalPreferenceService } from 'globals/GlobalPreferenceService';
import { CustomReuseStrategy } from 'globals/CustomReuseStrategy';
import { getLocalDateKey } from 'app/dashboard/dashboard-date.utils';
import { catchError, delay, retryWhen, tap } from 'rxjs/operators';
import { LeadDetailComponent } from 'app/shared/contacts/lead-detail/lead-detail.component';
import Auth from 'app/core/auth-shim'
import { AdHocReminderComponent } from 'app/shared/help/ad-hoc-reminder/ad-hoc-reminder.component';
import { FilteredContactsComponent } from 'app/shared/contacts/filtered-contacts/filtered-contacts.component';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { VideoCallsComponent } from 'app/shared/callings/video-calls/video-calls.component';
import { ChartGalleryComponent } from 'app/shared/report/chart-gallery/chart-gallery.component';
import { SubmittedFormService } from 'services/submitted-form.service';
import { AppHeaderComponent, AppSidebarComponent, AppSidebarNavComponent, AppSidebarFooterComponent, AppSidebarMinimizerComponent, AppAsideComponent } from '../../coreui-angular/index';
import { NgClass, SlicePipe, TitleCasePipe } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { BsDropdownDirective, BsDropdownMenuDirective, BsDropdownToggleDirective } from 'ngx-bootstrap/dropdown';
import { MatIcon } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';
import { MatTooltip } from '@angular/material/tooltip';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { ProfileImageComponent } from '../../shared/profile-image/profile-image.component';
import { MatChipListbox, MatChipOption, MatChipAvatar } from '@angular/material/chips';
import { NgSelectComponent, NgLabelTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatButton } from '@angular/material/button';
import { PerfectScrollbarDirective, PerfectScrollbarComponent } from '../../ngx-perfect-scrollbar/index';
import { isFeatureEnabled } from 'app/core/feature-flags';
import { WalletAlert, WalletBalanceService, currencySymbol } from 'app/wallet/wallet-balance.service';
import { AlertComponent } from 'ngx-bootstrap/alert';
import { TabsetComponent, TabDirective, TabHeadingDirective } from 'ngx-bootstrap/tabs';
import { FlexModule } from '@angular/flex-layout/flex';
import { QuickInboxComponent } from '../../shared/conversation/quick-inbox/quick-inbox.component';
import { ManualTranscriptionSnackComponent } from '../../shared/callings/manual-transcription/manual-transcription-snack.component';
import { FormatDatePipe } from '../../../services/format-date.pipe';
import { FormatDateTimePipe } from '../../../services/format-date-time.pipe';
import { FormatEnumPipe } from '../../../services/format-enum.pipe';
import { FormatDateRealTimePipe } from '../../../services/format-date-realtime.pipe';
import { UserClientfilterPipe } from '../../../services/user-client-filter.pipe';
import { AiAssistModule } from '../../ai-assist/ai-assist.module';
import { QuickActionsService } from '../../ai-assist/core/quick-actions.service';
import { BackgroundJobsWidgetComponent, BulkUploadSummary } from '../../shared/background-jobs-widget/background-jobs-widget.component';
import { AmplifyStorageService } from 'services/amplify-storage.service';
import { SalesmaxSupportAccountsService } from 'services/salesmax-support-accounts.service';
import { SupportIssuesAlertService } from 'app/salesmax-support/issues/support-issues-alert.service';
import { RouteAccessEnforcer } from 'app/core/access/route-access-enforcer.service';
import { canAccessNavRoute, canCustomizeWorkspace as canCustomizeWorkspaceForAccount } from 'app/core/access/route-access-policy';
import { UnifiedCommandPaletteComponent } from '../../ai-assist/navigate/unified-command-palette.component';
import { OnboardingChecklistService, OnboardingProgress } from '../../ai-assist/core/onboarding-checklist.service';
import { WorkflowPlayerService } from '../../ai-assist/guide/workflow-player.service';
import { AppHealthDiagnosticService, HealthIssue, UserHealthReport } from '../../shared/admin/app-install-status/app-health-diagnostic.service';
import {
  buildTrialRewardCallFilter,
  deriveTrialReward,
  REQUIRED_TRIAL_REPRESENTATIVES,
  REQUIRED_TRIAL_TRACKED_CALLS,
  TrialRewardProgress,
} from './trial-reward';

interface ContextualTab {
  label: string;
  route: string | any[]; // supports array syntax
  matchPattern: string;
  routeExtras?: {
    outlets?: { [key: string]: string };
    queryParams?: { [key: string]: any };
    fragment?: string;
  };
}

export interface TrialActivationMetrics {
  representativeCount: number;
  installedRepresentativeCount: number;
  readyRepresentativeCount: number;
  trackedCallCount: number;
  representatives: TrialRepresentativeReadiness[];
}

export type TrialRepresentativeMilestone = 'invited' | 'installed' | 'ready' | 'first-call';

export interface TrialRepresentativeReadiness {
  userId: string;
  name: string;
  registeredNumber: string | null;
  installed: boolean;
  ready: boolean;
  firstCall: boolean;
  lastCheckInLabel: string;
  nextAction: string;
  whatsappUrl: string | null;
  milestone: TrialRepresentativeMilestone;
  sourceOrder: number;
}

export interface TrialActivationStep {
  id: 'invite-reps' | 'install-app' | 'first-call';
  title: string;
  description: string;
  ctaLabel: string;
  icon: string;
  completed: boolean;
}

export type TrialCountdownUrgency = 'calm' | 'soon' | 'urgent';

export interface TrialCountdown {
  days: number;
  hours: number;
  totalHours: number;
  message: string;
  /** calm: 3+ days left, soon: 1–3 days, urgent: under a day. Drives colour only. */
  urgency: TrialCountdownUrgency;
}

function unwrapDynamoValue(value: any): any {
  if (value == null || typeof value !== 'object' || Array.isArray(value)) {
    return value;
  }

  const keys = Object.keys(value);
  if (keys.length === 1) {
    if ('S' in value) return value.S;
    if ('N' in value) return Number(value.N);
    if ('BOOL' in value) return value.BOOL;
    if ('NULL' in value) return null;
    if ('M' in value) return unwrapDynamoValue(value.M);
    if ('L' in value) return (value.L || []).map(item => unwrapDynamoValue(item));
  }

  return keys.reduce((result, key) => {
    result[key] = unwrapDynamoValue(value[key]);
    return result;
  }, {} as Record<string, any>);
}

function parseMemberReadOnlyInfo(member: AccountMembership): any {
  const rawValue = (member as any).prefReadOnlyInfoJson || (member as any).prefReadOnlyInfo;
  if (!rawValue) return null;

  try {
    const parsed = typeof rawValue === 'string' ? JSON.parse(rawValue) : rawValue;
    return unwrapDynamoValue(parsed);
  } catch {
    return null;
  }
}

const FIRST_CALL_BLOCKING_ISSUE_IDS = [
  'prefs-not-synced',
  'permission-call-log-denied',
  'permission-phone-state-denied',
  'save-call-log-off',
  'track-all-calls-off',
  'heartbeat-stale',
  'call-state-service-stopped',
  'pending-call-logs',
  'sync-error-active',
];

function firstName(name: string): string {
  return name.trim().split(/\s+/)[0] || 'your rep';
}

function firstSentence(value: string): string {
  return (value || '').trim().split('. ')[0].replace(/[.!?]+$/, '');
}

function lowerFirst(value: string): string {
  return value ? value.charAt(0).toLowerCase() + value.slice(1) : value;
}

function nextActionFromIssue(name: string, issue: HealthIssue): string {
  const repName = firstName(name);
  const fix = firstSentence(issue.fix || issue.title)
    .replace(/^Ask (?:the )?user to\s+/i, '')
    .replace(/^The user should\s+/i, '')
    .replace(/^User should\s+/i, '');
  return `Ask ${repName} to ${lowerFirst(fix)}.`;
}

export function buildTrialRepWhatsappUrl(
  registeredNumber: string | null | undefined,
  name: string,
  instruction: string,
): string | null {
  const rawNumber = String(registeredNumber || '').trim();
  const digits = rawNumber.replace(/\D/g, '');
  // wa.me requires an international number. Never guess a country code.
  if (!rawNumber.startsWith('+') || digits.length < 8 || digits.length > 15) return null;

  const repName = firstName(name);
  const cleanInstruction = instruction.replace(/[.!?]+$/, '');
  const message = `Hi ${repName}, please ${lowerFirst(cleanInstruction)} today. This is required so your work calls are tracked automatically in Salesmax. Let me know when it is done.`;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}

export function deriveTrialActivationMetrics(
  memberships: AccountMembership[] | null | undefined,
  healthReports: UserHealthReport[] = [],
  currentUserId?: string | null,
): TrialActivationMetrics {
  const representatives = (memberships || []).filter(member =>
    member?.userAccountStatus !== UserStatus.INACTIVE &&
    (member?.authorizationLevel === AuthorizationLevel.MEMBER ||
      member?.authorizationLevel === AuthorizationLevel.MANAGER)
  );

  const healthByUserId = new Map(healthReports.map(report => [report.member.userId, report]));
  const representativeRows = representatives.map((member, sourceOrder): TrialRepresentativeReadiness => {
    const prefInfo = parseMemberReadOnlyInfo(member);
    const report = healthByUserId.get(member.userId);
    const isActive = member.userAccountStatus === UserStatus.ACTIVE;
    const installed = report
      ? report.status !== 'not-installed'
      : !!((member.user as any)?.appVersion || prefInfo);
    const health = prefInfo?.supportDiagnostics?.health;
    const firstCall = !!(health?.lastCallDetectedAt || health?.lastCallLogSyncedAt || health?.lastCallStateEventAt);
    const lastHeartbeatAt = prefInfo?.supportDiagnostics?.lifecycle?.lastHeartbeatAt;
    const blocker = FIRST_CALL_BLOCKING_ISSUE_IDS
      .map(id => report?.issues.find(issue => issue.id === id))
      .find(Boolean);
    const name = String(member.user?.name || (member.user as any)?.registeredNumber || 'Sales rep');

    let nextAction: string;
    let whatsappInstruction: string;
    if (!isActive) {
      nextAction = `${firstName(name)} has not accepted the workspace invite yet.`;
      whatsappInstruction = 'accept the Salesmax workspace invite, install the app from the Play Store, and open it once';
    } else if (!installed) {
      nextAction = `${firstName(name)} has not installed the app yet. Send the setup instructions.`;
      whatsappInstruction = 'install Salesmax from the Play Store, sign in to our workspace, and open the app once';
    } else if (!lastHeartbeatAt) {
      nextAction = `Ask ${firstName(name)} to open Salesmax once so app setup can be verified.`;
      whatsappInstruction = 'open Salesmax once so the app setup can be verified';
    } else if (blocker) {
      nextAction = nextActionFromIssue(name, blocker);
      whatsappInstruction = nextAction.replace(new RegExp(`^Ask ${firstName(name)} to `), '');
    } else if (!firstCall) {
      nextAction = `Ask ${firstName(name)} to make a test call from Salesmax.`;
      whatsappInstruction = 'make a test call from Salesmax';
    } else {
      nextAction = 'First tracked call received.';
      whatsappInstruction = '';
    }

    const ready = firstCall || (!!report && isActive && installed && !!lastHeartbeatAt && !blocker);
    const milestone: TrialRepresentativeMilestone = firstCall
      ? 'first-call'
      : ready
        ? 'ready'
        : installed
          ? 'installed'
          : 'invited';
    const registeredNumber = (member.user as any)?.registeredNumber || null;

    return {
      userId: member.userId,
      name,
      registeredNumber,
      installed,
      ready,
      firstCall,
      lastCheckInLabel: report?.diagnostics?.lastHeartbeatLabel || (lastHeartbeatAt ? 'Recently' : 'Never'),
      nextAction,
      whatsappUrl: firstCall || member.userId === currentUserId
        ? null
        : buildTrialRepWhatsappUrl(registeredNumber, name, whatsappInstruction),
      milestone,
      sourceOrder,
    };
  });

  return {
    representativeCount: representativeRows.length,
    installedRepresentativeCount: representativeRows.filter(rep => rep.installed).length,
    readyRepresentativeCount: representativeRows.filter(rep => rep.ready).length,
    trackedCallCount: representativeRows.filter(rep => rep.firstCall).length,
    representatives: representativeRows,
  };
}

export function buildTrialCountdown(
  trialEndDate: string | null | undefined,
  now: number | Date = Date.now(),
): TrialCountdown | null {
  if (!trialEndDate) return null;

  const endTime = Date.parse(trialEndDate);
  const nowTime = now instanceof Date ? now.getTime() : now;
  if (!Number.isFinite(endTime) || !Number.isFinite(nowTime)) return null;

  const hourMs = 60 * 60 * 1000;
  const totalHours = Math.max(0, Math.ceil((endTime - nowTime) / hourMs));
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  const urgency: TrialCountdownUrgency = totalHours >= 72 ? 'calm' : totalHours >= 24 ? 'soon' : 'urgent';
  const message = urgency === 'calm'
    ? 'Use this time to get your reps calling and watch real team activity build up.'
    : urgency === 'soon'
      ? 'Complete the next step today and leave time to review real team activity.'
      : 'A focused setup now can still get your first tracked call into Salesmax today.';

  return { days, hours, totalHours, message, urgency };
}

const SAMPLE_DATA_SUPPORTED_ROUTES = new Set([
  '/home/dashboard',
  '/home/dashboard-new',
  '/leads/all-leads',
  '/leads/inactive-leads',
  '/activities/activities',
  '/activities/activities-feed',
  '/engagements/all-engagements',
  '/engagements/calls',
  '/engagements/video-calls',
  '/engagements/messages',
  '/engagements/visits',
  '/todo/to-do-kanban',
  '/todo/grid',
  '/metrics/performance',
  '/metrics/source-report',
  '/metrics/user-lead-report',
  '/metrics/custom-report',
  '/location/last-location',
  '/opportunities/opportunity-list',
  '/opportunities/opportunity-table',
  '/opportunities/payments',
  '/opportunities/payments/card',
  '/opportunities/payments/table',
  '/opportunities/quotes',
  '/conversations/inbox',
]);

export function isSampleDataSupportedRoute(url: string | null | undefined): boolean {
  const path = (url || '').split(/[?#]/, 1)[0].replace(/\/+$/, '') || '/';
  return SAMPLE_DATA_SUPPORTED_ROUTES.has(path);
}


export class DashboardGlobalFilter {
  level?: string;
  user?: AccountMembership[];
  team?: Team[];
  teamMember?: TeamMember[];
  period?: string;
}

export class MemberStatusData {
  userId: string;
  name: string;
  email: string;
  userProfilePic: string | null;
  role: string;
  lastActivityId: string | null;
  lastActivity: Activity | null;
  lastActivityTimeStamp?: number | null;
  lastActivityTime?: string | null;
  lastActivityType?: string | null;
  lastActivityBody?: string | null;
  lastCallLogged?: string | null;
  lastNoteAdded?: string | null;
  lastCommentAdded?: string | null;
  lastTaskCompleted?: string | null;
  lastTaskCreated?: string | null;
  lastVisitLogged?: string | null;
  lastContactAdded?: string | null;
  lastKnownLocation?: string | null;
  lastKnownLocationTime?: string | null;
  activeVisitEngagementId?: string | null;
  activeVisitContactId?: string | null;
  activeVisitContactName?: string | null;
  activeVisitStartedAt?: string | null;
  inVideoCall?: boolean | null;
  activeVideoCallEngagementId?: string | null;
  lastVideoCallEventAt?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export class KeyTrendData {
  metricName: string;
  value: number;
  displayValue: string;
  displayValueBenchmark?: string;
  previousValue: number;
  change: number;
  iconClass: string;
  countUpFromValue: number;
  period: string;
}

declare var M: any;

// const GET_AUTH = gql`
//     query GetAuthorizationByUser($userId: ID!) {
//       getAuthorizationByUser(userId: $userId) {
//         items {
//         id
//         }
//     }
//   }
//   `;

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./../../app.component.scss', './default-layout.component.scss'],
  imports: [AppHeaderComponent, NgClass, ExtendedModule, BsDropdownDirective, RouterLink, MatIcon, BsDropdownMenuDirective, MatBadge, MatTooltip, BsDropdownToggleDirective, NgScrollbarModule, InfiniteScrollDirective, ProfileImageComponent, MatChipListbox, MatChipOption, MatChipAvatar, RouterLinkActive, MatButtonModule, MatMenuTrigger, MatMenu, NgSelectComponent, FormsModule, NgxIntlTelInputModule, NgLabelTemplateDirective, NgOptionTemplateDirective, MatMenuItem, MatButton, AppSidebarComponent, AppSidebarNavComponent, PerfectScrollbarDirective, AppSidebarFooterComponent, AppSidebarMinimizerComponent, AlertComponent, RouterOutlet, AppAsideComponent, TabsetComponent, TabDirective, TabHeadingDirective, PerfectScrollbarComponent, FlexModule, SpeedDialFabComponent, QuickInboxComponent, ManualTranscriptionSnackComponent, SlicePipe, TitleCasePipe, FormatDatePipe, FormatDateTimePipe, FormatEnumPipe, FormatDateRealTimePipe, UserClientfilterPipe, AiAssistModule, BackgroundJobsWidgetComponent]
})
export class DefaultLayoutComponent implements OnDestroy, AfterViewInit {
  @ViewChild(SidebarContainerComponent, { static: true }) sidebarContainer: SidebarContainerComponent;
  @ViewChild('workspaceIndicator') workspaceIndicator?: ElementRef<HTMLElement>;
  @ViewChild('workspaceConfirmationCard') workspaceConfirmationCard?: ElementRef<HTMLElement>;
  @ViewChild('salesmaxHeader') salesmaxHeader: ElementRef;
  @ViewChild('salesmaxHeader1') salesmaxHeader1: ElementRef;
  @ViewChild('salesmaxHeader2') salesmaxHeader2: ElementRef;
  @ViewChild('salesmaxHeader4') salesmaxHeader4: ElementRef;
  @ViewChild('salesmaxHeader5') salesmaxHeader5: ElementRef;
  @ViewChild('salesmaxHeader6') salesmaxHeader6: ElementRef;
  @ViewChild('whatsappDropdown') whatsappDropdown: BsDropdownDirective;
  @ViewChild(UnifiedCommandPaletteComponent) unifiedPalette?: UnifiedCommandPaletteComponent;

  private viewInitialized = false;
  private pendingWorkspaceConfirmation?: () => void;
  private workspaceConfirmationMergeTimer?: number;
  private workspaceConfirmationHideTimer?: number;
  private workspaceConfirmationHighlightTimer?: number;
  private workspaceConfirmationFrame?: number;
  private readonly workspaceConfirmationPauseMs = 1100;
  private readonly workspaceConfirmationMergeMs = 440;
  private readonly trialDashboardOrientationStartedKeys = new Set<string>();
  private trialDashboardOrientationTimer?: number;
  private cloudCallingSessionKey: string | null = null;
  private readonly customPropertyDefinitionsMaxRetries = 2;
  private readonly customPropertyDefinitionsRetryCounts = new Map<string, number>();
  private readonly customPropertyDefinitionsRetryTimers = new Map<string, number>();
  private readonly customPropertyDefinitionsInFlight = new Map<string, { epoch: number; promise: Promise<void> }>();

  workspaceConfirmationVisible = false;
  workspaceConfirmationMerging = false;
  workspaceIndicatorHighlighted = false;
  workspaceConfirmationLabel = 'Current workspace';
  workspaceConfirmationAccountName = '';
  workspaceConfirmationTranslateX = '0px';
  workspaceConfirmationTranslateY = '0px';
  workspaceConfirmationScale = '0.22';

  width4 = null;
  width5 = null;
  width6 = null;

  configSuccess: MatSnackBarConfig = {
    panelClass: 'style-success',
    horizontalPosition: 'left',
    verticalPosition: 'bottom'
  };

  configEntityAction: MatSnackBarConfig = {
    panelClass: 'style-success',
    horizontalPosition: 'right',
    verticalPosition: 'bottom'
  };

  configNewLead: MatSnackBarConfig = {
    panelClass: 'style-success',
    horizontalPosition: 'right',
    verticalPosition: 'bottom'
  };

  configUpcomingTask: MatSnackBarConfig = {
    panelClass: 'style-success',
    horizontalPosition: 'left',
    verticalPosition: 'bottom'
  };

  configMissedCall: MatSnackBarConfig = {
    panelClass: 'style-warning',
    horizontalPosition: 'left',
    verticalPosition: 'bottom'
  };

  private currentTime: number = null;
  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement;

  hideWelcomeMessage: boolean = false;

  currentGlobalFilter: DashboardGlobalFilter = {}

  userNameSearchValue = null;

  private userDetails_: BehaviorSubject<any> = new BehaviorSubject(undefined);
  public userDetails = this.userDetails_.asObservable();

  private busy_ = new BehaviorSubject(false);
  public busy = this.busy_.asObservable();

  private errorMessage_ = new BehaviorSubject('');
  public errorMessage = this.errorMessage_.asObservable();

  /**
   * Terminal recovery state for the account bootstrap. The dashboard already
   * has its own loading skeleton, but it cannot recover when no active account
   * is ever published. Keep this state in the shell so Retry and Sign Out stay
   * available even when account-scoped UI cannot be rendered.
   */
  accountBootstrapFailed = false;
  accountBootstrapRetrying = false;
  accountBootstrapError = '';
  private accountBootstrapAttempt = 0;
  private readonly accountBootstrapTimeoutMs = 15000;

  private userAccountMemberships: AccountMembership[] = [];
  private activeAccountMemberships: AccountMembership[] = [];
  accountsInNeedOfAcceptance: AccountMembership[] = [];
  accountsInNeedOfNumberChangeApproval: AccountMembership[] = [];
  dropdownToChooseAccount: AccountMembership[] = [];
  private fetchedUserAuthorization: UserAuthorization = null;
  private fetchedTeams: Team[] = [];
  private fetchedUsers: AccountMembership[] = [];
  private fetchedActiveUsers: AccountMembership[] = [];
  private fetchedTeamMemberships: TeamMember[] = [];
  private directTeamsAsTL: TeamMember[] = [];
  private allDirectTeams: TeamMember[] = [];
  private directTeamsAsReportee: TeamMember[] = [];
  private directReportees: TeamMember[] = [];
  private indirectTeamsAsLead: Team[] = [];
  private inDirectReportees: TeamMember[] = [];
  private unVerifiedEmailAccounts = null;
  private registeredUser: User = null;

  integrationStatus: Map<string, any[]>;
  integrationStatusConnected: Map<string, any[]>;

  backgroundJobs: EntityActionDefinition[] = [];
  uploadSummaries: { [jobId: string]: BulkUploadSummary } = {};

  isOnline: boolean = true;
  reconnectReloadRequired: boolean = false;


  activeAccount: AccountMembership = null;
  private membershipToBeUpdated = null;

  private userId = null;

  recentActivities: Activity[] = [];
  recentMentions: MentionUserMembership[] = [];
  myTasksOverdue: Engagement[] = [];
  myTasksDueToday: Engagement[] = [];
  notifications: Activity[] = [];

  newNotificationCount = 0;
  newMentionCount = 0;
  newTaskCount = 0;
  newActivityCount = 0;
  newPendingAssignmentCount = 0;


  sub_memberStatus_update: ManagedSubscriptionHandle | null;
  sub_web_calls: ManagedSubscriptionHandle | null;
  sub_memberStatus_update_user: ManagedSubscriptionHandle | null;
  sub_activity_create;
  sub_engagement_create;
  sub_engagement_update;
  sub_account_update;
  sub_account_update_by_user;
  sub_entityActionDefinition_create: ManagedSubscriptionHandle | null;
  sub_entityActionDefinition_update: ManagedSubscriptionHandle | null;
  sub_activity_contact_assigned: ManagedSubscriptionHandle | null;
  sub_chatParticipant_update: ManagedSubscriptionHandle | null;
  currentTimeSubscription;
  currentTimeInterval: any;
  webCallIdSubscription;

  sub_cloud_calls_create: ManagedSubscriptionHandle | null;
  sub_cloud_calls_update: ManagedSubscriptionHandle | null;
  sub_gmeet_update: ManagedSubscriptionHandle | null;

  sub_user_account_update_create: ManagedSubscriptionHandle | null;

  private readonly cloudEventCacheTtlMs = 60 * 60 * 1000;
  private readonly cloudEventCacheMaxEntries = 200;
  private recentCloudEvents = new Map<string, number>();

  // Cache tracking for getAllUsersInAccount - persisted via localforage
  private readonly usersCacheTtlMs = 4 * 60 * 60 * 1000; // 4-hour failsafe TTL
  private readonly USERS_CACHE_TS_PREFIX = 'usersFetchedAt_v2_';
  private readonly USERS_CACHE_DATA_PREFIX = 'usersData_v2_';
  private lastLivePreviewOpenedAt = 0;
  private readonly previewDebounceMs = 5000;

  currentSnackBar: MatSnackBarRef<InCallNotification> = null;
  entityActionSnackBar: MatSnackBarRef<EntityActionNotification> = null;
  newLeadSnackBar: MatSnackBarRef<NewLeadNotification> = null;
  upcomingTaskSnackBar: MatSnackBarRef<UpcomingTaskNotification> = null;
  missedCallSnackBar: MatSnackBarRef<MissedCallNotification> = null;

  /** Minimum time between missed-call checks/banner appearances, persisted across
      foreground/background cycles and app restarts. */
  private readonly MISSED_CALL_THROTTLE_MS = 60 * 60 * 1000;
  private readonly MISSED_CALL_GATE_PREFIX = 'missed_call_banner_last_shown_';
  private readonly MISSED_CALL_CHECK_PREFIX = 'missed_call_banner_last_checked_';
  private get missedCallGateKey(): string {
    return `${this.MISSED_CALL_GATE_PREFIX}${this.activeAccount?.accountId || 'unknown'}_${this.activeAccount?.userId || 'unknown'}`;
  }
  private get missedCallCheckKey(): string {
    return `${this.MISSED_CALL_CHECK_PREFIX}${this.activeAccount?.accountId || 'unknown'}_${this.activeAccount?.userId || 'unknown'}`;
  }
  private dismissedUpcomingTaskIds = new Set<string>();

  userMap: Dictionary<User> = {}


  emailToVerify = new UntypedFormControl();

  modalRef: BsModalRef;

  auths: any;

  profilePicLoading = true;
  profilePic$: Observable<string>;

  currentRoute: string;
  breadcrumbText: string;
  helpPrompt = null;
  previousRoute: string;

  previousRouteSubscription;
  totalWhatsappNewCountSubscription;
  totalTeamChatNewCountSubscription;
  lastViewedChatNotificationSubscription;
  usersRefreshSubscription;

  applyCustomCssClass = false;
  applyCustomCssClassXscroll = false;
  noHeaderMode = false;
  onDashboard = false;
  onGettingStarted = false;

  showHealthBanner = false;
  healthBannerIssueCount = 0;
  healthBannerCountdown = 15;
  private healthBannerTimer: any = null;
  private readonly HEALTH_BANNER_AUTO_HIDE_SECONDS = 15;
  private readonly HEALTH_KEY_PREFIX = 'app_health_';

  freshLeads: Contact[] = [];
  unassignedTasks: Engagement[] = [];
  unassignedLeads: Contact[] = [];

  daysRemainingInTrial: number = null;
  daysOverPaidFor: number = null;
  daysOverPaidForBasedOnDue: number = null;

  // Onboarding progress for trial mode FAB
  isTrialMode = false;
  onboardingProgress: OnboardingProgress | null = null;
  trialActivationMetrics: TrialActivationMetrics = {
    representativeCount: 0,
    installedRepresentativeCount: 0,
    readyRepresentativeCount: 0,
    trackedCallCount: 0,
    representatives: [],
  };
  trialActivationReady = false;
  trialActivationCardMinimized = false;
  trialAppStatusRefreshing = false;
  trialCountdown: TrialCountdown | null = null;
  trialReward: TrialRewardProgress = deriveTrialReward(this.trialActivationMetrics, 0);
  trialRewardCallCountReady = false;
  trialRewardCallCountRefreshing = false;
  readonly requiredTrialRepresentatives = REQUIRED_TRIAL_REPRESENTATIVES;
  readonly requiredTrialTrackedCalls = REQUIRED_TRIAL_TRACKED_CALLS;
  private onboardingProgressSubscribed = false;
  private trialCountdownTimer?: number;
  private readonly trialAppStatusRefreshedSessionKeys = new Set<string>();
  private readonly trialRewardCallCountCache = new Map<string, { count: number; fetchedAt: number }>();
  private readonly trialRewardCallCountLastAttemptAt = new Map<string, number>();
  private readonly trialRewardUnlockedSessionKeys = new Set<string>();
  private readonly trialRewardUnlockToastSessionKeys = new Set<string>();
  private readonly trialRewardCallCountTtlMs = 10 * 60 * 1000;
  private trialRewardCallCountInFlightKey: string | null = null;
  sampleDataModeEnabled = false;
  walletFeatureEnabled = false;
  walletBalance = '--';
  walletCurrencySymbol = String.fromCodePoint(8377);
  walletRefreshing = false;
  walletBalanceError = false;

  get isCurrentRouteSampleDataSupported(): boolean {
    return isSampleDataSupportedRoute(this.currentRoute || this.router.url);
  }

  inCallToast = null;

  callToastIsShowing: boolean = false;
  hideFab: boolean = false;
  meetMode: boolean = false;
  lastInCallUpdatedAtDate

  accountMembershipUpdateInitiated: Boolean = false

  fetchedCurrentMemberStatus: AccountMemberActivity[] = [];
  allMemberStatusData: MemberStatusData[] = [];
  allUsers: AccountMembership[] | TeamMember[] = [];

  totalWhatsappUnreadCount = 0;
  totalWhatsappNewCount = 0;
  totalTeamChatNewCount = 0;
  lastChatMessageToShow: ChatParticipant = null;
  internalChatParticipants: ChatParticipant[] = [];
  externalChatParticipants: ChatParticipant[] = [];
  lastViewedChatNotification = null;

  // Support chats: customer accounts this SalesMax employee owns. Used to gate the
  // team-chat chime so it only sounds for support pings on the user's own accounts
  // (the unread badge still counts every support chat). null = not loaded yet.
  ownedSupportAccountIds: Set<string> | null = null;

  // Debounce rapid-fire WebSocket events for the same channel
  private lastNotifiedChannelId: string = null;
  private lastNotifiedAt: number = 0;

  lastQuickInboxDismissedAt: string = null;
  private readonly chatRefreshDelayMs = 3000;
  private externalChatRefreshTimer: number | null = null;
  private internalChatRefreshTimer: number | null = null;

  isVisible: boolean = true;

  fetchedChats: ChatParticipant[] = [];

  selectedTeamMembers: TeamMember[] = [];
  selectedTeamMember: TeamMember[] = [];
  selectedTeam: Team[] = [];
  selectedUser: AccountMembership[] = [];


  connectedWabaAccounts: WabaAccount[] = [];
  wabaNumbers: WabaPhoneNumber[] = [];

  allPeriods = allPeriods

  selectedPeriod = "DAY"
  selectedPeriodText = "Today"

  webCallId: WebCall = null;
  private readonly pendingWebCallLogPrefix = 'pending_web_call_log_';
  private readonly deadWebCallLogPrefix = 'dead_web_call_log_';
  private readonly deadWebCallLogRetentionMs = 30 * 24 * 60 * 60 * 1000;
  private replayingPendingWebCallLogs = false;
  private pendingWebCallReplayTimer: number | null = null;
  private pendingWebCallReplayDueAt: number | null = null;

  private visibilityChangeSubscription: Subscription;
  speedDialFabButtons = null;
  cloudTelephonyAccount: CloudTelephonyAccount[] = [];
  cloudTelephonyUser: CloudTelephonyUser[] = [];
  liveVideoCall = 0;

  memberStatusNeedsToBeRefreshed = false;
  // Set when a visibility return skips the member-status refetch because no view
  // consumes the table. Consumed (as a forced refresh) the next time a member-status
  // view becomes visible, so the route throttle can't suppress that catch-up fetch.
  private memberStatusVisibilityRefreshPending = false;
  private lastMemberStatusFetchedAt = 0;
  private readonly MEMBER_STATUS_ROUTE_REFRESH_THROTTLE_MS = 60 * 1000;
  private localforageCleanupInProgress = false;
  private lastLocalforageCleanupAt = 0;
  private readonly LOCALFORAGE_CLEANUP_INTERVAL_MS = 6 * 60 * 60 * 1000;

  speedDialFabButtonsNonAdmin = [
    {
      component: AdHocReminderComponent,
      icon: 'circle_notifications',
      tooltip: 'Ad Hoc Reminders',
      text: 'Remind Me!!',
      rootRoute: '/home',
      subRoutes: ['remindMe']
    },
    {
      component: SupportComponent,
      icon: 'help',
      tooltip: 'Get Assistance',
      text: 'Get Assistance',
      rootRoute: '/home',
      subRoutes: ['support']
    },
    {
      component: AddContactComponent,
      icon: 'person',
      tooltip: 'Add Single Lead',
      text: 'Add Single Lead',
      rootRoute: '/leads',
      subRoutes: ['add-contact']
    },
    {
      component: AddCompanyComponent,
      icon: 'business',
      tooltip: 'Add Business',
      text: 'Add Business',
      rootRoute: '/companies',
      subRoutes: ['add-company']
    },
    {
      component: LogCallComponent,
      icon: 'phone',
      tooltip: 'Log Call',
      text: 'Log Call',
      rootRoute: '',
      subRoutes: []
    },
    {
      component: LogMeetingComponent,
      icon: 'people',
      tooltip: 'Log Meeting',
      text: 'Log Meeting',
      rootRoute: '/meetings',
      subRoutes: ['log-meeting']
    },
    {
      component: LogUpdateComponent,
      icon: 'edit',
      tooltip: 'Add Note',
      text: 'Add Note',
      rootRoute: '',
      subRoutes: []
    },
    {
      component: UploadComponent,
      icon: 'cloud_upload',
      tooltip: 'Add Document',
      text: 'Add Document',
      rootRoute: '',
      subRoutes: []
    }
  ];

  speedDialFabButtonsAdmin = [
    {
      component: AdHocReminderComponent,
      icon: 'circle_notifications',
      tooltip: 'Ad Hoc Reminders',
      text: 'Remind Me!!',
      rootRoute: '/home',
      subRoutes: ['remindMe']
    },
    {
      component: AdminActionsComponent,
      icon: 'help',
      tooltip: 'Get Support',
      text: 'Get Support',
      rootRoute: '/home',
      subRoutes: ['support']
    },
    {
      component: AddContactComponent,
      icon: 'person',
      tooltip: 'Add Single Lead',
      text: 'Add Single Lead',
      rootRoute: '/leads',
      subRoutes: ['add-contact']
    },
    {
      component: BulkUploadStepsComponent,
      icon: 'upload_file',
      tooltip: 'Bulk Upload Leads',
      text: 'Bulk Upload Leads',
      rootRoute: '/leads',
      subRoutes: ['add-contact']
    },
    {
      component: DefineDistributionComponent,
      icon: 'alt_route',
      tooltip: 'Define Distribution',
      text: 'Define Distribution',
      rootRoute: '/leads',
      subRoutes: ['add-contact']
    },
    {
      component: AddEmployeeBulkComponent,
      icon: 'group_add',
      tooltip: 'Invite Employees',
      text: 'Invite Employees',
      rootRoute: '/companies',
      subRoutes: ['add-company']
    },
    {
      icon: 'people',
      tooltip: 'Manage Users & Teams',
      text: 'Manage Users & Teams',
      rootRoute: '/companies',
      subRoutes: ['add-company']
    },
    {
      component: CreateTemplateComponent,
      icon: 'message',
      tooltip: 'Create Templates',
      text: 'Create Templates',
      rootRoute: '',
      subRoutes: []
    },
    {
      component: CreateFormComponent,
      icon: 'list_alt',
      tooltip: 'Create Form',
      text: 'Create Form',
      rootRoute: '',
      subRoutes: []
    },
    {
      component: UploadComponent,
      icon: 'cloud_upload',
      tooltip: 'Add Document',
      text: 'Add Document',
      rootRoute: '',
      subRoutes: []
    }
  ];

  SpeedDialFabPosition = SpeedDialFabPosition;
  speedDialFabColumnDirection = 'column';
  speedDialFabPosition = SpeedDialFabPosition.Bottom;
  speedDialFabPositionChat = SpeedDialFabPosition.Bottom2;
  speedDialFabPositionClassName = 'speed-dial-container-bottom';
  hideAiAssistFabOnGridScroll = false;

  isDemoEnabledAccount = false;
  demoModeEnabled = false;

  isAsideOpen = false;
  activeAsideTab: string = null;
  private observer: MutationObserver;

  currentMainSection: string = '';
  selectedContextTab: string = "Default"
  contextualOptions: ContextualTab[] = [];


  mainSections = [
    {
      route: '/home/dashboard',
      label: 'Dashboards',
      icon: 'dashboard',
      sectionKey: 'dashboard'
    },
    {
      route: '/leads/all-leads',
      label: 'Leads',
      icon: 'person_search',
      sectionKey: 'leads'
    },
    {
      route: '/opportunities',
      label: 'Opportunities',
      icon: 'attach_money',
      sectionKey: 'opportunities'
    },
    {
      route: '/todo',
      label: 'To-dos',
      icon: 'check_circle',
      sectionKey: 'todo'
    },
    {
      route: '/engagements',
      label: 'Engagements',
      icon: 'timeline',
      sectionKey: 'engagements'
    },
    {
      route: '/conversations/inbox',
      label: 'Conversations',
      icon: 'chat',
      sectionKey: 'conversations'
    },
    {
      label: 'More',
      icon: 'more_horiz',
      sectionKey: 'more',
      isMore: true
    }
  ];

  contextualMap: Record<string, ContextualTab[]> = {
    dashboard: [
      { label: 'Default', route: '/home/dashboard', matchPattern: '/home/dashboard' },
      { label: 'Activity Metrics', route: '/metrics/performance', matchPattern: '/metrics/performance' },
      { label: 'Source Reports', route: '/metrics/source-report', matchPattern: '/metrics/source-report' },
      { label: 'User Leads', route: '/metrics/user-lead-report', matchPattern: '/metrics/user-lead-report' },
      { label: 'Attendance', route: '/metrics/attendance', matchPattern: '/metrics/attendance' },
      { label: 'Location', route: '/location/last-location', matchPattern: '/location/last-location' },
      { label: 'Custom', route: '/metrics/custom-report', matchPattern: '/metrics/custom-report' }
    ],
    leads: [
      { label: 'Active Leads', route: '/leads/all-leads', matchPattern: '/leads/all-leads' },
      { label: 'Worked Leads', route: '/leads/inactive-leads', matchPattern: '/leads/inactive-leads' },
      { label: 'Businesses', route: '/leads/businesses', matchPattern: '/leads/businesses' },
      { label: 'Documents', route: '/leads/documents', matchPattern: '/leads/documents' },
      { label: 'Segments/Lists', route: '/leads/lists', matchPattern: '/leads/lists' },
      { label: 'Uploads', route: '/leads/bulk-add-leads', matchPattern: '/leads/bulk-add-leads' },
      { label: 'Distributions', route: '/leads/distributions', matchPattern: '/leads/distributions' },
    ],
    opportunities: [
      { label: 'Deals', route: '/opportunities/opportunity-list', matchPattern: '/opportunities/opportunity-list' },
      { label: 'Deals Tabular', route: '/opportunities/opportunity-table', matchPattern: '/opportunities/opportunity-table' },
      { label: 'Payments', route: '/opportunities/payments/card', matchPattern: '/opportunities/payments/card' },
      { label: 'Payments Tabular', route: '/opportunities/payments/table', matchPattern: '/opportunities/payments/table' },
      { label: 'Quotes', route: '/opportunities/quotes', matchPattern: '/opportunities/quotes' }
    ],
    todo: [
      { label: 'To Do - Kanban', route: '/todo/to-do-kanban', matchPattern: '/todo/to-do-kanban' },
      { label: 'To Do - Table', route: '/todo/grid', matchPattern: '/todo/grid' }
    ],
    engagements: [
      { label: 'All Engagements', route: '/engagements/all-engagements', matchPattern: '/engagements/all-engagements' },
      { label: 'Calls', route: '/engagements/calls', matchPattern: '/engagements/calls' },
      { label: 'Video Calls', route: '/engagements/video-calls', matchPattern: '/engagements/video-calls' },
      { label: 'Messages', route: '/engagements/messages', matchPattern: '/engagements/messages' },
      { label: 'Visits', route: '/engagements/visits', matchPattern: '/engagements/visits' },
      { label: 'All Activities', route: '/activities/activities-feed', matchPattern: '/activities/activities-feed' },
      { label: 'Activities Table View', route: '/activities/activities', matchPattern: '/activities/activities' }
    ],
    conversations: [
      { label: 'Lead Inbox', route: '/conversations/inbox', matchPattern: '/conversations/inbox' },
      { label: 'Team Inbox', route: '/conversations/team-inbox', matchPattern: '/conversations/team-inbox' },
      { label: 'Broadcasts', route: '/conversations/broadcast', matchPattern: '/conversations/broadcast' },
      { label: 'Auto Messaging', route: '/conversations/reply', matchPattern: '/conversations/reply' },
      { label: 'AI Chatbots', route: '/conversations/chatbot', matchPattern: '/conversations/chatbot' },
      { label: 'Tickets', route: '/conversations/tickets', matchPattern: '/conversations/tickets' },
      { label: 'Stats', route: '/conversations/stats', matchPattern: '/conversations/stats' }
    ],
    more: [
      { label: 'Products & Inventory', route: '/products', matchPattern: '/products|/inventory' },
      { label: 'Data Exports', route: '/export/exports', matchPattern: '/export/exports' },
      { label: 'Email Leads', route: '/leads/mailbox', matchPattern: '/leads/mailbox' },
    ],
    support: [
      { label: 'Accounts', route: '/salesmax-support/accounts', matchPattern: '/salesmax-support/accounts' },
      { label: 'Issues', route: '/salesmax-support/issues', matchPattern: '/salesmax-support/issues' },
      { label: 'Demo Assist', route: '/salesmax-support/demo-assist', matchPattern: '/salesmax-support/demo-assist' },
      { label: 'Demo Live', route: '/salesmax-support/demo-live', matchPattern: '/salesmax-support/demo-live' },
    ],
    work: [
      { label: 'Floor', route: '/work/floor', matchPattern: '/work/floor' },
      { label: 'Definitions', route: '/work/definitions', matchPattern: '/work/definitions' },
    ]
  };

  contextualMapOriginal: Record<string, ContextualTab[]> = {
    dashboard: [
      { label: 'Default', route: '/home/dashboard', matchPattern: '/home/dashboard' },
      {
        label: 'Activity Metrics', route: '/metrics/performance', matchPattern: '/metrics/performance'
      },
      { label: 'Source Reports', route: '/metrics/source-report', matchPattern: '/metrics/source-report' },
      { label: 'User Leads', route: '/metrics/user-lead-report', matchPattern: '/metrics/user-lead-report' },
      { label: 'Attendance', route: '/metrics/attendance', matchPattern: '/metrics/attendance' },
      { label: 'Location', route: '/location/last-location', matchPattern: '/location/last-location' },
      { label: 'Custom', route: '/metrics/custom-report', matchPattern: '/metrics/custom-report' }
    ],
    leads: [
      { label: 'Active Leads', route: '/leads/all-leads', matchPattern: '/leads/all-leads' },
      { label: 'Worked Leads', route: '/leads/inactive-leads', matchPattern: '/leads/inactive-leads' },
      { label: 'Businesses', route: '/leads/businesses', matchPattern: '/leads/businesses' },
      { label: 'Documents', route: '/leads/documents', matchPattern: '/leads/documents' },
      { label: 'Segments/Lists', route: '/leads/lists', matchPattern: '/leads/lists' },
      { label: 'Uploads', route: '/leads/bulk-add-leads', matchPattern: '/leads/bulk-add-leads' },
      { label: 'Distributions', route: '/leads/distributions', matchPattern: '/leads/distributions' },
    ],
    opportunities: [
      { label: 'Deals', route: '/opportunities/opportunity-list', matchPattern: '/opportunities/opportunity-list' },
      { label: 'Deals Tabular', route: '/opportunities/opportunity-table', matchPattern: '/opportunities/opportunity-table' },
      { label: 'Payments', route: '/opportunities/payments/card', matchPattern: '/opportunities/payments/card' },
      { label: 'Payments Tabular', route: '/opportunities/payments/table', matchPattern: '/opportunities/payments/table' },
      { label: 'Quotes', route: '/opportunities/quotes', matchPattern: '/opportunities/quotes' }
    ],
    todo: [
      { label: 'To Do - Kanban', route: '/todo/to-do-kanban', matchPattern: '/todo/to-do-kanban' },
      { label: 'To Do - Table', route: '/todo/grid', matchPattern: '/todo/grid' }
    ],
    engagements: [
      { label: 'All Engagements', route: '/engagements/all-engagements', matchPattern: '/engagements/all-engagements' },
      { label: 'Calls', route: '/engagements/calls', matchPattern: '/engagements/calls' },
      { label: 'Video Calls', route: '/engagements/video-calls', matchPattern: '/engagements/video-calls' },
      { label: 'Messages', route: '/engagements/messages', matchPattern: '/engagements/messages' },
      { label: 'Visits', route: '/engagements/visits', matchPattern: '/engagements/visits' },
      { label: 'All Activities', route: '/activities/activities-feed', matchPattern: '/activities/activities-feed' },
      { label: 'Activities Table View', route: '/activities/activities', matchPattern: '/activities/activities' }
    ],
    conversations: [
      { label: 'Lead Inbox', route: '/conversations/inbox', matchPattern: '/conversations/inbox' },
      { label: 'Team Inbox', route: '/conversations/team-inbox', matchPattern: '/conversations/team-inbox' },
      { label: 'Broadcasts', route: '/conversations/broadcast', matchPattern: '/conversations/broadcast' },
      { label: 'Auto Messaging', route: '/conversations/reply', matchPattern: '/conversations/reply' },
      { label: 'AI Chatbots', route: '/conversations/chatbot', matchPattern: '/conversations/chatbot' },
      { label: 'Tickets', route: '/conversations/tickets', matchPattern: '/conversations/tickets' },
      { label: 'Stats', route: '/conversations/stats', matchPattern: '/conversations/stats' }
    ],
    more: [
      { label: 'Products & Inventory', route: '/products', matchPattern: '/products|/inventory' },
      { label: 'Data Exports', route: '/export/exports', matchPattern: '/export/exports' },
      { label: 'Email Leads', route: '/leads/mailbox', matchPattern: '/leads/mailbox' },
    ],
    support: [
      { label: 'Accounts', route: '/salesmax-support/accounts', matchPattern: '/salesmax-support/accounts' },
      { label: 'Issues', route: '/salesmax-support/issues', matchPattern: '/salesmax-support/issues' },
      { label: 'Demo Assist', route: '/salesmax-support/demo-assist', matchPattern: '/salesmax-support/demo-assist' },
      { label: 'Demo Live', route: '/salesmax-support/demo-live', matchPattern: '/salesmax-support/demo-live' },
    ],
    work: [
      { label: 'Floor', route: '/work/floor', matchPattern: '/work/floor' },
      { label: 'Definitions', route: '/work/definitions', matchPattern: '/work/definitions' },
    ]
  };



  hoveredDropdownIndex: number | null = null;


  onSpeedDialFabClicked(btn: { component: any, icon: string, tooltip: string, rootRoute: string, subRoutes: [] }) {
    if (btn.component) {
      if (btn.tooltip == 'Get Assistance' || btn.tooltip == 'Create Form' || btn.tooltip == 'Create Templates' || btn.tooltip == 'Define Distribution' || btn.tooltip == 'Bulk Upload Leads' || btn.tooltip == 'Get Support') {
        this.dialogService.open(btn.component, {}, 1);
      }
      else if (btn.tooltip == 'Add Single Lead') {
        this.dialogService.open(btn.component, {}, 0, false);
      }
      else if (btn.tooltip == 'Ad Hoc Reminders') {
        this.dialogService.open(btn.component, {}, 0, false);
      }
      else {
        this.dialogService.open(btn.component, {});
      }
    }
    else {
      if (btn.tooltip == 'View Reports') {
        this.router.navigate(['/metrics/performance']);
      }
      else if (btn.tooltip == 'Manage Users & Teams') {
        this.router.navigate(['/admin/users']);
      }
    }
  }

  openAdHocTask() {
    this.dialogService.open(AdHocReminderComponent, {
      data: {}
    });
  }


  onAddContact() {
    this.dialogService.open(AddContactComponent, {}, 0, false);
  }

  private alertSound: HTMLAudioElement;
  private alertSoundTeamChat: HTMLAudioElement;
  playButton: HTMLButtonElement;
  playButtonTeamChat: HTMLButtonElement;
  newlyAssignedLeads: Activity[] = [];
  newLeadAssignedAfter: string = null;
  private accountSwitchInProgress = false;
  private destroy$ = new Subject<void>();
  private loadedSmartViewSessionKeys = new Set<string>();
  private accountRequestEpoch = 0;
  private componentDestroyed = false;


  constructor(private router: Router, private activatedRoute: ActivatedRoute, private api: APIService,
    private auth: AuthService,
    private formBuilder: UntypedFormBuilder,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private clipboard: Clipboard,
    private dialogService: DialogService,
    private dataService: DataShareService,
    private os: SignalService,
    private data: UploadDoneService,
    public loaderService: LoaderService,
    private logger: NGXLogger,
    public snackBar: MatSnackBar,
    private cdRef: ChangeDetectorRef,
    private submittedForm: SubmittedFormService,
    private graphqlSubManager: GraphqlSubscriptionManagerService,
    private elementRef: ElementRef,
    private reuseStrategy: CustomReuseStrategy,
    private quickActionsService: QuickActionsService,
    private onboardingService: OnboardingChecklistService,
    private workflowPlayer: WorkflowPlayerService,
    private storageService: AmplifyStorageService,
    private appHealthService: AppHealthDiagnosticService,
    private salesmaxSupportAccounts: SalesmaxSupportAccountsService,
    private routeAccessEnforcer: RouteAccessEnforcer,
    private webCallPlacementCoordinator: WebCallPlacementCoordinatorService,
    private walletBalanceService: WalletBalanceService,
    private supportIssuesAlerts: SupportIssuesAlertService,
    @Inject(DOCUMENT) private readonly document: Document) {
    router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.updateContextualOptions(event.urlAfterRedirects);
      });

    this.playButton = this.document.createElement('button');
    this.playButton.style.display = 'none';
    this.document.body.appendChild(this.playButton);

    this.playButtonTeamChat = this.document.createElement('button');
    this.playButtonTeamChat.style.display = 'none';
    this.document.body.appendChild(this.playButtonTeamChat);

    this.alertSound = new Audio();
    this.alertSound.src = "../../../assets/audio/web_whatsapp.mp3";
    this.alertSound.addEventListener('canplaythrough', () => {
      this.playAudio();
    });

    this.alertSoundTeamChat = new Audio();
    this.alertSoundTeamChat.src = "../../../assets/audio/warm_chime.wav";
    this.alertSoundTeamChat.addEventListener('canplaythrough', () => {
      this.playAudioTeamChat();
    });


    this.previousRouteSubscription = this.dataService.getLastRoute()
      .pipe(takeUntil(this.destroy$))
      .subscribe((param: any) => {
        if (param)
          this.previousRoute = param;
        this.logger.log("previous saved route is :", this.previousRoute);
      });

    // MutationObserver initialization moved to ngOnInit to avoid memory leaks

    router.events.pipe(
        filter(event => event instanceof NavigationStart),
        takeUntil(this.destroy$)
      )
      .subscribe(event => {
        this.hideAiAssistFabOnGridScroll = false;
        this.logger.log(event);
        this.currentRoute = (event as NavigationStart).url;
        this.logger.log("current route is :", this.currentRoute);
        // Route access enforcement (was /admin + /salesmax-support redirects here)
        // now lives in AccessGuard (nav-time) + RouteAccessEnforcer (account-set,
        // wired in AppComponent). Kept below: /start-support-chat is a route-intent
        // handler that opens a dialog and rewrites navigation, not an access rule.
        if (this.currentRoute.startsWith("/start-support-chat") && this.activeAccount) {
          let channeId = `${this.activeAccount.accountId}__SALESMAX_SUPPORT_ALL`;
          this.router.navigate([this.router.url], { replaceUrl: true });
          let ref = this.dialogService.open(TeamInboxComponent, {
            data: { selectedChannelId: channeId, viewMode: 'dialog-mode' }
          }, 1);
        }
      });

    router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(event => {
        this.logger.log(event);
        this.currentRoute = (event as NavigationEnd).url;
        this.logger.log("current route is :", this.currentRoute);
        this.setBreadcrumbText();
        this.checkIfReloadMemberStatus(this.currentRoute);
        this.applyCustomCssClass = this.checkIfApplyCustomCss(this.currentRoute);
        this.applyCustomCssClassXscroll = this.checkIfApplyCustomCssXscroll(this.currentRoute);
        this.meetMode = this.checkIfMeetMode(this.currentRoute);
        this.noHeaderMode = this.checkIfNoHeaderMode(this.currentRoute) || this.meetMode;
        this.hideFab = this.checkIfHideFab(this.currentRoute) || this.meetMode;
        this.closeMobileSidebar();
        this.onDashboard = this.checkIfOnDashboard(this.currentRoute);
        this.onGettingStarted = this.checkIfOnGetStarted(this.currentRoute);
        if (this.onDashboard || this.onGettingStarted) {
          setTimeout(() => {
            this.evaluateWidths()
          }, 300);
        }
        if (this.onDashboard && this.showHealthBanner) {
          this.startHealthBannerCountdown();
        } else {
          this.stopHealthBannerCountdown();
        }
        this.scheduleTrialDashboardOrientation();
      });
  }

  checkIfReloadMemberStatus(path: string) {
    if (path.startsWith("/home/dashboard") && this.activeAccount)
      this.getMemberStatus();
  }

  checkIfApplyCustomCss(path: string) {
    return path.startsWith("/leads/lead-detail");
  }

  checkIfNoHeaderMode(path: string) {
    // return (path.startsWith("/conversations") && !path.startsWith("/conversations/reply") && !path.startsWith("/conversations/create-broadcast"));
    return false;
  }

  toggleMobileSidebar(): void {
    const body = this.document.body;
    if (body.classList.contains('sidebar-show')) {
      body.classList.remove('sidebar-show');
    } else {
      body.classList.add('sidebar-show');
    }
  }

  toggleAsideMenu(force?: boolean): void {
    const body = this.document.body;
    const className = 'aside-menu-show';
    if (force === true) {
      body.classList.add(className);
    } else if (force === false) {
      body.classList.remove(className);
    } else {
      body.classList.toggle(className);
    }
    this.isAsideOpen = body.classList.contains(className);
  }

  onJobsWidgetDismissed(): void {
    // Widget handles its own dismiss state; hook for future use
  }

  onViewExports(): void {
    this.router.navigate(['/export/exports']);
  }

  async onDownloadExport(job: EntityActionDefinition): Promise<void> {
    try {
      const compositeKey = <ModelDataExportOutputExportsByUserCompositeKeyConditionInput>{
        beginsWith: { accountId: this.activeAccount.accountId }
      };
      const filter = <ModelDataExportOutputFilterInput>{
        entityActionDefinitionReference: { eq: job.id }
      };
      const result = await this.api.GetExportsByUser(
        this.activeAccount.userId, compositeKey, ModelSortDirection.DESC, filter, 1
      );
      const exportOutput = result?.items?.[0] as DataExportOutput;
      if (exportOutput?.uploadedFile?.fileUrl) {
        const fileResult = await this.storageService.downloadFileFromS3AsBlob(exportOutput.uploadedFile.fileUrl, 'public');
        if (fileResult?.Body) {
          const url = URL.createObjectURL(fileResult.Body);
          const a = document.createElement('a');
          a.href = url;
          a.download = exportOutput.uploadedFile.fileName || 'export';
          a.click();
          setTimeout(() => URL.revokeObjectURL(url), 150);
        }
      } else {
        this.toastr.warning('Export file not found', 'The exported file is not available yet. Try again or check the Exports section.');
      }
    } catch (e) {
      console.error('Error downloading export', e);
      this.toastr.error('Download Failed', 'Could not download the file.');
    }
  }

  onViewBulkUpload(job: EntityActionDefinition): void {
    this.router.navigate(['/leads/bulk-add-leads']);
  }


  private closeMobileSidebar(): void {
    this.document.body.classList.remove('sidebar-show');
  }

  checkIfHideFab(path: string) {
    return path.startsWith("/salesmax-support/demo-assist") || path.startsWith("/salesmax-support/demo-conductor") || path.startsWith("/salesmax-support/demo-live");
  }

  checkIfMeetMode(path: string) {
    return path.startsWith("/salesmax-support/demo-conductor") && window.self !== window.top;
  }

  checkIfApplyCustomCssXscroll(path: string) {
    return path.startsWith("/opportunities/opportunity-list");
  }

  checkIfOnDashboard(path: string) {
    return path.startsWith("/home/dashboard-new") || path.startsWith("/home/dashboard") || path == "/home" || path == "/";
  }

  checkIfOnGetStarted(path: string) {
    return path.startsWith("/home/get-started");
  }


  createOnline$(): Observable<boolean> {
    return merge(
      // Listen for offline events
      fromEvent(window, 'offline').pipe(map(() => false)),
      // Listen for online events
      fromEvent(window, 'online').pipe(map(() => true)),
      // Periodically verify the state to fix inconsistencies
      timer(0, 5000).pipe(map(() => navigator.onLine)),
      // Emit the initial state when subscribed
      new Observable<boolean>((sub) => {
        sub.next(navigator.onLine);
        sub.complete();
      })
    ).pipe(
      // Debounce rapid toggles
      debounceTime(500),
      // Prevent duplicate emissions of the same state
      distinctUntilChanged(),
      // Ensure it always starts with the correct state
      startWith(navigator.onLine)
    );
  }

  reloadAfterReconnect(): void {
    if (this.isOnline && navigator.onLine && this.reconnectReloadRequired) {
      window.location.reload();
    }
  }


  private tabHiddenAt: number = null;
  private lastVisibilitySnapshotRefreshAt = 0;
  private readonly VISIBILITY_REFRESH_MIN_HIDDEN_MS = 30_000;
  private readonly VISIBILITY_REFRESH_THROTTLE_MS = 60_000;

  handleVisibilityChange = () => {
    const now = Date.now();

    if (this.document.visibilityState === 'hidden') {
      this.isVisible = false;
      this.tabHiddenAt = now;
      return;
    }

    this.isVisible = true;

    const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
    this.currentTime = now;
    if (sessionKey) {
      this.dataService.setCurrentTime(now, sessionKey);
    }

    // Real-time subscriptions may miss events while tab is backgrounded/disconnected.
    // Only force the snapshot refresh if the tab was hidden long enough that events
    // could plausibly have been missed, and not more than once per throttle window.
    const hiddenFor = this.tabHiddenAt ? now - this.tabHiddenAt : 0;
    const sinceLastRefresh = now - this.lastVisibilitySnapshotRefreshAt;
    this.tabHiddenAt = null;

    if (
      hiddenFor >= this.VISIBILITY_REFRESH_MIN_HIDDEN_MS &&
      sinceLastRefresh >= this.VISIBILITY_REFRESH_THROTTLE_MS
    ) {
      this.lastVisibilitySnapshotRefreshAt = now;

      // The 500-row member status snapshot is only rendered on the dashboard
      // Default tab and the aside "status" tab. Elsewhere the live
      // OnUpdateAccountMemberActivity subscription plus the currentTime tick keep
      // the global activity dots working, so skip the heavy refetch when no view
      // consumes the table. Set the refresh flag only when we actually call, so it
      // can't linger and bypass the route throttle on a later getMemberStatus().
      const memberStatusInView =
        (this.currentMainSection == 'dashboard' && this.selectedContextTab == 'Default') ||
        (this.isAsideOpen && this.activeAsideTab === 'status');
      if (memberStatusInView) {
        this.memberStatusNeedsToBeRefreshed = true;
        this.getMemberStatus();
      } else {
        // No view consumes the table now; defer the catch-up refresh until a
        // member-status view becomes visible (see getMemberStatus()).
        this.memberStatusVisibilityRefreshPending = true;
      }
      this.getNewChatsAsParticipant(false);
      this.getNewChatsAsParticipantInternal(false);
    }

    void this.replayPendingWebCallLogsOnBoot(true);
  }

  openChartGallery() {
    this.dialogService.open(ChartGalleryComponent, {}, 1);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // Reserved for future responsive layout adjustments
  }

  @HostListener('document:app-floating-actions-grid-scroll', ['$event'])
  onFloatingActionsGridScroll(event: Event): void {
    const detail = (event as CustomEvent<{ hidden?: boolean }>).detail;
    this.hideAiAssistFabOnGridScroll = detail?.hidden === true;
  }

  evaluateWidths() {
    // Reserved for future header width calculations
    // Currently not implemented - header layout is handled by CSS
  }

  ngAfterViewInit() {
    this.viewInitialized = true;
    setTimeout(() => {
      this.evaluateWidths()
    }, 300);
    if (this.pendingWorkspaceConfirmation) {
      this.pendingWorkspaceConfirmation();
      this.pendingWorkspaceConfirmation = undefined;
    }
    this.scheduleTrialDashboardOrientation();
  }

  private scheduleWorkspaceConfirmation(accountName: string, context: 'entered' | 'switched'): void {
    const trigger = () => {
      this.clearWorkspaceConfirmationTimers();
      this.workspaceConfirmationVisible = false;
      this.workspaceConfirmationMerging = false;
      this.workspaceIndicatorHighlighted = false;
      this.cdRef?.detectChanges?.();

      this.workspaceConfirmationLabel = context === 'switched' ? 'Switched workspace' : 'Current workspace';
      this.workspaceConfirmationAccountName = accountName;
      this.workspaceConfirmationTranslateX = '0px';
      this.workspaceConfirmationTranslateY = '0px';
      this.workspaceConfirmationScale = '0.22';
      this.workspaceConfirmationVisible = true;
      this.cdRef?.detectChanges?.();

      this.workspaceConfirmationMergeTimer = window.setTimeout(
        () => this.mergeWorkspaceConfirmationIntoHeader(),
        this.workspaceConfirmationPauseMs,
      );
    };

    if (this.viewInitialized) {
      trigger();
    } else {
      this.pendingWorkspaceConfirmation = trigger;
    }
  }

  private mergeWorkspaceConfirmationIntoHeader(): void {
    this.workspaceConfirmationMergeTimer = undefined;
    const card = this.workspaceConfirmationCard?.nativeElement;
    const target = this.workspaceIndicator?.nativeElement;

    if (!card || !target) {
      this.workspaceConfirmationVisible = false;
      this.cdRef?.detectChanges?.();
      return;
    }

    const cardRect = card.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    const cardCenterX = cardRect.left + cardRect.width / 2;
    const cardCenterY = cardRect.top + cardRect.height / 2;
    const targetCenterX = targetRect.left + targetRect.width / 2;
    const targetCenterY = targetRect.top + targetRect.height / 2;
    const targetScale = Math.min(0.32, Math.max(0.18, targetRect.width / Math.max(cardRect.width, 1)));

    this.workspaceConfirmationTranslateX = `${Math.round(targetCenterX - cardCenterX)}px`;
    this.workspaceConfirmationTranslateY = `${Math.round(targetCenterY - cardCenterY)}px`;
    this.workspaceConfirmationScale = targetScale.toFixed(3);
    this.workspaceIndicatorHighlighted = true;
    this.cdRef?.detectChanges?.();

    const reducedMotion = typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      this.workspaceConfirmationVisible = false;
      this.scheduleWorkspaceIndicatorHighlightClear();
      this.cdRef?.detectChanges?.();
      return;
    }

    this.workspaceConfirmationFrame = window.requestAnimationFrame(() => {
      this.workspaceConfirmationFrame = undefined;
      this.workspaceConfirmationMerging = true;
      this.cdRef?.detectChanges?.();
      this.workspaceConfirmationHideTimer = window.setTimeout(() => {
        this.workspaceConfirmationHideTimer = undefined;
        this.workspaceConfirmationVisible = false;
        this.workspaceConfirmationMerging = false;
        this.cdRef?.detectChanges?.();
        this.scheduleWorkspaceIndicatorHighlightClear();
      }, this.workspaceConfirmationMergeMs);
    });
  }

  private scheduleWorkspaceIndicatorHighlightClear(): void {
    this.workspaceConfirmationHighlightTimer = window.setTimeout(() => {
      this.workspaceConfirmationHighlightTimer = undefined;
      this.workspaceIndicatorHighlighted = false;
      this.cdRef?.detectChanges?.();
    }, 500);
  }

  private clearWorkspaceConfirmationTimers(): void {
    if (this.workspaceConfirmationMergeTimer) {
      window.clearTimeout(this.workspaceConfirmationMergeTimer);
      this.workspaceConfirmationMergeTimer = undefined;
    }
    if (this.workspaceConfirmationHideTimer) {
      window.clearTimeout(this.workspaceConfirmationHideTimer);
      this.workspaceConfirmationHideTimer = undefined;
    }
    if (this.workspaceConfirmationHighlightTimer) {
      window.clearTimeout(this.workspaceConfirmationHighlightTimer);
      this.workspaceConfirmationHighlightTimer = undefined;
    }
    if (this.workspaceConfirmationFrame) {
      window.cancelAnimationFrame(this.workspaceConfirmationFrame);
      this.workspaceConfirmationFrame = undefined;
    }
  }

  showVideoCalls() {
    this.dialogService.open(VideoCallsComponent, {}, 1);
  }

  /**
   * DEPRECATED: This method is no longer needed.
   * GraphqlSubscriptionManagerService now handles all reconnection automatically.
   * Keeping this method stub to avoid breaking any references, but it does nothing.
   */
  reSubscribeAll() {
    // This method intentionally left empty - subscriptions auto-reconnect via GraphqlSubscriptionManagerService
    console.log('⚠️ reSubscribeAll() called but is deprecated - GraphqlSubscriptionManagerService handles reconnection automatically');
  }

  isRouteActive(path: string): boolean {
    return this.router.url.startsWith(path);
  }

  selectContextualTab(option: ContextualTab): void {
    this.selectedContextTab = option.label;

    // Close the dropdown after navigation
    this.hoveredDropdownIndex = null;

    if (option.routeExtras) {
      this.router.navigate([option.route], option.routeExtras);
    } else {
      this.router.navigate([option.route]);
    }
  }

  updateContextualOptions(url: string): void {
    // Step 1: Determine main section by matching url with matchPattern of any ContextualTab
    let matchedSectionKey: string | null = null;

    for (const [sectionKey, tabs] of Object.entries(this.contextualMap)) {
      if (tabs.some(tab => String(tab.matchPattern || tab.route).split('|').some(path => url.startsWith(path)))) {
        matchedSectionKey = sectionKey;
        break;
      }
    }

    this.currentMainSection = matchedSectionKey || '';
    if (this.currentMainSection == '') {
      if (url.startsWith('/salesmax-support')) {
        this.currentMainSection = 'support';
      }
    }
    this.contextualOptions = this.contextualMap[this.currentMainSection] || [];

    // Step 2: Find matching contextual tab
    const matchedOption = this.contextualOptions.find(opt =>
      String(opt.matchPattern || opt.route).split('|').some(path => url.startsWith(path))
    );

    this.selectedContextTab = matchedOption?.label || this.contextualOptions[0]?.label;
  }


  goToNewBulkUpload() {
    let ref = this.dialogService.open(BulkUploadStepsComponent, { data: {} }, 1);
  }

  openSupportChat() {
    let channeId = `${this.activeAccount.accountId}__SALESMAX_SUPPORT_ALL`;
    let ref = this.dialogService.open(TeamInboxComponent, {
      data: { selectedChannelId: channeId, viewMode: 'dialog-mode' }
    }, 1);
  }

  ngOnInit(): void {
    this.checkValidSession();
    this.walletBalanceService.balance
      .pipe(takeUntil(this.destroy$))
      .subscribe(balance => {
        this.walletBalance = balance == null
          ? '--'
          : balance.toLocaleString('en-IN', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });

      });
    this.walletBalanceService.currency
      .pipe(takeUntil(this.destroy$))
      .subscribe(currency => (this.walletCurrencySymbol = currencySymbol(currency)));
    this.walletBalanceService.loading
      .pipe(takeUntil(this.destroy$))
      .subscribe(loading => (this.walletRefreshing = loading));
    this.walletBalanceService.error
      .pipe(takeUntil(this.destroy$))
      .subscribe(error => (this.walletBalanceError = error));
    this.dataService.getActiveAccount()
      .pipe(takeUntil(this.destroy$))
      .subscribe((account: AccountMembership) => {
        this.walletFeatureEnabled = isFeatureEnabled('wallet', account);
        if (!this.walletFeatureEnabled) {
          this.walletBalanceService.clear();
          return;
        }
        this.walletBalanceService.refresh(account.accountId).catch(error => {
          this.logger.warn('Could not load wallet balance', error);
        });
      });
    this.dataService.getSampleDataMode()
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        const wasEnabled = this.sampleDataModeEnabled;
        const belongsToActiveAccount = state.accountId === this.activeAccount?.accountId;
        this.sampleDataModeEnabled = state.enabled && belongsToActiveAccount;
        if (!wasEnabled && this.sampleDataModeEnabled) {
          this.clearRealBusinessShellState();
        } else if (wasEnabled && !this.sampleDataModeEnabled) {
          this.restoreRealBusinessShellState();
          if (!this.accountSwitchInProgress) void this.refreshTrialRewardCallCount();
        }
        if (state.enabled && this.activeAccount && !belongsToActiveAccount) {
          this.dataService.disableSampleDataMode();
        }
      });
    // Shallow clone object + shallow clone arrays (ContextualTab objects are immutable)
    this.contextualMap = Object.fromEntries(
      Object.entries(this.contextualMapOriginal).map(([key, value]) => [key, [...value]])
    );

    // Initialize MutationObserver for sidebar state (moved from constructor to avoid memory leaks)
    this.element = this.elementRef.nativeElement;
    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = this.document.body.classList.contains('sidebar-minimized');
    });
    this.changes.observe(<Element>this.element, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Note: Hub listener for connection state changes is now centralized in GraphqlSubscriptionManagerService
    // No need to listen here - the service handles all reconnection logic automatically

    const asideClassPattern = /aside-menu(?:-[a-z]+)?-show/;
    this.newLeadAssignedAfter = (new Date()).toISOString();
    this.setNewLeadAssignedCutoff(this.newLeadAssignedAfter);
    this.isVisible = !document.hidden;
    this.visibilityChangeSubscription = fromEvent(window, 'visibilitychange')
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.handleVisibilityChange();
      });
    const initialSessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
    if (initialSessionKey) {
      this.dataService.setCurrentTime(Date.now(), initialSessionKey);
    }
    this.currentTime = Date.now();
    this.currentTimeInterval = setInterval(() => {
      this.currentTime = Date.now();
      const tickSessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
      if (tickSessionKey) {
        this.dataService.setCurrentTime(this.currentTime, tickSessionKey);
      }
      void this.cleanupExpiredLocalforageEntries();
    }, 30000);

    //Observe aside open
    this.observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // Check if the 'aside-open' class is present
          this.isAsideOpen = asideClassPattern.test(document.body.className);
        }
      });
    });

    this.isAsideOpen = asideClassPattern.test(this.document.body.className);

    // Start observing the body for class attribute changes
    this.observer.observe(document.body, {
      attributes: true // Observe attribute changes only
    });


    //End observe aside open

    this.createOnline$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(isOnline => {
        if (!this.isOnline && isOnline) {
          // Let users save open drafts before reloading to synchronize data.
          this.reconnectReloadRequired = true;
        }
        this.isOnline = isOnline;
      });
    this.getUserDetailsAndId();

    this.data.userProfilePicRefreshNeeded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(async () => {
        await this.getUserRegistrationDetail(this.userId);
      })

    this.data.customPropertiesRefreshNeeded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        setTimeout(async () => {
          await this.getCustomPropertyDefinitions();
        }, 2000);
      })

    this.dataService.getAccountBootstrapRecoveryRequests()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
        if (sessionKey) {
          this.recoverMissingAccountBootstrapData(sessionKey);
        }
      });

    this.data.reportCategoryRefreshNeeded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        setTimeout(async () => {
          await this.getCustomReportCategories();
        }, 2000);
      })

    this.data.productRefreshNeeded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        setTimeout(async () => {
          await this.getAllProducts();
        }, 2000);
      })

    this.data.allSmartViewtDataRefreshNeeded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        setTimeout(async () => {
          await this.getSmartViews();
        }, 3000);
      })

    this.data.allParentDataRefreshNeeded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(async () => {
        if (this.activeAccount)
          await this.changeActiveAccount(this.activeAccount);
      })

    this.data.accountLogoRefreshNeeded$
      .pipe(takeUntil(this.destroy$))
      .subscribe(async () => {
        // TODO await this.getAccountLogo(this.userId);
        this.logger.log("Account Logo has been updated **************************88")
      })
  }

  async checkValidSession() {
    const session = await Auth.currentSession();
    const token = session?.getIdToken().getJwtToken();
    if (!token || token == "") {
      await this.auth.signOut();
      this.router.navigate(['/sign-in']);
    }
  }

  public async getUserDetailsAndId() {
    const attempt = ++this.accountBootstrapAttempt;
    this.accountBootstrapFailed = false;
    this.accountBootstrapError = '';
    this.busy_.next(true);
    this.errorMessage_.next('');
    const timeoutHandle = window.setTimeout(() => {
      if (this.isAccountBootstrapAttemptCurrent(attempt) && !this.activeAccount) {
        this.handleAccountBootstrapFailure(new Error('Account bootstrap timed out'), attempt);
      }
    }, this.accountBootstrapTimeoutMs);
    try {
      const userDetails: CognitoUser = await this.auth.currentAuthenticatedUser();
      if (!this.isAccountBootstrapAttemptCurrent(attempt)) {
        return;
      }
      this.userId = userDetails.getSignInUserSession().getIdToken().payload.userId;
      this.setOneSignalExternalUserId(this.userId);
      this.logger.log("Fetched User Detail :", userDetails)
      this.logger.log("Fetched User ID Token is :", this.userId)
      if (this.userId) {
        await this.getUserRegistrationDetail(this.userId, attempt);
      } else {
        this.handleAccountBootstrapFailure(new Error('Authenticated session did not contain a user id'), attempt);
      }
      if (this.isAccountBootstrapAttemptCurrent(attempt)) {
        this.userDetails_.next(userDetails);
      }
    } catch (err) {
      this.errorMessage_.next(err.message || err);
      this.handleAccountBootstrapFailure(err, attempt);
    } finally {
      window.clearTimeout(timeoutHandle);
      if (this.isAccountBootstrapAttemptCurrent(attempt)) {
        this.busy_.next(false);
        this.accountBootstrapRetrying = false;
      }
    }
  }

  retryAccountBootstrap(): void {
    if (this.accountBootstrapRetrying) {
      return;
    }
    this.accountBootstrapRetrying = true;
    void this.getUserDetailsAndId();
  }

  async signOutFromAccountBootstrap(): Promise<void> {
    if (this.accountBootstrapRetrying) {
      return;
    }
    this.accountBootstrapRetrying = true;
    this.accountBootstrapAttempt++;
    try {
      await this.removeOneSignalExternalUserId();
      await this.resetAllSavedDataInService();
      await this.auth.signOut();
    } catch (error) {
      this.logger.warn('Account bootstrap recovery sign out failed', error);
    } finally {
      this.accountBootstrapRetrying = false;
      await this.router.navigate(['/sign-in'], { replaceUrl: true });
    }
  }

  private handleAccountBootstrapFailure(error: any, attempt: number = this.accountBootstrapAttempt): void {
    if (!this.isAccountBootstrapAttemptCurrent(attempt)) {
      return;
    }
    this.logger.error('Unable to finish account bootstrap', error);
    this.accountBootstrapFailed = true;
    this.accountBootstrapRetrying = false;
    this.accountBootstrapError = this.isOnline === false
      ? 'You appear to be offline. Reconnect and try again.'
      : 'We could not load your workspace access. It may have changed. Try again or sign out.';
  }

  private isAccountBootstrapAttemptCurrent(attempt: number): boolean {
    return !this.componentDestroyed && attempt === this.accountBootstrapAttempt;
  }

  setOneSignalExternalUserId(externalId: string) {
    this.os.setExternalId(externalId);
  }

  openSpecificSupport(helpPrompt: any) {
    let action = helpPrompt.action;
    let searchValue = helpPrompt.searchValue;
    if (this.activeAccount && ((this.activeAccount.authorizationLevel == AuthorizationLevel.ADMIN) || (this.activeAccount.authorizationLevel == AuthorizationLevel.SUPERADMIN)))
      this.dialogService.open(AdminActionsComponent, {
        data: { action: action, searchValue: searchValue }
      }, 1);
    else {
      this.dialogService.open(SupportComponent, {}, 1);
    }
  }

  setBreadcrumbText() {
    this.helpPrompt = null;
    if (this.currentRoute.startsWith('/dashboard'))
      this.breadcrumbText = 'Dashboard'
    else if (this.currentRoute.startsWith('/leads/all-leads')) {
      this.breadcrumbText = 'Active Leads'
      this.helpPrompt = { searchValue: "How to Customize Table + Assign Leads", action: "customize_table_assign" };
    }
    else if (this.currentRoute.startsWith('/leads/inactive-leads')) {
      this.breadcrumbText = 'Inactive Leads'
      this.helpPrompt = { searchValue: "How to Customize Table", action: "customize_table" };
    }
    else if (this.currentRoute.startsWith('/leads/businesses'))
      this.breadcrumbText = 'Businesses'
    else if (this.currentRoute.startsWith('/leads/documents'))
      this.breadcrumbText = 'Documents'
    else if (this.currentRoute.startsWith('/leads/lists'))
      this.breadcrumbText = 'Lists'
    else if (this.currentRoute.startsWith('/leads/bulk-add-leads')) {
      this.breadcrumbText = 'Bulk Add'
      this.helpPrompt = { searchValue: "How to add leads", action: "upload_lead" };
    }
    else if (this.currentRoute.startsWith('/leads/distributions')) {
      this.breadcrumbText = 'Distribution'
      this.helpPrompt = { searchValue: "Create Distribution Rule", action: "create_distribution" };
    }
    else if (this.currentRoute.startsWith('/leads/define-distribution')) {
      this.breadcrumbText = 'Create Distribution'
      this.helpPrompt = { searchValue: "Create Distribution Rule", action: "create_distribution" };
    }
    else if (this.currentRoute.startsWith('/leads/create-list'))
      this.breadcrumbText = 'Create List'
    else if (this.currentRoute.startsWith('/engagements/all-engagements'))
      this.breadcrumbText = 'Engagements'
    else if (this.currentRoute.startsWith('/engagements/calls'))
      this.breadcrumbText = 'Calls'
    else if (this.currentRoute.startsWith('/engagements/messages'))
      this.breadcrumbText = 'Messages'
    else if (this.currentRoute.startsWith('/engagements/visits'))
      this.breadcrumbText = 'Visits'
    else if (this.currentRoute.startsWith('/todo/grid'))
      this.breadcrumbText = 'To-Dos'
    else if (this.currentRoute.startsWith('/todo/to-do-kanban')) {
      this.breadcrumbText = 'To-Dos'
    }
    else if (this.currentRoute.startsWith('/opportunities/opportunity-list'))
      this.breadcrumbText = 'Opportunities'
    else if (this.currentRoute.startsWith('/opportunities/opportunity-table'))
      this.breadcrumbText = 'Opportunities'
    else if (this.currentRoute.startsWith('/metrics/performance'))
      this.breadcrumbText = 'All Metrics'
    else if (this.currentRoute.startsWith('/activities/activities-feed'))
      this.breadcrumbText = 'Activity Feed'
    else if (this.currentRoute.startsWith('/export'))
      this.breadcrumbText = 'Data Exports'
    else if (this.currentRoute.startsWith('/activities/activities'))
      this.breadcrumbText = 'Activity Grid'
    else if (this.currentRoute.startsWith('/location/last-location'))
      this.breadcrumbText = 'Last Location'
    else if (this.currentRoute.startsWith('/admin/integrations')) {
      this.helpPrompt = { searchValue: "How to Integrate Whatsapp Cloud API or Facebook", action: "integrations" };
      this.breadcrumbText = 'Integrations'
    }
    else if (this.currentRoute.startsWith('/admin/templates')) {
      this.helpPrompt = { searchValue: "How to Create & Send Templates", action: "create_template" };
      this.breadcrumbText = 'Templates'
    }
    else
      this.breadcrumbText = ""
  }

  private getUserRegistrationDetail(userId: string, attempt: number = this.accountBootstrapAttempt) {
    return this.api.GetUser(userId).then(async event => {
      if (!this.isAccountBootstrapAttemptCurrent(attempt)) {
        return;
      }
      this.logger.log('User Registration Detail Fetched : ', event);
      if (event) {
        this.registeredUser = event;
        // if (this.registeredUser.profilePictureUrl) {
        //   this.profilePic$ = this.docService.getImageFromLocalOrS3(this.registeredUser.profilePictureUrl, 'public');
        // }
        this.dataService.setRegisteredUser({...this.registeredUser});
        await this.getuserAccountMemberships(this.registeredUser, attempt);
      } else {
        await this.removeOneSignalExternalUserId();
        await this.resetAllSavedDataInService();
        await this.auth.signOut();
        this.router.navigate(['/sign-in']);
      }
    })
      .catch(e => {
        this.logger.log('error fetching user registration detail', e);
        this.handleAccountBootstrapFailure(e, attempt);
      });

  }

  removeOneSignalExternalUserId(): Promise<void> {
    return this.os.removeExternalId(2000);
  }

  setNewLeadAssignedCutoff(value) {
    const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
    if (sessionKey) {
      this.dataService.setNewLeadAssignedAfter(value, sessionKey);
    }
  }

  private getuserAccountMemberships(user: User, attempt: number = this.accountBootstrapAttempt) {
    return this.api.AccountsByUser(user.id).then(async event => {
      if (!this.isAccountBootstrapAttemptCurrent(attempt)) {
        return;
      }
      this.logger.log('User Account Memberships Fetched : ', event);
      const membershipItems = (event?.items || []).filter((item): item is AccountMembership => !!item);
      if (membershipItems.length > 0) {
        membershipItems.forEach(item => {
          item.user = user;
        });
        // A membership can briefly outlive its related account while account
        // removal propagates. Treat that partial record as unusable instead of
        // throwing on o.account and trapping the shell on its loading screen.
        this.userAccountMemberships = _filter(membershipItems, function (o) {
          return !!o.account && o.account.accountStatus != AccountStatus.DELETED;
        });
        this.activeAccountMemberships = _filter(this.userAccountMemberships, function (o) {
          return o.userAccountStatus == UserStatus.ACTIVE && (o.account.accountType == AccountType.TEAM || o.account.accountType == AccountType.TEAM_TRIAL);
        });
        this.accountsInNeedOfAcceptance = _filter(this.userAccountMemberships, function (item) {
          return item.userAccountStatus == UserStatus.APPROVED;
        });
        this.dataService.setAllUserAccountMemberships([...this.userAccountMemberships]);
        this.dataService.setAccountsInNeedOfAcceptance([...this.accountsInNeedOfAcceptance]);
        if (this.activeAccountMemberships.length == 0) {
          await this.handleNoActiveMembership(attempt);
          return;
        }
        else {
          await localforage.getItem('lastActiveAccountSelectedInBrowser').then(event => {
            if (event && event != null) {
              let lastSelectedAccount = _filter(this.userAccountMemberships, function (item) {
                return item.account.id == event && item.userAccountStatus == UserStatus.ACTIVE && (item.account.accountType == AccountType.TEAM || item.account.accountType == AccountType.TEAM_TRIAL);
              });
              if (lastSelectedAccount && lastSelectedAccount.length > 0) {
                this.activeAccount = lastSelectedAccount[0];
                setTimeout(() => {
                  this.evaluateWidths()
                }, 300);
                this.updateNav()
              }
              else {
                let teamAccountMemberships = _filter(this.userAccountMemberships, function (item) {
                  return item.account.accountType != AccountType.INDIVIDUAL && item.userAccountStatus == UserStatus.ACTIVE && item.account.accountStatus == AccountStatus.ACTIVE;
                });
                if (teamAccountMemberships && teamAccountMemberships.length > 0) {
                  this.activeAccount = teamAccountMemberships[0];
                  setTimeout(() => {
                    this.evaluateWidths()
                  }, 300);
                  this.updateNav()
                }
              }
            }
            else {
              let teamAccountMemberships = _filter(this.userAccountMemberships, function (item) {
                return item.account.accountType != AccountType.INDIVIDUAL && item.userAccountStatus == UserStatus.ACTIVE;
              });
              if (teamAccountMemberships && teamAccountMemberships.length > 0) {
                this.activeAccount = teamAccountMemberships[0];
                setTimeout(() => {
                  this.evaluateWidths()
                }, 300);
                this.updateNav()
              }
            }
          })
            .catch(e => {
              console.log('Error getting saved last active acccount', e);
              let teamAccountMemberships = _filter(this.userAccountMemberships, function (item) {
                return item.account.accountType != AccountType.INDIVIDUAL && item.userAccountStatus == UserStatus.ACTIVE;
              });
              if (teamAccountMemberships && teamAccountMemberships.length > 0) {
                this.activeAccount = teamAccountMemberships[0];
                setTimeout(() => {
                  this.evaluateWidths()
                }, 300);
                this.updateNav()
              }
            });
          // A stale browser selection must never leave activeAccount null when
          // another valid membership exists. The older branches above apply
          // slightly different account-status filters, so retain a final,
          // deterministic fallback from the already validated active list.
          if (!this.activeAccount && this.activeAccountMemberships.length > 0) {
            this.activeAccount = this.activeAccountMemberships.find(item =>
              item.account?.accountStatus == AccountStatus.ACTIVE
            ) || this.activeAccountMemberships[0];
            setTimeout(() => this.evaluateWidths(), 300);
            this.updateNav();
          }
          if (!this.activeAccount) {
            await this.handleNoActiveMembership(attempt);
            return;
          }
          // Cold load: the updateNav() calls above filtered contextualMap by role, but the
          // toolbar's contextualOptions may already be populated (from NavigationEnd) off the
          // unfiltered map. Refresh it so the composed role/permission filters show immediately.
          if (this.activeAccount) {
            // The backend authorizes account-scoped queries from the token's
            // accountIds claim. A token minted before this membership existed
            // (invited while signed in, fresh trial) would make every screen
            // blank, so confirm the claim first; this refreshes at most once and
            // does nothing when the account is already in the token.
            const hasTokenAccess = await this.auth.ensureAccountInToken(this.activeAccount.accountId);
            if (!this.isAccountBootstrapAttemptCurrent(attempt)) {
              return;
            }
            if (!hasTokenAccess) {
              const accountName = this.activeAccount.account?.accountName || 'this workspace';
              this.logger.warn('Selected account is not in the session token after refresh', this.activeAccount.accountId);
              this.activeAccount = null;
              this.handleAccountBootstrapFailure(new Error('Selected account missing from token claims'), attempt);
              this.accountBootstrapError = `Your access to ${accountName} is not active yet. Try again in a moment or sign out.`;
              return;
            }
            this.accountBootstrapFailed = false;
            this.accountBootstrapError = '';
            // Publish the selected account before any account-scoped bootstrap work
            // so consumers and request guards agree on the current session.
            this.dataService.setActiveAccount(_.cloneDeep(this.activeAccount));
            this.updateContextualOptions(this.router.url);
            // Layer B at TRUE account-selection time. The active account is chosen here
            // from local memberships (with authorizationLevel) BEFORE the secondary
            // GetAuthorizationByUserAccount fetch that later calls setActiveAccount(). Running
            // the enforcer here guarantees a denied cold deep-link is redirected even if that
            // fetch returns 0/2 rows or errors. Replaces the old hardcoded /salesmax-support
            // redirect and also covers /admin + permission-flag routes.
            this.routeAccessEnforcer.enforceCurrentRoute(this.activeAccount);
          }
          if (this.activeAccount.accountId != user.lastSelectedAccountWeb || (this.previousRoute == "/enter-secret-code" && this.currentRoute == "/dashboard")) {
            this.scheduleWorkspaceConfirmation(this.activeAccount.account.accountName, 'entered');
            if (this.activeAccount.accountId != user.lastSelectedAccountWeb)
              this.updateLastActiveAccountWeb();
          }
          let accountIdToBeRemoved = this.activeAccount.accountId;
          this.dropdownToChooseAccount = cloneDeep(this.activeAccountMemberships);
          remove(this.dropdownToChooseAccount, function (n) {
            return n.accountId == accountIdToBeRemoved;
          });
          if (this.activeAccount && (this.activeAccount.authorizationLevel == AuthorizationLevel.ADMIN || this.activeAccount.authorizationLevel == AuthorizationLevel.SUPERADMIN))
            this.setDashboardGlobalFilter("admin");
          else if (this.activeAccount && this.activeAccount.authorizationLevel == AuthorizationLevel.MEMBER)
            this.setDashboardGlobalFilter("member");
          const isTrialRemaining = this.getTrialDaysRemaining();
          if (!isTrialRemaining) {
            return;
          }
          this.initializeOnboardingProgress();
          if (!this.checkIfWebAccessDisabled() || !this.checkIfAccountToBeBlocked()) {
            return;
          }
          this.createSubscriptions();
          void this.replayPendingWebCallLogsOnBoot();

          // Parallelize and track every account-scoped bootstrap request.
          void this.loadAccountBootstrapData('initial load');

          this.createAccountRelatedChangeSubscription();
          this.startUpcomingTaskPolling();
          this.startMissedCallPolling();
          // Salesmax-only: 30-minute fresh/unresolved support-issue alert (gated inside the service).
          this.supportIssuesAlerts?.start();
        }
      }
      else {
        this.userAccountMemberships = [];
        this.activeAccountMemberships = [];
        this.accountsInNeedOfAcceptance = [];
        this.dataService.setAllUserAccountMemberships([]);
        this.dataService.setAccountsInNeedOfAcceptance([]);
        await this.handleNoActiveMembership(attempt);
      }
    })
      .catch(e => {
        this.logger.log('error fetching user account memberships', e);
        this.handleAccountBootstrapFailure(e, attempt);
      });
  }

  private async handleNoActiveMembership(attempt: number = this.accountBootstrapAttempt): Promise<void> {
    if (!this.isAccountBootstrapAttemptCurrent(attempt)) {
      return;
    }
    this.accountBootstrapFailed = false;
    this.accountBootstrapError = '';
    this.activeAccount = null;
    await this.resetAllSavedDataInService();
    try {
      await localforage.removeItem('lastActiveAccountSelectedInBrowser');
    } catch (error) {
      // A storage failure must not keep a removed user inside the account shell.
      this.logger.warn('Could not clear the last selected workspace during account recovery', error);
    }
    await this.router.navigate(['/join-workspace'], { replaceUrl: true });
  }

  trialExpiredAction() {
    this.invalidateAccountRequests();
    this.router.navigate(['/trial-over', this.activeAccount.id]);
  }

  private invalidateAccountRequests(): void {
    this.accountRequestEpoch++;
  }

  private isAccountRequestCurrent(sessionKey: string, requestEpoch: number): boolean {
    return !this.componentDestroyed &&
      requestEpoch === this.accountRequestEpoch &&
      this.dataService.getSessionKeyForAccount(this.activeAccount) === sessionKey;
  }

  private async loadAccountBootstrapData(context: 'initial load' | 'account switch'): Promise<void> {
    const tasks: Array<[string, () => void | Promise<void>]> = [
      ['custom property definitions', () => this.getCustomPropertyDefinitions()],
      ['report categories', () => this.getCustomReportCategories()],
      ['products', () => this.getAllProducts()],
      ['integration status', () => this.getIntegrationStatus()],
      ['smart views', () => this.getSmartViews()],
      ['WhatsApp accounts', () => this.getWhatsappAccount()],
      ['user WABA numbers', () => this.getWabaNumbersForUser()],
      ['channel accounts', () => this.getChannelAccounts()],
      ['user authorization', () => this.getUserAuthorization()],
      ['bulk action status', () => this.getInitialBulkActionStatus()],
      ['cloud telephony', () => this.getCloudTelephonyDetail()],
      ['live video calls', () => this.checkForLiveVideoCalls()]
    ];
    const results = await Promise.allSettled(
      tasks.map(([, task]) => Promise.resolve().then(task))
    );
    results.forEach((result, index) => {
      if (result.status === 'rejected') {
        this.logger.error(`Unexpected ${tasks[index][0]} failure during ${context}`, result.reason);
      }
    });
  }

  checkIfWebAccessDisabled(): boolean {
    if (this.activeAccount.account.permissions && this.activeAccount.account.permissions.length > 0) {
      let permissions: any;
      try {
        permissions = JSON.parse(this.activeAccount.account.permissions[0]);
      } catch (error) {
        // Match DataShareService.setActiveAccount(): malformed optional permissions
        // must not prevent the account bootstrap from completing.
        this.logger.warn('Ignoring malformed account permissions while checking web access', error);
        return true;
      }
      const web_access_restriced_permission = permissions["disable-web-access"];
      if (web_access_restriced_permission && web_access_restriced_permission[this.activeAccount.authorizationLevel.toLowerCase()] == true) {
        this.invalidateAccountRequests();
        this.router.navigate(['/not-authorized', this.activeAccount.id]);
        return false;
      }
    }
    return true;
  }

  getTrialDaysRemaining(): boolean {
    if (this.activeAccount.account.accountType == AccountType.TEAM_TRIAL && this.activeAccount.account.trialAccountEndDate != null) {
      var currentDate = new Date();
      var trialExpiryDate = new Date(this.activeAccount.account.trialAccountEndDate);
      var difference = trialExpiryDate.getTime() - currentDate.getTime();
      this.daysRemainingInTrial = Math.ceil(difference / (1000 * 3600 * 24)); // Calculate days remaining

      if (this.daysRemainingInTrial < 0) {
        this.invalidateAccountRequests();
        this.router.navigate(['/trial-over', this.activeAccount.id]); // Navigate if trial is over
        return false; // Return false when the trial has expired
      } else {
        return true;
      }
    } else {
      this.daysRemainingInTrial = null;
      return true;
    }
  }

  initializeOnboardingProgress(): void {
    // Set trial mode based on account type
    this.isTrialMode = this.activeAccount?.account?.accountType === AccountType.TEAM_TRIAL;
    console.log('[DefaultLayout] Trial mode:', this.isTrialMode, '| Account type:', this.activeAccount?.account?.accountType);

    this.trialActivationReady = false;
    this.loadTrialActivationCardPreference();
    this.initializeTrialCountdown();

    if (this.isTrialMode && this.activeAccount) {
      // Determine user role
      const authLevel = this.activeAccount.authorizationLevel?.toLowerCase();
      const userRole: 'member' | 'manager' | 'admin' =
        authLevel === 'admin' || authLevel === 'superadmin' ? 'admin' :
        authLevel === 'manager' ? 'manager' : 'member';

      // Initialize onboarding service with account/user data for completion tracking
      this.onboardingService.initialize(
        userRole,
        this.activeAccount.account || {},
        this.activeAccount || {}
      );
    }

    // Always subscribe to onboarding progress (needed for FAB logic)
    if (this.onboardingProgressSubscribed) {
      return;
    }
    this.onboardingProgressSubscribed = true;
    this.onboardingService.progress$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        // In trial mode, use trial-specific progress (subset of steps)
        if (this.isTrialMode) {
          this.onboardingProgress = this.onboardingService.getTrialProgress();
        } else {
          this.onboardingProgress = this.onboardingService.getProgress();
        }
        console.log('[DefaultLayout] Onboarding progress:', this.onboardingProgress, '| isTrialMode:', this.isTrialMode);
      });
  }

  get isTrialActivationAdmin(): boolean {
    return this.isTrialMode && !!this.activeAccount && (
      this.activeAccount.authorizationLevel === AuthorizationLevel.ADMIN ||
      this.activeAccount.authorizationLevel === AuthorizationLevel.SUPERADMIN
    );
  }

  get trialActivationSteps(): TrialActivationStep[] {
    const metrics = this.trialActivationMetrics;
    const representativeCount = Math.min(metrics.representativeCount, REQUIRED_TRIAL_REPRESENTATIVES);
    const installedCount = Math.min(metrics.installedRepresentativeCount, REQUIRED_TRIAL_REPRESENTATIVES);
    const representativesRemaining = Math.max(0, REQUIRED_TRIAL_REPRESENTATIVES - representativeCount);
    const installsRemaining = Math.max(0, REQUIRED_TRIAL_REPRESENTATIVES - installedCount);

    return [
      {
        id: 'invite-reps',
        title: 'Add 3 sales reps',
        description: representativeCount === 0
          ? 'Add 3 sales reps or telecallers. Your admin account does not count toward this target.'
          : `${representativeCount} of ${REQUIRED_TRIAL_REPRESENTATIVES} reps added. Add ${representativesRemaining} more toward your free admin seat.`,
        ctaLabel: 'Add reps',
        icon: 'group_add',
        completed: this.trialReward.representativesComplete,
      },
      {
        id: 'install-app',
        title: 'Install Salesmax on 3 phones',
        description: installedCount < REQUIRED_TRIAL_REPRESENTATIVES
          ? `${installedCount} of ${REQUIRED_TRIAL_REPRESENTATIVES} reps have installed the app. Get ${installsRemaining} more phone${installsRemaining === 1 ? '' : 's'} connected.`
          : 'All 3 reps have installed Salesmax. Use the live checks below to clear anything blocking call tracking.',
        ctaLabel: 'Check again',
        icon: 'phone_android',
        completed: this.trialReward.installsComplete,
      },
      {
        id: 'first-call',
        title: `Log ${REQUIRED_TRIAL_TRACKED_CALLS} tracked calls`,
        description: this.trialRewardCallCountReady
          ? `${this.trialReward.callCount} of ${REQUIRED_TRIAL_TRACKED_CALLS} real rep calls tracked. Keep calling from Salesmax and review the activity as it builds.`
          : 'Checking the real calls logged by your reps since this trial started.',
        ctaLabel: 'Open leads',
        icon: 'phone_in_talk',
        completed: this.trialRewardCallCountReady && this.trialReward.callsComplete,
      },
    ];
  }

  get trialActivationCompletedSteps(): number {
    return this.trialActivationSteps.filter(step => step.completed).length;
  }

  get trialActivationPercentComplete(): number {
    return Math.round((this.trialActivationCompletedSteps / this.trialActivationSteps.length) * 100);
  }

  get trialActivationNextStep(): TrialActivationStep | undefined {
    return this.trialActivationSteps.find(step => !step.completed);
  }

  get shouldShowTrialActivationCard(): boolean {
    return this.isTrialActivationAdmin &&
      this.trialActivationReady;
  }

  get trialActivationDisplayReps(): TrialRepresentativeReadiness[] {
    const rank: Record<TrialRepresentativeMilestone, number> = {
      'invited': 0,
      'installed': 1,
      'ready': 2,
      'first-call': 3,
    };
    return [...this.trialActivationMetrics.representatives]
      .sort((a, b) => rank[b.milestone] - rank[a.milestone] || a.sourceOrder - b.sourceOrder)
      .slice(0, REQUIRED_TRIAL_REPRESENTATIVES);
  }

  get trialDeviceKey(): string | null {
    if (!this.isTrialActivationAdmin || this.activeAccount?.authorizationLevel !== AuthorizationLevel.SUPERADMIN) {
      return null;
    }
    const deviceKey = String(this.activeAccount?.account?.deviceKey || '').trim();
    return deviceKey || null;
  }

  private updateTrialActivationProgress(users: AccountMembership[]): void {
    if (!this.isTrialActivationAdmin) {
      this.trialActivationReady = false;
      return;
    }

    const permissionsMap = this.appHealthService.parseAccountPermissions(this.activeAccount?.account?.permissions);
    const healthReport = this.appHealthService.diagnoseAll(users, permissionsMap);
    this.trialActivationMetrics = deriveTrialActivationMetrics(users, healthReport.userReports, this.activeAccount?.userId);
    this.trialActivationReady = true;
    this.updateTrialReward();
    void this.refreshTrialRewardCallCount();
    this.scheduleTrialDashboardOrientation();
    this.refreshTrialAppStatusOnce();
  }

  /** Starts the orientation once for each trial account in this browser. */
  private scheduleTrialDashboardOrientation(attempt = 0): void {
    const orientationKey = this.getTrialDashboardOrientationStorageKey();
    if (!orientationKey || this.hasSeenTrialDashboardOrientation(orientationKey) || this.componentDestroyed ||
        !this.viewInitialized || !this.onDashboard || !this.isTrialActivationAdmin ||
        !this.trialActivationReady) {
      return;
    }

    if (this.trialDashboardOrientationTimer != null) {
      window.clearTimeout(this.trialDashboardOrientationTimer);
    }
    const delay = attempt === 0 ? 1800 : 250;
    this.trialDashboardOrientationTimer = window.setTimeout(async () => {
      this.trialDashboardOrientationTimer = undefined;
      if (orientationKey !== this.getTrialDashboardOrientationStorageKey() ||
          this.hasSeenTrialDashboardOrientation(orientationKey) || this.componentDestroyed ||
          !this.onDashboard || !this.isTrialActivationAdmin || !this.trialActivationReady ||
          this.workflowPlayer.hasActiveWorkflow()) {
        return;
      }

      const selectors = [
        "[data-guide='trial-sample-data']",
        "[data-guide='trial-progress-assist']",
        "[data-guide='trial-support-chat']",
      ];
      const targetsReady = selectors.every(selector => {
        const target = this.document.querySelector(selector) as HTMLElement | null;
        return !!target && target.getClientRects().length > 0;
      });
      if (!targetsReady) {
        if (attempt < 8) this.scheduleTrialDashboardOrientation(attempt + 1);
        return;
      }

      await this.workflowPlayer.startWorkflow('trial-dashboard-orientation', { bundledOnly: true });
      if (this.workflowPlayer.hasActiveWorkflow()) {
        this.markTrialDashboardOrientationSeen(orientationKey);
      }
    }, delay);
  }

  private getTrialDashboardOrientationStorageKey(): string | null {
    if (!this.activeAccount?.accountId || !this.activeAccount?.userId) return null;
    return `trial_dashboard_orientation_seen_v1_${this.activeAccount.accountId}_${this.activeAccount.userId}`;
  }

  private hasSeenTrialDashboardOrientation(key: string): boolean {
    if (this.trialDashboardOrientationStartedKeys.has(key)) return true;
    try {
      return localStorage.getItem(key) === 'true';
    } catch {
      return false;
    }
  }

  private markTrialDashboardOrientationSeen(key: string): void {
    this.trialDashboardOrientationStartedKeys.add(key);
    try {
      localStorage.setItem(key, 'true');
    } catch {
      // The in-memory key still prevents repeats during this application load.
    }
  }

  private getTrialActivationPreferenceKey(): string | null {
    if (!this.activeAccount?.accountId || !this.activeAccount?.userId) return null;
    return `trial_activation_card_minimized_${this.activeAccount.accountId}_${this.activeAccount.userId}`;
  }

  private initializeTrialCountdown(): void {
    this.clearTrialCountdownTimer();
    this.updateTrialCountdown();

    if (!this.isTrialActivationAdmin || !this.activeAccount?.account?.trialAccountEndDate) return;
    this.trialCountdownTimer = window.setInterval(() => {
      this.updateTrialCountdown();
    }, 60 * 1000);
  }

  private updateTrialCountdown(): void {
    this.trialCountdown = this.isTrialActivationAdmin
      ? buildTrialCountdown(this.activeAccount?.account?.trialAccountEndDate)
      : null;
    this.updateTrialReward();
    void this.refreshTrialRewardCallCount();
  }

  private getTrialRewardSessionKey(): string | null {
    if (!this.activeAccount?.accountId || !this.activeAccount?.userId) return null;
    return `${this.activeAccount.accountId}_${this.activeAccount.userId}`;
  }

  private updateTrialReward(): void {
    const liveReward = deriveTrialReward(this.trialActivationMetrics, this.trialReward.callCount);
    const sessionKey = this.getTrialRewardSessionKey();
    const unlockedDuringActiveTrial = liveReward.unlocked && !!this.trialCountdown && this.trialCountdown.totalHours > 0;

    if (sessionKey && unlockedDuringActiveTrial) {
      this.trialRewardUnlockedSessionKeys.add(sessionKey);
      if (!this.trialRewardUnlockToastSessionKeys.has(sessionKey)) {
        this.trialRewardUnlockToastSessionKeys.add(sessionKey);
        this.toastr.success('Free admin seat unlocked. Support will apply it when you subscribe.');
      }
    }

    this.trialReward = {
      ...liveReward,
      unlocked: !!sessionKey && this.trialRewardUnlockedSessionKeys.has(sessionKey),
    };
  }

  private async refreshTrialRewardCallCount(): Promise<void> {
    if (!this.isTrialActivationAdmin || !this.trialActivationReady || this.sampleDataModeEnabled) return;

    const accountSessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
    const requestEpoch = this.accountRequestEpoch;
    if (!accountSessionKey) return;

    const representativeIds = this.trialActivationMetrics.representatives.map(rep => rep.userId);
    const filter = buildTrialRewardCallFilter({
      accountId: this.activeAccount?.accountId,
      trialStartedAt: this.activeAccount?.account?.createdAt,
      representativeIds,
    });

    if (representativeIds.length === 0) {
      this.trialReward = deriveTrialReward(this.trialActivationMetrics, 0);
      this.trialRewardCallCountReady = true;
      this.updateTrialReward();
      return;
    }

    if (!filter) {
      this.trialRewardCallCountReady = false;
      return;
    }

    const requestKey = `${accountSessionKey}:${this.activeAccount.account.createdAt}:${[...new Set(representativeIds)].sort().join(',')}`;
    const cached = this.trialRewardCallCountCache.get(requestKey);
    if (cached && Date.now() - cached.fetchedAt < this.trialRewardCallCountTtlMs) {
      this.trialReward = deriveTrialReward(this.trialActivationMetrics, cached.count);
      this.trialRewardCallCountReady = true;
      this.updateTrialReward();
      return;
    }
    const lastAttemptAt = this.trialRewardCallCountLastAttemptAt.get(requestKey);
    if (lastAttemptAt && Date.now() - lastAttemptAt < this.trialRewardCallCountTtlMs) return;
    if (this.trialRewardCallCountInFlightKey === requestKey) return;

    this.trialRewardCallCountLastAttemptAt.set(requestKey, Date.now());
    this.trialRewardCallCountInFlightKey = requestKey;
    this.trialRewardCallCountRefreshing = true;
    this.trialRewardCallCountReady = false;
    try {
      const result = await this.api.SearchActivitys(filter, undefined, 1, undefined);
      if (!this.isAccountRequestCurrent(accountSessionKey, requestEpoch)) return;
      if (this.sampleDataModeEnabled) {
        this.trialRewardCallCountLastAttemptAt.delete(requestKey);
        return;
      }
      const currentRepresentativeIds = this.trialActivationMetrics.representatives.map(rep => rep.userId);
      const currentRequestKey = `${accountSessionKey}:${this.activeAccount.account.createdAt}:${[...new Set(currentRepresentativeIds)].sort().join(',')}`;
      if (currentRequestKey !== requestKey) return;
      const count = Math.max(0, Number(result?.total) || 0);
      this.trialRewardCallCountCache.set(requestKey, { count, fetchedAt: Date.now() });
      this.trialReward = deriveTrialReward(this.trialActivationMetrics, count);
      this.trialRewardCallCountReady = true;
      this.updateTrialReward();
    } catch (error) {
      if (this.isAccountRequestCurrent(accountSessionKey, requestEpoch)) {
        this.logger.warn('Could not refresh the trial reward call count', error);
      }
    } finally {
      if (this.trialRewardCallCountInFlightKey === requestKey) {
        this.trialRewardCallCountInFlightKey = null;
        this.trialRewardCallCountRefreshing = false;
      }
    }
  }

  private clearTrialCountdownTimer(): void {
    if (this.trialCountdownTimer != null) {
      window.clearInterval(this.trialCountdownTimer);
      this.trialCountdownTimer = undefined;
    }
  }

  private loadTrialActivationCardPreference(): void {
    const key = this.getTrialActivationPreferenceKey();
    if (!key) {
      this.trialActivationCardMinimized = false;
      return;
    }

    try {
      this.trialActivationCardMinimized = localStorage.getItem(key) === 'true';
    } catch {
      this.trialActivationCardMinimized = false;
    }
  }

  setTrialActivationCardMinimized(minimized: boolean, event?: Event): void {
    event?.stopPropagation();
    this.trialActivationCardMinimized = minimized;
    if (!minimized) this.refreshTrialAppStatusOnce();
    const key = this.getTrialActivationPreferenceKey();
    if (!key) return;

    try {
      localStorage.setItem(key, String(minimized));
    } catch {
      // The card remains usable when browser storage is unavailable.
    }
  }

  async startTrialActivationNextStep(event?: Event): Promise<void> {
    event?.stopPropagation();
    const nextStep = this.trialActivationNextStep;
    if (!nextStep) return;

    if (this.sampleDataModeEnabled) {
      this.dataService.disableSampleDataMode();
    }

    if (nextStep.id === 'invite-reps') {
      const inviteStep = this.onboardingService.getTrialSteps()
        .find(step => step.actionId === 'invite_user');
      if (inviteStep && this.unifiedPalette) {
        await this.unifiedPalette.startOnboardingStep(inviteStep);
        return;
      }
      await this.router.navigate(['/admin/users']);
      return;
    }

    if (nextStep.id === 'install-app') {
      this.refreshTrialAppStatus(event);
      return;
    }

    await this.router.navigate(['/leads/all-leads']);
  }

  copyTrialDeviceKey(event?: Event): void {
    event?.stopPropagation();
    const deviceKey = this.trialDeviceKey;
    if (!deviceKey) return;
    if (this.clipboard.copy(deviceKey)) {
      this.toastr.success('Workspace PIN copied');
    } else {
      this.toastr.error('Could not copy the workspace PIN');
    }
  }

  refreshTrialAppStatus(event?: Event, announce = true): void {
    event?.stopPropagation();
    if (this.sampleDataModeEnabled) {
      this.toastr.info('Exit sample data to check your real app status.');
      return;
    }
    if (this.trialAppStatusRefreshing) return;
    this.trialAppStatusRefreshing = true;
    if (announce) this.toastr.info('Checking the latest app status...');
    this.dataService.triggerUsersRefresh();
  }

  async openFullTrialAppStatus(event?: Event): Promise<void> {
    event?.stopPropagation();
    if (this.sampleDataModeEnabled) this.dataService.disableSampleDataMode();
    await this.router.navigate(['/admin/users'], { queryParams: { tab: 'app' } });
  }

  private refreshTrialAppStatusOnce(): void {
    const nextStep = this.trialActivationNextStep;
    if (this.trialActivationCardMinimized || this.sampleDataModeEnabled ||
        (nextStep?.id !== 'install-app' && nextStep?.id !== 'first-call')) {
      return;
    }
    const key = this.activeAccount?.accountId && this.activeAccount?.userId
      ? `${this.activeAccount.accountId}_${this.activeAccount.userId}`
      : null;
    if (!key || this.trialAppStatusRefreshedSessionKeys.has(key)) return;
    this.trialAppStatusRefreshedSessionKeys.add(key);
    this.refreshTrialAppStatus(undefined, false);
  }

  openTrialAssist(event?: Event): void {
    event?.stopPropagation();
    this.openUnifiedPalette();
  }

  openTrialDashboard(event?: Event): void {
    event?.stopPropagation();
    void this.router.navigate(['/dashboard']);
  }

  get showSampleDataModeControl(): boolean {
    return this.dataService.canEnableSampleDataMode(this.activeAccount);
  }

  toggleSampleDataMode(event?: Event): void {
    event?.stopPropagation();
    if (this.sampleDataModeEnabled) {
      this.dataService.disableSampleDataMode();
      return;
    }

    this.dataService.enableSampleDataMode(this.activeAccount, 'global-header');
  }

  exitSampleDataMode(event?: Event): void {
    event?.stopPropagation();
    this.dataService.disableSampleDataMode();
  }

  private clearRealBusinessShellState(): void {
    this.recentActivities = [];
    this.recentMentions = [];
    this.notifications = [];
    this.freshLeads = [];
    this.unassignedLeads = [];
    this.unassignedTasks = [];
    this.myTasksDueToday = [];
    this.myTasksOverdue = [];
    this.fetchedChats = [];
    this.externalChatParticipants = [];
    this.internalChatParticipants = [];
    this.totalWhatsappUnreadCount = 0;
    this.totalWhatsappNewCount = 0;
    this.totalTeamChatNewCount = 0;
    this.newActivityCount = 0;
    this.newTaskCount = 0;
    this.newPendingAssignmentCount = 0;
    this.clearPendingChatRefreshTimers();
    this.closeNewLeadSnackBar();
    this.closeSnackBar();
    this.dismissMissedCallSnackBar();
    if (this.upcomingTaskSnackBar) {
      this.upcomingTaskSnackBar.dismiss();
      this.upcomingTaskSnackBar = null;
    }
    resetFavicon();
  }

  private restoreRealBusinessShellState(): void {
    if (!this.activeAccount || this.accountSwitchInProgress || this.componentDestroyed) return;
    this.getNewChatsAsParticipant(false);
    this.getNewChatsAsParticipantInternal(false);
  }

  checkIfAccountToBeBlocked(): boolean {
    this.daysOverPaidFor = null;
    this.daysOverPaidForBasedOnDue = null;
    if (this.activeAccount.account.accountType == AccountType.TEAM) {
      const now = new Date();
      const account = this.activeAccount.account;
      // Display counters for the payment banner; the block decision is the shared grace rule.
      this.daysOverPaidFor = getDaysOver(account.paidForTillDate, now);
      this.daysOverPaidForBasedOnDue = getDaysOver(account.paidUpTo, now);
      const shouldBlockAccount = shouldBlockForPayment(account, now);
      if (shouldBlockAccount) {
        this.invalidateAccountRequests();
        this.router.navigate(['/payment-pending', this.activeAccount.id]);
        return false;
      }
    } else {
      this.daysOverPaidFor = null;
      this.daysOverPaidForBasedOnDue = null;
    }
    return true;
  }

  goToPaymentPage() {
    if (this.activeAccount.account.lastPaymentDataId)
      this.router.navigate(['/payment-pending', this.activeAccount.id]);
  }

  async getCloudTelephonyDetail(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    const accountRequest = this.api.GetTelephonyByAccount(account.accountId).then(event => {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      if (event && event.items) {
        this.cloudTelephonyAccount = event.items;
        this.dataService.setCloudTelephonyAccount([...this.cloudTelephonyAccount], sessionKey);
        if (event.items.length > 0) {
          let selectedCloudAccount = event.items[0] as CloudTelephonyAccount;
          let subsParam = `cloudTelephony-${selectedCloudAccount.providerName}`
          this.createCloudCallingSubscriptions(subsParam);
        }
      }
    })
      .catch(e => {
        if (this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
          console.log('Error Fetching Cloud Telephony Account', e);
        }
      });


    const userRequest = this.api.GetTelephonyByUserId(account.accountId, { eq: account.userId }).then(event => {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      if (event && event.items) {
        this.cloudTelephonyUser = event.items;
        this.dataService.setCloudTelephonyUser([...this.cloudTelephonyUser], sessionKey);
      }
    })
      .catch(e => {
        if (this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
          console.log('Error Fetching Cloud Telephony User', e);
        }
      });
    await Promise.all([accountRequest, userRequest]);
  }

  async getInitialBulkActionStatus(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    this.backgroundJobs = [];
    let s = <SearchableEntityActionDefinitionSortInput>{};
    const currentDate = new Date();
    const twentyFourHoursAgo = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000);

    // Fetch running jobs
    const runningFilter = <SearchableEntityActionDefinitionFilterInput>{
      and: [{ accountId: { eq: account.accountId } }, { createdAt: { gt: twentyFourHoursAgo.toISOString() } }, { ownerId: { eq: account.userId } }, { or: [{ status: { eq: 'REQUESTED' } }, { status: { eq: 'UNDER_PROCESSING' } }] }]
    };
    s = { field: SearchableEntityActionDefinitionSortableFields.updatedAt, direction: SearchableSortDirection.desc }
    const runningRequest = this.api.SearchEntityActionDefinitions(runningFilter, s, 20, undefined, undefined).then(event => {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log('Running Bulk Actions Fetched ', event);
      const items = (event.items || []) as EntityActionDefinition[];
      this.mergeBackgroundJobs(items);
    })
      .catch(e => {
        if (this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
          console.log('Error Fetching Running Bulk Actions', e);
        }
      });

    // Fetch recently completed jobs (last 1 hour) for the widget
    const oneHourAgo = new Date(currentDate.getTime() - 60 * 60 * 1000);
    const completedFilter = <SearchableEntityActionDefinitionFilterInput>{
      and: [
        { accountId: { eq: account.accountId } },
        { updatedAt: { gt: oneHourAgo.toISOString() } },
        { ownerId: { eq: account.userId } },
        { or: [{ status: { eq: 'SUCCESS' } }, { status: { eq: 'FAILURE' } }] }
      ]
    };
    const completedRequest = this.api.SearchEntityActionDefinitions(completedFilter, s, 10, undefined, undefined).then(event => {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      const completed = (event.items || []) as EntityActionDefinition[];
      this.mergeBackgroundJobs(completed);
    })
      .catch(e => {
        if (this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
          console.log('Error Fetching Completed Bulk Actions', e);
        }
      });
    await Promise.all([runningRequest, completedRequest]);
  }

  setBulkActionStatus(entityActions: EntityActionDefinition[]) {
    if (entityActions && entityActions.length > 0) {
      this.mergeBackgroundJobs(entityActions);
    }
  }

  private mergeBackgroundJobs(actions: EntityActionDefinition[]): void {
    if (!actions || actions.length === 0) return;
    const updated = [...this.backgroundJobs];
    for (const action of actions) {
      const idx = updated.findIndex(j => j.id === action.id);
      if (idx >= 0) {
        updated[idx] = action;
      } else {
        updated.unshift(action);
      }
      // Fetch bulk upload summary when a BULK_UPLOAD job completes
      // Delay to allow backend to finish populating EntityList counts
      if (action.status === 'SUCCESS' && (action.action === 'BULK_UPLOAD' || action.action === 'BULK_UPLOAD_TASK') && !this.uploadSummaries[action.id]) {
        setTimeout(() => this.fetchBulkUploadSummary(action.id), 3000);
      }
    }
    // Prune completed jobs older than 1 hour
    const oneHourAgo = Date.now() - 60 * 60 * 1000;
    this.backgroundJobs = updated.filter(j => {
      if (j.status === 'SUCCESS' || j.status === 'FAILURE') {
        return new Date(j.updatedAt).getTime() > oneHourAgo;
      }
      return true;
    });
  }

  private fetchBulkUploadSummary(jobId: string): void {
    const filter = <ModelEntityListFilterInput>{
      entityActionDefinitionReference: { eq: jobId },
      listCreationType: { eq: 'BULK_UPLOAD' }
    };
    this.api.GetListForAccount(this.activeAccount.accountId, undefined, ModelSortDirection.DESC, filter, 1)
      .then(result => {
        const entityList = result?.items?.[0] as EntityList;
        if (entityList) {
          this.uploadSummaries = {
            ...this.uploadSummaries,
            [jobId]: {
              successfulCount: entityList.successfulCount || 0,
              duplicateCount: entityList.duplicateCount || 0,
              failedCount: (entityList.invalidNumbersCount || 0) + (entityList.invalidEmailCount || 0) + (entityList.doNotTrackCount || 0) + (entityList.otherFailedCount || 0)
            }
          };
        }
      })
      .catch(e => console.error('Error fetching bulk upload summary', e));
  }

  // getCallScripts() {
  //   let f = <SearchableUploadedFileFilterInput>{}
  //   let s = <SearchableUploadedFileSortInput>{}
  //   f = { and: [{ accountId: { eq: this.activeAccount.accountId } }, { templateType: { eq: 'script' } }, { or: [{ scopeId: { eq: this.activeAccount.accountId } }, { scopeId: { eq: this.activeAccount.user.id } }] }] }
  //   s = { field: SearchableUploadedFileSortableFields.updatedAt, direction: SearchableSortDirection.desc }
  //   this.api.SearchUploadedFiles(f, s, 5).then(event => {
  //     console.log('Fetched Calling Scripts ', event);
  //     if (event.items && event.items.length > 0)
  //       this.dataService.setCallingScripts(_.cloneDeep(event.items as UploadedFile[]))
  //     else
  //       this.dataService.setCallingScripts(null)
  //   })
  //     .catch(e => {
  //       console.log('Error Fetching Call Scripts', e);
  //     });
  // }

  async getSmartViews(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    // Route via the DynamoDB-backed list resolver instead of OpenSearch. The
    // SavedTableViews model is small, account-scoped metadata that does not need
    // search-engine semantics, so it should not consume OpenSearch capacity.
    // ListSavedTableViewss uses the accountId GSI; sort by createdAt is applied
    // client-side because the primary sort key is the composite ownerId/table/view.
    try {
      // Page through ALL views — the raw list must be COMPLETE because the visible
      // list is derived from it AND it is the own-key collision guard on save
      // (see docs/saved-table-views-resolution-plan.md). A single 100-row page
      // silently truncates accounts and reintroduces duplicate-create failures.
      const allItems: any[] = [];
      let nextToken: string | undefined = undefined;
      const PAGE_SIZE = 200;
      // Safety backstop only. 100 pages × 200 = 20,000 views/account — far beyond
      // any real account — so this should never bound a legitimate fetch; the
      // raw cache stays complete (the resolution contract depends on it).
      const MAX_PAGES = 100;
      let pages = 0;
      do {
        const event = await this.api.ListSavedTableViewss(
          account.accountId, undefined, undefined, PAGE_SIZE, nextToken
        );
        if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
          return;
        }
        if (event?.items?.length) {
          allItems.push(...event.items.filter(Boolean));
        }
        nextToken = event?.nextToken ?? undefined;
        pages++;
      } while (nextToken && pages < MAX_PAGES);

      if (nextToken) {
        // Cap hit with more pages remaining: the raw cache is INCOMPLETE, but the
        // app treats it as authoritative for CREATE-vs-UPDATE. Surface loudly so
        // this is caught rather than silently risking duplicate-create failures.
        console.error(
          `getSmartViews: stopped after ${MAX_PAGES} pages (${allItems.length} views) with more remaining ` +
          `for account ${account.accountId}. Saved-view cache is incomplete; raise MAX_PAGES/page size.`
        );
      }

      this.loadedSmartViewSessionKeys.add(sessionKey);
      if (allItems.length > 0) {
        const sortedItems = allItems.sort((a, b) =>
          (b?.createdAt ?? '').localeCompare(a?.createdAt ?? '')
        );
        this.dataService.setTableViews(sortedItems, sessionKey);
      } else {
        this.dataService.setTableViews([], sessionKey);
      }
    } catch (e) {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log('Error Fetching Table Views', e);
      if (!this.loadedSmartViewSessionKeys.has(sessionKey)) {
        this.loadedSmartViewSessionKeys.add(sessionKey);
        this.dataService.setTableViews([], sessionKey);
      }
    }
  }

  async getIntegrationStatus(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    let b = <MutationIntegrationActionsBodyInput>{};
    b.accountId = account.accountId;
    b.action = "GET_CONNECTION";
    b.data = "";
    b.networkType = "";
    try {
      const event = await this.api.IntegrationActions(undefined, b);
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log("integration event is ", event)
      if (event) {
        let resp = JSON.parse(event);
        console.log("integration event.result is ", resp["result"])
        this.integrationStatus = _.mapValues(_.keyBy(resp["result"], 'networkType'), 'connected') as Map<string, any[]>
        this.integrationStatusConnected = _.cloneDeep(this.integrationStatus)
        this.removeSubscribedFalse(sessionKey);
      }
    } catch (e) {
      if (this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        console.log('Error Fetching Integration Status', e);
      }
    }
  }

  removeSubscribedFalse(sessionKey: string) {
    let nonSubscribedKeys = ["RAZORPAY", "CALENDLY"]
    for (let key in this.integrationStatusConnected) {
      this.integrationStatusConnected[key] = this.integrationStatusConnected[key].filter(obj => obj.subscribed === true || nonSubscribedKeys.includes(key));
    }
    this.dataService.setConnectedIntegrations({...this.integrationStatusConnected}, sessionKey);
  }

  async getWhatsappAccount(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    try {
      const event = await this.api.GetWabaByAccount(account.accountId);
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      const wabaAccounts = event?.items || [];
      this.connectedWabaAccounts = getUsableWabaAccounts(wabaAccounts as WabaAccount[], account.accountId);
      this.dataService.setWhatsappAccount([...this.connectedWabaAccounts], sessionKey);
      this.wabaNumbers = getUniqueWabaPhoneNumbers(this.connectedWabaAccounts, account.accountId);
      console.log("Waba phone numbers are ", this.wabaNumbers);
    } catch (e) {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log('Error Fetching Integration Status', e);
      this.showErrorInToastr(e, 'Error Fetching Integration Status');
    }
  }

  async getWabaNumbersForUser(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    try {
      const event = await this.api.GetWabaPhoneNumbersByUser(account.accountId, { eq: account.userId }, undefined, undefined, 100);
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log("user waba phone numbers fetched ", event)
      if (event && event.items && event.items.length > 0) {
        this.dataService.setUserWabaNumbers([...event.items], sessionKey);
      }
    } catch (e) {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log('Error Fetching User Waba Numbers', e);
      this.showErrorInToastr(e, 'Error Fetching User Waba Numbers');
    }
  }

  async getChannelAccounts(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    try {
      const accountsResult = await this.api.ListChannelAccountsByWorkspace(
        account.accountId, undefined, undefined, 100
      );
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      if (accountsResult?.items) {
        const channelAccounts = accountsResult.items.filter(item => item !== null);
        this.dataService.setChannelAccounts([...channelAccounts], sessionKey);

        // Fetch endpoints for each channel account
        const allEndpoints = [];
        for (const channelAccount of channelAccounts) {
          const endpointsResult = await this.api.ListEndpointsByChannelAccount(
            channelAccount.id, undefined, undefined, 100
          );
          if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
            return;
          }
          if (endpointsResult?.items) {
            allEndpoints.push(...endpointsResult.items.filter(e => e !== null));
          }
        }
        this.dataService.setChannelEndpoints([...allEndpoints], sessionKey);
        console.log("channel endpoints fetched ", allEndpoints);
      }
    } catch (e) {
      if (this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        console.log('Error Fetching Channel Accounts', e);
      }
    }
  }

  async getAllProducts(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    const filter = <SearchableProductServiceFilterInput>{ accountId: { eq: account.accountId } };
    try {
      const products = await fetchAllProductServices(this.api, { filter });
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log('Products Fetched. Count:', products.length);
      this.dataService.setProducts([...products as ProductService[]], sessionKey);
    } catch (e) {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log('Error Fetching Products', e);
      this.showErrorInToastr(e, 'Error Fetching Products');
    }
  }

  async getCustomReportCategories(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    this.dataService.setReportCategories([], sessionKey);
    const filter = <SearchableSavedChartViewsFilterInput>{ accountId: { eq: account.accountId } };
    try {
      const event = await this.api.AggregateSearchableQuery(
        account.accountId,
        "SavedChartViews",
        JSON.stringify(filter),
        null,
        "reportCategory",
        "count"
      );
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log('Report Categories Fetched : ', event);
      if (event) {
        const parsedData = JSON.parse(event);
        const buckets = parsedData.aggregations["reportCategory"].buckets;
        console.log(buckets);
        this.dataService.setReportCategories([...buckets], sessionKey);
      }
    } catch (e) {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log('Error Fetching Report Categories', e);
      this.showErrorInToastr(e, 'Error Fetching Report Categories');
    }
  }

  getCustomPropertyDefinitions(isRetry = false): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey || !account.accountId) {
      return Promise.resolve();
    }
    const requestEpoch = this.accountRequestEpoch;
    if (!isRetry) {
      // A fresh trigger (bootstrap, refresh-needed, recovery request) gets a
      // fresh retry budget and cancels any pending backoff timer; otherwise a
      // session that exhausted its retries at login can never recover without
      // a full reload. This runs before the coalescing return below so a
      // Retry that lands on an exhausted in-flight attempt still resets the
      // budget for that attempt's failure handling.
      this.clearCustomPropertyDefinitionsRetryState(sessionKey);
    }
    // Coalesce concurrent callers (bootstrap plus one or more recovery
    // requests): a duplicate fetch for the same session only fans out
    // requests. Only reuse a request from the current epoch — an A -> B -> A
    // account flap invalidates the old request's epoch, so its response would
    // be discarded and coalescing onto it would leave the session unloaded.
    const inFlight = this.customPropertyDefinitionsInFlight.get(sessionKey);
    if (inFlight && inFlight.epoch === requestEpoch) {
      return inFlight.promise;
    }
    const inFlightEntry = { epoch: requestEpoch, promise: undefined as Promise<void> };
    const request = fetchAllPropertiesByAccountAndType(this.api, account.accountId).then(properties => {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      console.log('Custom Property Definitions Fetched. Count:', properties.length);
      if (properties) {
        let customPropertyDefinitions: CustomPropertyDefinitions[] = (properties as CustomPropertyDefinitions[])
          .sort((a, b) => {
            if (a.displayOrder == null) return 1; // Null or undefined goes to the bottom
            if (b.displayOrder == null) return -1; // Null or undefined goes to the bottom
            return a.displayOrder - b.displayOrder; // Sort by displayOrder
          });
        let customPropertyMap = keyBy(customPropertyDefinitions, 'propertyName')
        this.dataService.setMapAllCustomProperties({...customPropertyMap}, sessionKey);
        this.dataService.setArrayAllCustomProperties([...customPropertyDefinitions], sessionKey);
        let dealDefinitions: DealDefinition[] = [];
        let taskTypes: TaskDefinition[] = [];
        let lifecycleNames: valueViewValue[] = [];
        let leadSourceTypes: LeadSourceType[] = [];
        let docTypes: DocumentCategoryType[] = [];
        let ticketStages: TicketStageDefinition[] = [];
        let ticketCategories: TicketCategoryDefinition[] = [];
        let leadTags: LeadTag[] = [];
        let callTypes: valueViewValueType[] = [];
        let visitTypes: valueViewValueType[] = [];
        let labelTypes: ChatLabel[] = [];
        let dealStageDefinitionFound = false;
        for (var _i = 0; _i < customPropertyDefinitions.length; _i++) {
          if (customPropertyDefinitions[_i].propertyName == "dealStage") {
            dealStageDefinitionFound = true;
            const dealStagePossibleValues = customPropertyDefinitions[_i].possibleValues || [];
            var values = _map(dealStagePossibleValues, "otherAttributes");
            // console.log("json array from deal stage is ", values)
            dealDefinitions = [];
            for (var _j = 0; _j < values.length; _j++) {
              try {
                var obj = JSON.parse(values[_j])
                let dealdef = <DealDefinition>{};
                dealdef.value = dealStagePossibleValues[_j].value;
                dealdef.name = obj["name"];
                dealdef.description = obj["description"];
                dealdef.isTerminalStateInFailure = obj["isTerminalStateInFailure"];
                dealdef.isTerminalStateInSuccess = obj["isTerminalStateInSuccess"];
                dealdef.createIfTaskCompletedSuccessfully = obj["createIfTaskCompletedSuccessfully"];
                dealdef.createIfTaskCompletedInFailure = obj["createIfTaskCompletedInFailure"];
                if (!dealdef.name) {
                  console.warn('Skipping deal stage with missing name', dealStagePossibleValues[_j]);
                  continue;
                }
                dealDefinitions.push(dealdef)
              }
              catch (e) {
                console.log("error in json parse")
              }
            }
            console.log("deal stages are ", dealDefinitions)
          }
          else if (customPropertyDefinitions[_i].propertyName == "taskType") {
            taskTypes = [];
            var possibleValues = customPropertyDefinitions[_i].possibleValues;
            // console.log("json array from task type is ", JSON.stringify(possibleValues))
            for (var _j = 0; _j < possibleValues.length; _j++) {
              var taskType = <TaskDefinition>{};
              taskType.value = possibleValues[_j].value
              taskType.viewValue = possibleValues[_j].viewValue
              let otherAttributesJson = JSON.parse(possibleValues[_j].otherAttributes)
              if (otherAttributesJson && otherAttributesJson["taskAutoCloseDays"])
                taskType.expiresInDays = Number(otherAttributesJson["taskAutoCloseDays"]);
              else
                taskType.expiresInDays = 30;
              if (otherAttributesJson && otherAttributesJson["maxFollowUps"])
                taskType.maxFollowUps = Number(otherAttributesJson["maxFollowUps"])
              taskType.description = otherAttributesJson.description
              taskType.name = otherAttributesJson.name
              taskType.activities = otherAttributesJson.taskActivityTypes
              taskTypes.push(taskType)
            }
            console.log("task types are ", taskTypes)
          }
          else if (customPropertyDefinitions[_i].propertyName == "leadLifecycleName") {
            lifecycleNames = [];
            var possibleValues = customPropertyDefinitions[_i].possibleValues;
            // console.log("json array from task type is ", JSON.stringify(possibleValues))
            for (var _j = 0; _j < possibleValues.length; _j++) {
              var lifecycleName = <valueViewValue>{};
              lifecycleName.value = possibleValues[_j].value
              lifecycleName.viewValue = possibleValues[_j].viewValue
              lifecycleNames.push(lifecycleName)
            }
            console.log("lead lifecycle are ", lifecycleNames)
          }
          else if (customPropertyDefinitions[_i].propertyName == "leadSource") {
            leadSourceTypes = [];
            var possibleValues = customPropertyDefinitions[_i].possibleValues;
            // console.log("json array from call outcome type is ", JSON.stringify(possibleValues))
            for (var _j = 0; _j < possibleValues.length; _j++) {
              var leadSource = <LeadSourceType>{};
              leadSource.value = possibleValues[_j].value
              leadSource.viewValue = possibleValues[_j].viewValue
              let otherAttributesJson = JSON.parse(possibleValues[_j].otherAttributes)
              leadSource.subCategory = otherAttributesJson.subCategory
              leadSourceTypes.push(leadSource)
            }
            console.log("lead Sources are ", leadSourceTypes)
          }
          else if (customPropertyDefinitions[_i].propertyName == "docCategory") {
            docTypes = [];
            var possibleValues = customPropertyDefinitions[_i].possibleValues;
            // console.log("json array from call outcome type is ", JSON.stringify(possibleValues))
            for (var _j = 0; _j < possibleValues.length; _j++) {
              var docType = <DocumentCategoryType>{};
              docType.value = possibleValues[_j].value
              docType.viewValue = possibleValues[_j].viewValue
              let otherAttributesJson = JSON.parse(possibleValues[_j].otherAttributes)
              docType.subCategory = otherAttributesJson.subCategory
              docTypes.push(docType)
            }
            console.log("doc types are ", docTypes)
          }
          else if (customPropertyDefinitions[_i].propertyName == "ticketStage") {
            const possibleValues = customPropertyDefinitions[_i].possibleValues;
            ticketStages = [];
            for (let _j = 0; _j < possibleValues.length; _j++) {
              let attrs: any = {};
              try {
                attrs = JSON.parse(possibleValues[_j].otherAttributes || '{}');
              } catch {
                attrs = {};
              }
              ticketStages.push({
                value: possibleValues[_j].value,
                name: attrs.name || possibleValues[_j].viewValue,
                description: attrs.description,
                stageType: (attrs.stageType || 'ACTIVE') as TicketStageType,
                statusOnEnter: attrs.statusOnEnter
              });
            }
            console.log("ticket stages are ", ticketStages);
          }
          else if (customPropertyDefinitions[_i].propertyName == "ticketCategory") {
            const possibleValues = customPropertyDefinitions[_i].possibleValues;
            ticketCategories = [];
            for (let _j = 0; _j < possibleValues.length; _j++) {
              let attrs: any = {};
              try {
                attrs = JSON.parse(possibleValues[_j].otherAttributes || '{}');
              } catch {
                attrs = {};
              }
              ticketCategories.push({
                value: possibleValues[_j].value,
                viewValue: possibleValues[_j].viewValue,
                description: attrs.description
              });
            }
            console.log("ticket categories are ", ticketCategories);
          }
          else if (customPropertyDefinitions[_i].propertyName == "leadTag") {
            leadTags = [];
            var possibleValues = customPropertyDefinitions[_i].possibleValues;
            for (var _j = 0; _j < possibleValues.length; _j++) {
              var leadTag = <LeadTag>{};
              leadTag.value = possibleValues[_j].value
              leadTag.viewValue = possibleValues[_j].viewValue
              let otherAttributesJson = possibleValues[_j].otherAttributes ? JSON.parse(possibleValues[_j].otherAttributes) : {}
              leadTag.color = otherAttributesJson?.color
              leadTags.push(leadTag)
            }
            console.log("Lead tags are ", leadTags)
          }
          else if (customPropertyDefinitions[_i].propertyName == "callOutcome") {
            callTypes = [];
            var possibleValues = customPropertyDefinitions[_i].possibleValues;
            // console.log("json array from call outcome type is ", JSON.stringify(possibleValues))
            for (var _j = 0; _j < possibleValues.length; _j++) {
              var callType = <valueViewValueType>{};
              callType.value = possibleValues[_j].value
              callType.viewValue = possibleValues[_j].viewValue
              let otherAttributesJson = JSON.parse(possibleValues[_j].otherAttributes)
              callType.type = otherAttributesJson.nature
              callType.startsNewDeal = otherAttributesJson.createNewDeal
              callType.startsNewDealManual = otherAttributesJson.createNewDealManual
              callType.applicableTemplateIds = otherAttributesJson.applicableTemplateIds
              callTypes.push(callType)
            }
            console.log("call outcome types are ", callTypes)
          }
          else if (customPropertyDefinitions[_i].propertyName == "visitOutcome") {
            visitTypes = [];
            var possibleValues = customPropertyDefinitions[_i].possibleValues;
            // console.log("json array from visit outcome type is ", JSON.stringify(possibleValues))
            for (var _j = 0; _j < possibleValues.length; _j++) {
              var visitType = <valueViewValueType>{};
              visitType.value = possibleValues[_j].value
              visitType.viewValue = possibleValues[_j].viewValue
              let otherAttributesJson = JSON.parse(possibleValues[_j].otherAttributes)
              visitType.type = otherAttributesJson.nature
              visitType.startsNewDeal = otherAttributesJson.createNewDeal
              visitType.startsNewDealManual = otherAttributesJson.createNewDealManual
              visitTypes.push(visitType)
            }
            console.log("visit outcome types are ", visitTypes)
          }
          else if (customPropertyDefinitions[_i].propertyName == "chatLabel") {
            labelTypes = [];
            var possibleValues = customPropertyDefinitions[_i].possibleValues;
            // console.log("json array from visit outcome type is ", JSON.stringify(possibleValues))
            for (var _j = 0; _j < possibleValues.length; _j++) {
              var labelType = <ChatLabel>{};
              labelType.value = possibleValues[_j].value
              labelType.viewValue = possibleValues[_j].viewValue
              let otherAttributesJson = JSON.parse(possibleValues[_j].otherAttributes)
              labelType.color = otherAttributesJson.color
              labelTypes.push(labelType)
            }
            console.log("Chat label types are ", labelTypes)
          }
        }
        if (dealStageDefinitionFound && dealDefinitions.length > 0) {
          this.clearCustomPropertyDefinitionsRetryState(sessionKey);
          this.dataService.setDealStages([...dealDefinitions], sessionKey);
        } else {
          console.warn('Deal stages were not available in custom property definitions; leaving previous stage state untouched.', {
            accountId: account.accountId,
            customPropertyCount: customPropertyDefinitions.length,
            dealStageDefinitionFound,
            parsedDealStageCount: dealDefinitions.length
          });
          this.scheduleCustomPropertyDefinitionsRetry(sessionKey, requestEpoch);
        }
        this.dataService.setTaskTypes([...taskTypes], sessionKey);
        this.dataService.setLifecycleViewValue([...lifecycleNames], sessionKey);
        globalFunctions.setLeadLifecycle(lifecycleNames);
        this.dataService.setLeadSourcesTypes(_.cloneDeep(leadSourceTypes), sessionKey);
        this.dataService.setDocCategories(_.cloneDeep(docTypes), sessionKey);
        this.dataService.setTicketStages(_.cloneDeep(ticketStages), sessionKey);
        this.dataService.setTicketCategories(_.cloneDeep(ticketCategories), sessionKey);
        this.dataService.setLeadTags(_.cloneDeep(leadTags), sessionKey);
        this.dataService.setCallOutcomeTypes(_.cloneDeep(callTypes), sessionKey);
        this.dataService.setVisitOutcomeTypes(_.cloneDeep(visitTypes), sessionKey);
        this.dataService.setChatLabelTypes(_.cloneDeep(labelTypes), sessionKey);
      } else {
        console.warn('Custom property definitions response did not contain items; retrying if possible.', { accountId: account.accountId });
        this.scheduleCustomPropertyDefinitionsRetry(sessionKey, requestEpoch);
      }
    })
      .catch(e => {
        if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
          return;
        }
        console.log('Error Fetching Custom Property Definitions', e);
        this.scheduleCustomPropertyDefinitionsRetry(sessionKey, requestEpoch);
        // this.showErrorInToastr(e, 'Error Fetching Custom Property Definitions')
      })
      .finally(() => {
        // Only clean up our own entry: a stale-epoch request settling late
        // must not delete a newer in-flight request for the same session.
        if (this.customPropertyDefinitionsInFlight.get(sessionKey) === inFlightEntry) {
          this.customPropertyDefinitionsInFlight.delete(sessionKey);
        }
      });
    inFlightEntry.promise = request;
    this.customPropertyDefinitionsInFlight.set(sessionKey, inFlightEntry);
    return request;
  }

  private scheduleCustomPropertyDefinitionsRetry(sessionKey: string, requestEpoch: number): void {
    const retryCount = this.customPropertyDefinitionsRetryCounts.get(sessionKey) || 0;
    if (retryCount >= this.customPropertyDefinitionsMaxRetries) {
      return;
    }
    this.customPropertyDefinitionsRetryCounts.set(sessionKey, retryCount + 1);
    const timer = window.setTimeout(() => {
      this.customPropertyDefinitionsRetryTimers.delete(sessionKey);
      if (this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        void this.getCustomPropertyDefinitions(true);
      }
    }, 1000 * (retryCount + 1));
    this.customPropertyDefinitionsRetryTimers.set(sessionKey, timer);
  }

  private clearCustomPropertyDefinitionsRetryState(sessionKey: string): void {
    this.customPropertyDefinitionsRetryCounts.delete(sessionKey);
    const pendingTimer = this.customPropertyDefinitionsRetryTimers.get(sessionKey);
    if (pendingTimer != null) {
      window.clearTimeout(pendingTimer);
      this.customPropertyDefinitionsRetryTimers.delete(sessionKey);
    }
  }

  createAccountRelatedChangeSubscription() {
    if (this.sub_user_account_update_create && !this.sub_user_account_update_create.closed) {
      this.sub_user_account_update_create.unsubscribe();
    }
    this.sub_user_account_update_create = this.graphqlSubManager.managedSubscribe(
      () => this.api.OnCreateAccountUpdatesByUserListener(this.activeAccount.userId),
      {
        next: (event: any) => {
          if (event) {
            this.logger.log("event received on onCreateAccountUpdatesByUser subscription:", event);
            let data = event.value?.data?.onCreateAccountUpdatesByUser;
            if (data && (data.entityType == "AccountMembership" || data.entityType == "Account")) {
              // Account settings changed - notify user before reloading
              this.toastr.warning('Account settings updated. Reloading to apply changes...', '', { timeOut: 3000 });
              setTimeout(() => window.location.reload(), 3000);
            }
          }
        },
        error: err => this.logger.error('onCreateAccountUpdatesByUser error', err)
      },
      { description: 'default-layout:OnCreateAccountUpdatesByUser' }
    );
  }

  createCloudCallingSubscriptions(engagementSource) {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    this.cloudCallingSessionKey = sessionKey;
    if (this.sub_cloud_calls_create && !this.sub_cloud_calls_create.closed) {
      this.sub_cloud_calls_create.unsubscribe();
    }
    if (this.sub_cloud_calls_update && !this.sub_cloud_calls_update.closed) {
      this.sub_cloud_calls_update.unsubscribe();
    }
    this.sub_cloud_calls_create = this.graphqlSubManager.managedSubscribe(
      () => this.api.OnCreateEngagementUserLevelListener(account.accountId, account.userId, engagementSource),
      {
        next: (event: any) => {
          const callStatus = event?.value?.data?.onCreateEngagementUserLevel as Engagement;
          if (!callStatus) {
            return;
          }
          console.log("cloudCall event received on create is ", callStatus);
          this.handleCloudCallCreateEvent(callStatus, sessionKey);
        },
        error: (error) => {
          this.logger.error("Error in cloud calls create subscription", error);
        }
      },
      { description: 'default-layout:OnCreateEngagementUserLevel' }
    );

    this.sub_cloud_calls_update = this.graphqlSubManager.managedSubscribe(
      () => this.api.OnUpdateEngagementUserLevelListener(account.accountId, account.userId, engagementSource),
      {
        next: (event: any) => {
          const callStatus = event?.value?.data?.onUpdateEngagementUserLevel as Engagement;
          if (!callStatus) {
            return;
          }
          console.log("cloudCall event received on update is ", callStatus);
          this.handleCloudCallUpdateEvent(callStatus, sessionKey);
        },
        error: (error) => {
          this.logger.error("Error in cloud calls update subscription", error);
        }
      },
      { description: 'default-layout:OnUpdateEngagementUserLevel' }
    );
  }

  private handleCloudCallCreateEvent(callStatus: Engagement, sessionKey: string): void {
    if (this.sampleDataModeEnabled) return;
    if (!callStatus || callStatus.cloudProvider === 'CX') {
      return;
    }
    if (callStatus.toBeAssigned == ContactAssignmentStatus.UNASSIGNED || (callStatus.callStatus === 'QUEUED' &&
      (callStatus.cloudProvider === 'TATATELESERVICES' || callStatus.engagementSource === 'cloudTelephony-TATATELESERVICES'))) {
      return;
    }
    if (!this.shouldProcessCloudCallEvent(callStatus)) {
      return;
    }
    this.dataService.getLiveCloudCallContactIdInPreview().pipe(take(1)).subscribe(contactIdInPreview => {
      this.dataService.setLiveCloudCallEngagement(_.cloneDeep(callStatus), sessionKey);
      if (callStatus.contactId !== contactIdInPreview) {
        if (!this.canOpenLivePreview()) {
          return;
        }
        const config = { data: { previewContactId: callStatus.contactId, engagement: callStatus, isLiveCall: true } };
        const ref = this.dialogService.open(LeadDetailComponent, config, 1);
        this.dataService.setLiveCloudCallContactIdInPreview(callStatus.contactId, sessionKey);
        ref.afterClosed.pipe(take(1)).subscribe(() => this.dataService.setLiveCloudCallContactIdInPreview(null, sessionKey));
      }
    });
  }

  private handleCloudCallUpdateEvent(callStatus: Engagement, sessionKey: string): void {
    if (this.sampleDataModeEnabled) return;
    if (!callStatus) {
      return;
    }
    if (!this.shouldProcessCloudCallEvent(callStatus)) {
      return;
    }
    this.dataService.getLiveCloudCallContactIdInPreview().pipe(take(1)).subscribe(contactIdInPreview => {
      this.dataService.setLiveCloudCallEngagement(_.cloneDeep(callStatus), sessionKey);
      const shouldOpenPreview = callStatus.toBeAssigned != ContactAssignmentStatus.UNASSIGNED &&
        (callStatus.callStatus === 'AGENT_RINGING' && (callStatus.cloudProvider === 'TATATELESERVICES' ||
          callStatus.engagementSource === 'cloudTelephony-TATATELESERVICES'));
      if (shouldOpenPreview && callStatus.contactId !== contactIdInPreview) {
        if (!this.canOpenLivePreview()) {
          return;
        }
        const config = { data: { previewContactId: callStatus.contactId, engagement: callStatus, isLiveCall: true } };
        const ref = this.dialogService.open(LeadDetailComponent, config, 1);
        this.dataService.setLiveCloudCallContactIdInPreview(callStatus.contactId, sessionKey);
        ref.afterClosed.pipe(take(1)).subscribe(() => this.dataService.setLiveCloudCallContactIdInPreview(null, sessionKey));
      }
    });
  }

  private shouldProcessCloudCallEvent(callStatus: Engagement): boolean {
    if (!callStatus) {
      return false;
    }
    const identifier = callStatus.id;
    const status = callStatus.callStatus || '';
    if (!identifier && !status) {
      return true;
    }
    const key = `${identifier}:${status}`;
    const now = Date.now();
    this.purgeOldCloudEvents(now);
    const lastSeen = this.recentCloudEvents.get(key);
    if (lastSeen && now - lastSeen < this.cloudEventCacheTtlMs) {
      return false;
    }
    this.recentCloudEvents.set(key, now);
    if (this.recentCloudEvents.size > this.cloudEventCacheMaxEntries) {
      this.trimCloudEventCache();
    }
    return true;
  }

  private purgeOldCloudEvents(now: number): void {
    for (const [eventKey, seenAt] of this.recentCloudEvents.entries()) {
      if (now - seenAt > this.cloudEventCacheTtlMs) {
        this.recentCloudEvents.delete(eventKey);
      }
    }
  }

  private trimCloudEventCache(): void {
    if (this.recentCloudEvents.size <= this.cloudEventCacheMaxEntries) {
      return;
    }
    const ordered = Array.from(this.recentCloudEvents.entries()).sort((a, b) => a[1] - b[1]);
    while (ordered.length > this.cloudEventCacheMaxEntries) {
      const [keyToRemove] = ordered.shift();
      if (keyToRemove) {
        this.recentCloudEvents.delete(keyToRemove);
      }
    }
  }

  private canOpenLivePreview(): boolean {
    const now = Date.now();
    if (now - this.lastLivePreviewOpenedAt < this.previewDebounceMs) {
      return false;
    }
    this.lastLivePreviewOpenedAt = now;
    return true;
  }

  createSubscriptions(isResubscribe = false) {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      this.logger.warn('createSubscriptions skipped: activeAccount not yet available', { isResubscribe });
      return;
    }

    if (this.sub_web_calls && !this.sub_web_calls.closed) {
      this.sub_web_calls.unsubscribe();
    }
    this.sub_web_calls = this.graphqlSubManager.managedSubscribe(
      () => this.api.OnUpdateWebInitiatedCallListener(account.accountId, account.userId),
      {
        next: (event: any) => {
          if (this.sampleDataModeEnabled) return;
          if (event) {
            let callStatus = event.value.data.onUpdateWebInitiatedCall;
            this.logger.log("event received on OnUpdateWebInitiatedCallListener subscription:", event)
            this.logger.log("OnUpdateWebInitiatedCallListener ----------------- :", callStatus)
            if (callStatus) {
              if (callStatus.status == "OFFHOOK") {
                const currentWebCall = this.webCallId;
                const coordinatedAttempt = this.webCallPlacementCoordinator
                  .acknowledgeOffhook(callStatus.callId);
                const matchedWebCall = coordinatedAttempt
                  || (callStatus.callId && callStatus.callId == currentWebCall?.callId
                    ? currentWebCall
                    : null);
                this.logger.log('OFFHOOK received for web call', {
                  receivedCallId: callStatus.callId,
                  currentWebCallId: currentWebCall?.callId,
                  currentWebCallContactId: currentWebCall?.contactId
                });
                if (matchedWebCall) {
                  // Coordinator-owned placements are cleaned up by exact ID.
                  // Only the legacy fallback still needs shared-state cleanup;
                  // otherwise a late event for call A could clear active call B.
                  if (!coordinatedAttempt) {
                    this.dataService.setWebCallId(null);
                  }
                  const webCallLogRef = this.dialogService.open(LogCallComponent, {
                    data: {
                      preSelectedContactId: matchedWebCall.contactId,
                      callPlacementId: matchedWebCall.callId
                    }
                  });
                  const savedAccountId = this.activeAccount?.accountId;
                  const savedContactId = matchedWebCall.contactId;
                  const savedCallPlacementId = matchedWebCall.callId;
                  webCallLogRef.afterClosed.pipe(take(1)).subscribe(result => {
                    void this.announceWebCallOutcomeSaved(result, savedCallPlacementId, savedAccountId, savedContactId);
                  });
                }
                else {
                  this.logger.warn('OFFHOOK ignored because callId did not match current web call context', {
                    receivedCallId: callStatus.callId,
                    currentWebCallId: this.webCallId?.callId,
                    currentWebCallContactId: this.webCallId?.contactId
                  });
                }
              }
              else if (callStatus.status == "COMPLETED") {
                const currentWebCallId = this.webCallId?.callId;
                this.webCallPlacementCoordinator.complete(callStatus.callId);
                if (callStatus.callId && callStatus.callId == currentWebCallId) {
                  this.dataService.setWebCallId(null);
                }
                this.handleCompletedWebCallOutcome(callStatus.callId)
                  .catch(e => {
                    this.logger.error('Error scheduling completed web-call outcome reconciliation', e);
                  });
              }
            }
          }
        },
        error: err => this.logger.error('OnUpdateWebInitiatedCallListener error', err)
      },
      { description: 'default-layout:OnUpdateWebInitiatedCall' }
    );

    //Subscribe to real time user status`
    if (this.sub_memberStatus_update && !this.sub_memberStatus_update.closed) {
      this.sub_memberStatus_update.unsubscribe();
    }
    this.sub_memberStatus_update = this.graphqlSubManager.managedSubscribe(
      () => this.api.OnUpdateAccountMemberActivityListener(account.accountId),
      {
        next: (event: any) => {
          if (this.sampleDataModeEnabled) return;
          if (event) {
            let newMemberStatus = event.value.data.onUpdateAccountMemberActivity;
            this.logger.log("event received on subscription:", event)
            this.logger.log("New Member Status ----------------- :", newMemberStatus)
            if (newMemberStatus) {
              this.dataService.setOnUpdateAccountMemberActivityListener(_.cloneDeep(newMemberStatus), sessionKey);
              this.updateMemberStatusWithNewData(newMemberStatus);
            }
          }
        },
        error: err => this.logger.error('OnUpdateAccountMemberActivityListener error', err)
      },
      { description: 'default-layout:OnUpdateAccountMemberActivity' }
    );

    //Subscribe to entity Action Definition mutations
    if (this.activeAccount.authorizationLevel != AuthorizationLevel.MEMBER) {
      if (this.sub_entityActionDefinition_update && !this.sub_entityActionDefinition_update.closed) {
        this.sub_entityActionDefinition_update.unsubscribe();
      }
      this.sub_entityActionDefinition_update = this.graphqlSubManager.managedSubscribe(
      () => this.api.OnUpdateEntityActionDefinitionListener(account.accountId, account.userId),
        {
          next: (event: any) => {
            if (this.sampleDataModeEnabled) return;
            if (event) {
              let newActionUpdate = event.value.data.onUpdateEntityActionDefinition as EntityActionDefinition;
              this.logger.log("OnUpdateEntityActionDefinitionListener event received on subscription:", event)
              this.dataService.setJobChange(_.cloneDeep(newActionUpdate), sessionKey);
              this.setBulkActionStatus([newActionUpdate]);
            }
          },
          error: err => this.logger.error('OnUpdateEntityActionDefinitionListener error', err)
        },
        { description: 'default-layout:OnUpdateEntityActionDefinition' }
      );
      if (this.sub_entityActionDefinition_create && !this.sub_entityActionDefinition_create.closed) {
        this.sub_entityActionDefinition_create.unsubscribe();
      }
      this.sub_entityActionDefinition_create = this.graphqlSubManager.managedSubscribe(
      () => this.api.OnCreateEntityActionDefinitionListener(account.accountId, account.userId),
        {
          next: (event: any) => {
            if (this.sampleDataModeEnabled) return;
            if (event) {
              let newActionCreate = event.value.data.onCreateEntityActionDefinition;
              this.logger.log("OnCreateEntityActionDefinitionListener event received on subscription:", event)
              this.dataService.setJobChange(_.cloneDeep(newActionCreate), sessionKey);
              this.setBulkActionStatus([newActionCreate]);
            }
          },
          error: err => this.logger.error('OnCreateEntityActionDefinitionListener error', err)
        },
        { description: 'default-layout:OnCreateEntityActionDefinition' }
      );
    }
    //Subscribe to contact assignment activity
    if (this.sub_activity_contact_assigned && !this.sub_activity_contact_assigned.closed) {
      this.sub_activity_contact_assigned.unsubscribe();
    }
    this.sub_activity_contact_assigned = this.graphqlSubManager.managedSubscribe(
      () => this.api.OnCreateActivityUserLevelActivityTypeListener(account.accountId, account.userId, ActivityType.CONTACT_ASSIGNED),
      {
        next: (event: any) => {
          if (this.sampleDataModeEnabled) return;
          if (event) {
            let contactAssignedUpdate = event.value.data.onCreateActivityUserLevelActivityType as Activity;
            this.logger.log("OnCreateActivityUserLevelActivityTypeListener event received on subscription:", event)
            this.newlyAssignedLeads.push(contactAssignedUpdate)
            if (!this.newLeadSnackBar)
              this.openNewLeadSnackBar(this.newlyAssignedLeads.length);
            else
              this.newLeadSnackBar.instance.newLeadCount = this.newlyAssignedLeads.length;
          }
        },
        error: err => this.logger.error('OnCreateActivityUserLevelActivityTypeListener error', err)
      },
      { description: 'default-layout:OnCreateActivityUserLevelActivityType' }
    );

    //Own Account Member Activity Updates
    if (this.sub_memberStatus_update_user && !this.sub_memberStatus_update_user.closed) {
      this.sub_memberStatus_update_user.unsubscribe();
    }
    this.sub_memberStatus_update_user = this.graphqlSubManager.managedSubscribe(
      () => this.api.OnUpdateAccountMemberActivityByUserListener(account.accountId, this.userId),
      {
        next: (event: any) => {
          if (this.sampleDataModeEnabled) return;
          if (event) {
            let newMemberStatus = event.value.data.onUpdateAccountMemberActivityByUser;
            this.logger.log("user level event received on subscription:", event)
            this.logger.log(" user level New Member Status ----------------- :", newMemberStatus)
            if (newMemberStatus && newMemberStatus.inCall != null && newMemberStatus.lastInCallUpdatedAt != null) {
              this.dataService.setOnUpdateAccountMemberActivityListener(_.cloneDeep(newMemberStatus), sessionKey);
              let now = new Date();
              let lastInCallUpdatedAtDate = new Date(newMemberStatus.lastInCallUpdatedAt)
              this.lastInCallUpdatedAtDate = lastInCallUpdatedAtDate.getTime()
              if ((newMemberStatus.inCall == "Outgoing Call Is Picked Up And In Progress" || newMemberStatus.inCall == "Outgoing Call" || newMemberStatus.inCall == "Incoming Call" || newMemberStatus.inCall == "Incoming Call Is Picked Up And In Progress") && (now.getTime() - this.lastInCallUpdatedAtDate) < 30000) {
                if (!this.currentSnackBar)
                  this.openSnackBar(newMemberStatus);
                else
                  this.currentSnackBar.instance.data = newMemberStatus;
              }
              if (newMemberStatus.inCall != null && (newMemberStatus.inCall == "Outgoing Call Has Completed" || newMemberStatus.inCall == "Incoming Call Has Completed")) {
                this.closeSnackBar();
              }
            }
          }
        },
        error: err => this.logger.error('OnUpdateAccountMemberActivityByUserListener error', err)
      },
      { description: 'default-layout:OnUpdateAccountMemberActivityByUser' }
    );

    //subscribe to messages
    if (this.sub_chatParticipant_update && !this.sub_chatParticipant_update.closed) {
      this.sub_chatParticipant_update.unsubscribe();
    }
    this.sub_chatParticipant_update = this.graphqlSubManager.managedSubscribe(
      () => this.api.OnUpdateChatParticipantListener(account.accountId, account.userId),
      {
        next: (event: any) => {
          if (this.sampleDataModeEnabled) return;
          if (event) {
            console.log("in default layout component OnUpdateChatParticipantListener event received on subscription:", event)
            let newActionUpdate = event.value.data.onUpdateChatParticipant as ChatParticipant;
            this.dataService.setChatParticipantUpdate(_.cloneDeep(newActionUpdate), sessionKey);
            if (newActionUpdate.isNewMessageUpdate) {
              const isInternalChannel = newActionUpdate.channelType === 'INTERNAL';

              // Always keep preview payload in sync with the latest event.
              // Optimistically ensure count ≥ 1 so quick-inbox can show immediately;
              // the API refresh (scheduleChatRefresh) will correct to the accurate count.
              if (isInternalChannel) {
                this.internalChatParticipants = [
                  newActionUpdate,
                  ...this.internalChatParticipants.filter(p => p.channelId !== newActionUpdate.channelId)
                ];
                this.totalTeamChatNewCount = Math.max(this.totalTeamChatNewCount, 1);
                this.scheduleChatRefresh(true);
              } else {
                this.externalChatParticipants = [
                  newActionUpdate,
                  ...this.externalChatParticipants.filter(p => p.channelId !== newActionUpdate.channelId)
                ];
                this.totalWhatsappNewCount = Math.max(this.totalWhatsappNewCount, 1);
                this.scheduleChatRefresh(false);
              }

              // Debounce rapid-fire events for same channel (2s window)
              const now = Date.now();
              if (newActionUpdate.channelId === this.lastNotifiedChannelId && (now - this.lastNotifiedAt) < 2000) {
                return;
              }
              this.lastNotifiedChannelId = newActionUpdate.channelId;
              this.lastNotifiedAt = now;

              if (!isInternalChannel) {
                console.log("this.isVisible value is ", this.isVisible);
                console.log("play audio");
                this.alertSound.play();
              }
              else if (this.shouldChimeForInternalChat(newActionUpdate.channelId)) {
                console.log("play audio");
                this.alertSoundTeamChat.play();
              }
            }
          }
        },
        error: err => this.logger.error('OnUpdateChatParticipantListener error', err)
      },
      { description: 'default-layout:OnUpdateChatParticipant' }
    );

    if (this.activeAccount) {
      if (this.sub_gmeet_update && !this.sub_gmeet_update.closed) {
        this.sub_gmeet_update.unsubscribe();
      }
      this.sub_gmeet_update = this.graphqlSubManager.managedSubscribe(
        () => this.api.OnUpdateSpecificEngagementTypeAccountLevelListener(this.activeAccount.accountId, EngagementType.VIDEO),
        {
          next: (event: any) => {
            if (this.sampleDataModeEnabled) return;
            if (event) {
              this.logger.log("event received on OnUpdateSpecificEngagementTypeAccountLevelListener subscription:", event)
              let data = event.value?.data?.onUpdateSpecificEngagementTypeAccountLevel;
              if (data)
                this.checkForLiveVideoCalls();
            }
          },
          error: err => this.logger.error('OnUpdateSpecificEngagementTypeAccountLevelListener error', err)
        },
        { description: 'default-layout:OnUpdateSpecificEngagementTypeAccountLevel' }
      );
    }

    if (!isResubscribe) {
      this.webCallIdSubscription = this.dataService.getWebCallId().subscribe((webCallIdParam: any) => {
        this.webCallId = webCallIdParam;
      });

      this.currentTimeSubscription = this.dataService.getCurrentTime().subscribe((time_param: any) => {
        if (time_param) {
          if ((time_param - this.lastInCallUpdatedAtDate) > 35000 && this.currentSnackBar)
            this.closeSnackBar();
        }
      });

      this.totalWhatsappNewCountSubscription = this.dataService.getTotalWhatsappNewCount().subscribe((count_param: number) => {
        if (this.sampleDataModeEnabled) return;
        console.log("total new whatsapp char count totalWhatsappNewCount ", count_param);
        this.totalWhatsappNewCount = count_param;
        if (!this.totalWhatsappNewCount || this.totalWhatsappNewCount == 0) {
          resetFavicon();
        }
      });

      this.totalTeamChatNewCountSubscription = this.dataService.getTotalTeamChatNewCount().subscribe((count_param_team: number) => {
        if (this.sampleDataModeEnabled) return;
        console.log("total new whatsapp char count totalWhatsappNewCount ", count_param_team);
        this.totalTeamChatNewCount = count_param_team;
      });

      this.lastViewedChatNotificationSubscription = this.dataService.getLastViewedChatNotification().subscribe((chat_seen_param: string) => {
        if (chat_seen_param) {
          this.lastViewedChatNotification = chat_seen_param;
        }
      });

      // Subscribe to users refresh trigger (for forcing fresh user data from child components)
      this.usersRefreshSubscription = this.dataService.getUsersRefresh().subscribe(() => {
        if (this.sampleDataModeEnabled) return;
        this.getAllUsersInAccount(true); // Force refresh bypasses cache
      });

      this.loadQuickInboxDismissedAt().then(() => {
        this.getNewChatsAsParticipant(false);
        this.getNewChatsAsParticipantInternal(false);
      });

      this.loadOwnedSupportAccounts();
    }
  }

  private loadOwnedSupportAccounts(): void {
    const account = this.activeAccount;
    if (!account || !this.salesmaxSupportAccounts.isSalesmaxAccount(account.accountId)) {
      this.ownedSupportAccountIds = null;
      return;
    }
    this.salesmaxSupportAccounts.getOwnedAccountIds(account.accountId, account.userId)
      .then(ids => {
        // Ignore if the active account changed while the fetch was in flight.
        if (this.activeAccount?.accountId === account.accountId && this.activeAccount?.userId === account.userId) {
          this.ownedSupportAccountIds = ids;
        }
      })
      .catch(e => this.logger.error('Failed to load owned support accounts', e));
  }

  /**
   * Whether the team-chat chime should sound for an internal-channel message.
   * Normal team chats always chime. Support chats chime only when the message is
   * on a customer account this employee owns. Fails open (chimes) while the owned
   * set is still loading so early pings on own accounts are not missed.
   */
  private shouldChimeForInternalChat(channelId: string): boolean {
    if (!this.salesmaxSupportAccounts.isSupportChannelId(channelId)) {
      return true;
    }
    if (this.ownedSupportAccountIds === null) {
      return true;
    }
    const accountId = this.salesmaxSupportAccounts.deriveSalesmaxAccountId(channelId);
    return !!accountId && this.ownedSupportAccountIds.has(accountId);
  }

  private async loadQuickInboxDismissedAt(): Promise<void> {
    if (!this.activeAccount) return;
    try {
      const key = `quick_inbox_dismissed_at_${this.activeAccount.accountId}_${this.activeAccount.userId}`;
      const stored = await localforage.getItem<string>(key);
      if (stored) {
        this.lastQuickInboxDismissedAt = stored;
      }
    } catch (e) {
      console.error('Error loading quick-inbox dismissed timestamp', e);
    }
  }

  onQuickInboxDismissed(lastDismissedAt: string): void {
    this.lastQuickInboxDismissedAt = lastDismissedAt;
  }

  onQuickInboxRefresh(): void {
    this.getNewChatsAsParticipant(false);
    this.getNewChatsAsParticipantInternal(false);
  }

  async checkForLiveVideoCalls(): Promise<void> {
    this.liveVideoCall = 0;
    if (this.sampleDataModeEnabled) return;
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (account && sessionKey && (account.authorizationLevel == AuthorizationLevel.SUPERADMIN || account.authorizationLevel == AuthorizationLevel.ADMIN)) {
      const requestEpoch = this.accountRequestEpoch;
      let f = <SearchableEngagementFilterInput>{}
      f.accountId = { eq: account.accountId };
      f.engagementType = { eq: EngagementType.VIDEO };
      f.videoCallOutcome = { eq: "STARTED" };
      let sortCriteria = <SearchableEngagementSortInput>{};
      sortCriteria = { field: SearchableEngagementSortableFields.callStartTime, direction: SearchableSortDirection.desc }
      try {
        const event = await this.api.SearchEngagementsMinimal(f, sortCriteria, 1, null);
        if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
          return;
        }
        if (event && event.total) {
          this.liveVideoCall = event.total;
        }
        else {
          this.liveVideoCall = 0;
        }
      } catch (e) {
        if (this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
          console.log('Error Fetching Tasks', e);
        }
      }
    }
  }


  playAudio() {
    if (this.sampleDataModeEnabled) return;
    this.playButton.click();
  }

  playAudioTeamChat() {
    if (this.sampleDataModeEnabled) return;
    this.playButtonTeamChat.click();
  }

  private scheduleChatRefresh(isInternalChannel: boolean): void {
    if (this.sampleDataModeEnabled) return;
    if (isInternalChannel) {
      if (this.internalChatRefreshTimer) {
        window.clearTimeout(this.internalChatRefreshTimer);
      }
      this.internalChatRefreshTimer = window.setTimeout(() => {
        this.internalChatRefreshTimer = null;
        this.getNewChatsAsParticipantInternal(true);
      }, this.chatRefreshDelayMs);
      return;
    }

    if (this.externalChatRefreshTimer) {
      window.clearTimeout(this.externalChatRefreshTimer);
    }
    this.externalChatRefreshTimer = window.setTimeout(() => {
      this.externalChatRefreshTimer = null;
      this.getNewChatsAsParticipant(true);
    }, this.chatRefreshDelayMs);
  }

  private clearPendingChatRefreshTimers(): void {
    if (this.externalChatRefreshTimer) {
      window.clearTimeout(this.externalChatRefreshTimer);
      this.externalChatRefreshTimer = null;
    }
    if (this.internalChatRefreshTimer) {
      window.clearTimeout(this.internalChatRefreshTimer);
      this.internalChatRefreshTimer = null;
    }
  }

  isTodaysTask(eng: Engagement): boolean {
    let toReturn = false;
    if (eng.engagementType == EngagementType.TASK && eng.engagementStatus == EngagementStatus.ACTIVE) {
      var start = new Date();
      start.setHours(0, 0, 0, 0);
      var end = new Date();
      end.setHours(23, 59, 59, 999);
      if (eng.dueDateTime >= start.toISOString() && eng.dueDateTime <= end.toISOString())
        toReturn = true;
    }
    return toReturn;
  }

  isOverdueTask(eng: Engagement): boolean {
    let toReturn = false;
    if (eng.engagementType == EngagementType.TASK && eng.engagementStatus == EngagementStatus.ACTIVE) {
      var start = new Date();
      start.setHours(0, 0, 0, 0);
      if (eng.dueDateTime < start.toISOString())
        toReturn = true;
    }
    return toReturn;
  }

  checkIfNotification(event: Activity): boolean {
    return true;
  }

  async getAllTeams(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    try {
      const event = await this.api.TeamsByAccount(account.accountId);
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      this.logger.log('Teams Fetched : ', event);
      if (event && event.items)
        this.fetchedTeams = event.items;
      this.dataService.setTeams(_.cloneDeep(this.fetchedTeams), sessionKey);
      let teamMap = keyBy(this.fetchedTeams, 'id')
      this.dataService.setMapAllTeamsInAccount(_.cloneDeep(teamMap), sessionKey);

    } catch (e) {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      this.logger.log('Error Fetching Teams', e);
      this.showErrorInToastr(e, 'Error Fetching Teams');
    }
  }

  async getAllTeamMemberships(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    try {
      const memberships = await fetchAllMembersByTeam(this.api, account.accountId);
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      this.logger.log('Team Memberships Fetched. Count:', memberships.length);
      this.fetchedTeamMemberships = memberships;
      this.fetchedTeamMemberships = this.fetchedTeamMemberships.filter(teamMembership => teamMembership.team !== null && teamMembership.hasOwnProperty('team'));
      this.dataService.setAllTeamMemberships(_.cloneDeep(this.fetchedTeamMemberships), sessionKey);
      this.allDirectTeams = (_filter(this.fetchedTeamMemberships, { userId: this.userId })) as TeamMember[]
      this.directTeamsAsTL = (_filter(this.fetchedTeamMemberships, { userId: this.userId, teamRole: TeamRole.TEAM_LEADER })) as TeamMember[]
      if (this.activeAccount && this.activeAccount.authorizationLevel == AuthorizationLevel.MANAGER) {
        this.setDashboardGlobalFilter("manager");
      }
      this.directTeamsAsReportee = (_filter(this.fetchedTeamMemberships, { userId: this.userId, teamRole: TeamRole.REPORTEE })) as TeamMember[]
      for (var _i = 0; _i < this.directTeamsAsTL.length; _i++)
        this.directReportees = this.directReportees.concat(_filter(this.fetchedTeamMemberships, { teamId: this.directTeamsAsTL[_i].teamId }) as TeamMember[])
      if (this.fetchedUserAuthorization.teamsAsLead) {
        for (var _i = 0; _i < this.fetchedUserAuthorization.teamsAsLead.length; _i++) {
          if (!find(this.directTeamsAsTL, { teamId: this.fetchedUserAuthorization.teamsAsLead[_i] })) {
            this.indirectTeamsAsLead = this.indirectTeamsAsLead.concat((_filter(this.fetchedTeams, { teamId: this.fetchedUserAuthorization.teamsAsLead[_i] })) as Team[])
            this.inDirectReportees = this.inDirectReportees.concat(_filter(this.fetchedTeamMemberships, { teamId: this.fetchedUserAuthorization.teamsAsLead[_i], teamRole: TeamRole.REPORTEE }) as TeamMember[])
          }
        }
      }
      this.logger.log("Direct Team as Leader :", this.directTeamsAsTL);
      this.logger.log("Direct Team as Reportee :", this.directTeamsAsReportee);
      this.logger.log("InDirect Team as Leader :", this.indirectTeamsAsLead);
      this.logger.log("Direct Reportees :", this.directReportees);
      this.logger.log("InDirect Reportees :", this.inDirectReportees);
      this.dataService.setAllDirectTeams(_.cloneDeep(this.allDirectTeams), sessionKey);
      this.dataService.setDirectTeamsAsTL(_.cloneDeep(this.directTeamsAsTL), sessionKey);
      this.dataService.setDirectTeamsAsReportee(_.cloneDeep(this.directTeamsAsReportee), sessionKey);
      this.dataService.setIndirectTeamsAsLead(_.cloneDeep(this.indirectTeamsAsLead), sessionKey);
      this.dataService.setDirectReportees(_.cloneDeep(this.directReportees), sessionKey);
      if (this.activeAccount && this.activeAccount.authorizationLevel == AuthorizationLevel.MANAGER)
        this.allUsers = this.directReportees;
      this.dataService.setInDirectReportees(_.cloneDeep(this.inDirectReportees), sessionKey);
    } catch (e) {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      this.logger.log('Error Fetching Teams', e);
      this.showErrorInToastr(e, 'Error Fetching Teams');
    }
  }

  async getUserAuthorization(): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;
    try {
      const event = await this.api.GetAuthorizationByUserAccount(account.accountId, { eq: this.userId });
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      if (event && event.items && event.items.length == 1) {
        this.logger.log("fetched user authorizations :", event)
        this.fetchedUserAuthorization = event.items[0];
        this.dataService.setUserAuthorization(_.cloneDeep(this.fetchedUserAuthorization), sessionKey);
        this.cleanupExpiredLocalforageEntries();
        void this.getAllUsersInAccount();
        // this.getRecentMentions();
        this.getToBeAssignedContacts();
        if (this.activeAccount.account.accountType != AccountType.INDIVIDUAL) {
          void this.getAllTeams();
          void this.getAllTeamMemberships();
        }
      }
      else {
        this.logger.log("No or more than one user authorization found for the given account and user");
      }
    } catch (e) {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      this.logger.log('Error Fetching User Authorization', e);
      this.showErrorInToastr(e, 'Error Fetching User Authorization');
    }
  }

  getToBeAssignedContacts() {

  }

  onSelect(tab: string) {
    this.activeAsideTab = tab;
    this.memberStatusNeedsToBeRefreshed = false;
    if (this.sampleDataModeEnabled) {
      this.clearRealBusinessShellState();
      return;
    }
    switch (tab) {
      case 'fresh':
        this.getFreshLeads();
        break;
      case 'task':
        this.newTaskCount = 0;
        this.getTodaysTasks();
        this.getOverdueTasks();
        break;
      case 'activity':
        this.getRecentActivities();
        this.newActivityCount = 0;
        break;
      case 'status':
        this.memberStatusNeedsToBeRefreshed = true;
        this.getMemberStatus();
        break;
      case 'unassigned':
        this.getUnassignedLeads();
        this.getUnassignedTasks();
        this.newPendingAssignmentCount = 0;
        break;
    }
  }

  clearMissedAction(op: MissedOpportunities) {
    console.log("clearMissedAction function called with missed opportunity :", op);
    let eng = op.relatedEngagement;
    let contactUnderProcessing = op.contact;
    let contactEntityUnderProcessing: Entity = { entityID: null, entityIDType: null, entitySource: null, entityType: null };
    contactEntityUnderProcessing.entityID = contactUnderProcessing.id;
    contactEntityUnderProcessing.entityType = 'CONTACT'
    switch (op.missedOpportunityType) {
      case 'VISIT_DISPOSITION_NOT_RECORDED':
        this.dialogService.open(LogMeetingOutcomeComponent, {
          data: { engagement: eng }
        });
        break;
      case 'VISIT_NOT_ADDED':
        this.dialogService.open(LogMeetingComponent, {
          data: { entity: contactEntityUnderProcessing, displayName: contactUnderProcessing.name, preSelectedContact: contactUnderProcessing }
        });
        break;
      case 'CALL_DISPOSITION_NOT_RECORDED':
        this.dialogService.open(LogCallComponent, {
          data: { engagement: eng }
        });
        break;
    }
  }

  getRecentActivities() {
    if (this.sampleDataModeEnabled) return;
    let f = <SearchableActivityFilterInput>{};
    let s = <SearchableActivitySortInput>{};
    s.field = SearchableActivitySortableFields.updatedAt;
    s.direction = SearchableSortDirection.desc;

    f.accountId = { eq: this.activeAccount.accountId };
    if (this.activeAccount && this.activeAccount.authorizationLevel == AuthorizationLevel.MANAGER && this.selectedTeam.length > 0) {
      const team_filter = {
        or: this.selectedTeam.map(team => ({
          primaryTeamId: { eq: team.id }
        }))
      };
      if (!_.isEmpty(team_filter)) {
        f = <SearchableActivityFilterInput>{ "and": [f, team_filter] }
      }
    }
    else {
      f.ownerId = { eq: this.activeAccount.userId };
    }
    this.api.SearchActivitys(f, s, 30, undefined).then(event => {
      this.logger.log('My Activities Fetched : ', event);
      if (event && event.items) {
        this.recentActivities = <Activity[]>event.items;
        this.checkForBellNotification();
      }
    })
      .catch(e => {
        this.logger.log('Error Fetching Own Activities', e);
        this.showErrorInToastr(e, 'Error Fetching Own Activities')
      });
  }

  checkForBellNotification() {
    for (let _i = 0; _i < this.recentActivities.length; _i++) {
      let isNotification = this.checkIfNotification(this.recentActivities[_i])
      if (isNotification)
        this.notifications.push(this.recentActivities[_i]);
    }
  }

  getTodaysTasks() {
    if (this.sampleDataModeEnabled) return;
    let sort = <SearchableEngagementSortInput>{};
    sort = { field: SearchableEngagementSortableFields.updatedAt, direction: SearchableSortDirection.asc };
    let localFilter = <SearchableEngagementFilterInput>{}
    var start = new Date();
    start.setHours(0, 0, 0, 0);
    var end = new Date();
    end.setHours(23, 59, 59, 999);
    localFilter = {
      or: [{ and: [{ engagementStatus: { eq: EngagementStatus.ACTIVE } }, { dueDateTime: { gte: start.toISOString() } }, { dueDateTime: { lt: end.toISOString() } }, { nextFollowUpOn: { exists: false } }] },
      { and: [{ engagementStatus: { eq: EngagementStatus.ACTIVE } }, { nextFollowUpOn: { gte: start.toISOString() } }, { nextFollowUpOn: { lt: end.toISOString() } }, { nextFollowUpOn: { exists: true } }] }
      ]
    }
    localFilter.accountId = { eq: this.activeAccount.accountId };
    this.api.SearchEngagementsOnlyTask(localFilter, sort, 25, undefined).then(event => {
      this.logger.log('My Tasks Due Today Fetched : ', event);
      this.myTasksDueToday = <Engagement[]>event.items;
    })
      .catch(e => {
        this.logger.log('Error Fetching My Due Tasks', e);
        this.showErrorInToastr(e, 'Error Fetching My Due Tasks')
      });
  }

  getOverdueTasks() {
    if (this.sampleDataModeEnabled) return;
    let sort = <SearchableEngagementSortInput>{};
    sort = { field: SearchableEngagementSortableFields.updatedAt, direction: SearchableSortDirection.asc };
    let localFilter = <SearchableEngagementFilterInput>{}
    var start = new Date();
    start.setHours(0, 0, 0, 0);
    localFilter = {
      or: [{ and: [{ engagementStatus: { eq: EngagementStatus.ACTIVE } }, { dueDateTime: { lt: start.toISOString() } }, { nextFollowUpOn: { exists: false } }] },
      { and: [{ engagementStatus: { eq: EngagementStatus.ACTIVE } }, { nextFollowUpOn: { lt: start.toISOString() } }, { nextFollowUpOn: { exists: true } }] }
      ]
    }
    localFilter.accountId = { eq: this.activeAccount.accountId };
    this.api.SearchEngagementsOnlyTask(localFilter, sort, 25, undefined).then(event => {
      this.logger.log('My Tasks Overdue Fetched : ', event);
      this.myTasksOverdue = <Engagement[]>event.items;
    })
      .catch(e => {
        this.logger.log('Error Fetching My Overdue Tasks', e);
        this.showErrorInToastr(e, 'Error Fetching My Overdue Tasks')
      });
  }


  getRecentMentions() {
    let o = <ModelMentionUserMembershipByMentionedUserIdCompositeKeyConditionInput>{};
    o = { beginsWith: { accountId: this.activeAccount.accountId } }
    this.api.GetCommentsByMentionedUser(this.activeAccount.userId, o, ModelSortDirection.DESC, undefined, 20, undefined).then(event => {
      this.logger.log('Recent Mentions Fetched : ', event);
      if (event && event.items) {
        this.recentMentions = event.items;
      }
    })
      .catch(e => {
        this.logger.log('Error Fetching Recent Mentions', e);
        this.showErrorInToastr(e, 'Error Fetching Recent Mentions')
      });
  }

  acceptMembership(membership: AccountMembership) {
    if (!this.accountMembershipUpdateInitiated) {
      this.accountMembershipUpdateInitiated = true;
      var input = <UpdateAccountMembershipInput>{}
      input.id = membership.id
      input.updateAction = UpdateAccountMembershipAction.ACCEPT_MEMBERSHIP
      if (membership.accountEmail == null)
        input.accountEmail = this.registeredUser.registeredEmail
      this.api.UpdateAccountMembership(input).then(event => {
        this.accountMembershipUpdateInitiated = false;
        this.logger.log('Account Membership Accepted : ', event);
        this.accountsInNeedOfAcceptance.splice(0, 1)

      })
        .catch(e => {
          this.accountMembershipUpdateInitiated = false;
          this.logger.log('Error in accepting account membership', e);
          this.showErrorInToastr(e, 'Error in accepting account membership')
        });
    }
  }


  approveNumberChange(membership: AccountMembership) {
    if (!this.accountMembershipUpdateInitiated) {
      this.accountMembershipUpdateInitiated = true;
      var input = <UpdateAccountMembershipInput>{}
      input.id = membership.id
      input.updateAction = UpdateAccountMembershipAction.APPROVE_NUMBER_CHANGE
      this.api.UpdateAccountMembership(input).then(event => {
        this.accountMembershipUpdateInitiated = false;
        this.logger.log('Account Membership Accepted : ', event);
        this.accountsInNeedOfNumberChangeApproval.splice(0, 1)

      })
        .catch(e => {
          this.accountMembershipUpdateInitiated = false;
          this.logger.log('Error in accepting account membership', e);
          this.showErrorInToastr(e, 'Error in accepting account membership')
        });
    }
  }

  rejectMembership(membership: AccountMembership) {
    if (!this.accountMembershipUpdateInitiated) {
      this.accountMembershipUpdateInitiated = true;
      var input = <UpdateAccountMembershipInput>{}
      input.id = membership.id
      input.updateAction = UpdateAccountMembershipAction.REJECT_MEMBERSHIP
      if (membership.accountEmail == null)
        input.accountEmail = this.registeredUser.registeredEmail
      this.api.UpdateAccountMembership(input).then(event => {
        this.accountMembershipUpdateInitiated = false;
        this.logger.log('Account Membership Accepted : ', event);
        this.accountsInNeedOfAcceptance.splice(0, 1)

      })
        .catch(e => {
          this.accountMembershipUpdateInitiated = false;
          this.logger.log('Error in accepting account membership', e);
          this.showErrorInToastr(e, 'Error in accepting account membership')
        });
    }
  }

  async getAllUsersInAccount(forceRefresh = false): Promise<void> {
    const account = this.activeAccount;
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!account || !sessionKey) {
      return;
    }
    const requestEpoch = this.accountRequestEpoch;

    const tsKey = `${this.USERS_CACHE_TS_PREFIX}${account.accountId}`;
    const dataKey = `${this.USERS_CACHE_DATA_PREFIX}${account.accountId}`;

    // Check cache validity before fetching
    if (!forceRefresh) {
      const lastFetchedAt = await localforage.getItem<number>(tsKey);
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      const now = Date.now();
      const cacheExpired = !lastFetchedAt || (now - lastFetchedAt > this.usersCacheTtlMs);

      if (!cacheExpired && lastFetchedAt) {
        // Check if any account changes occurred after cache time
        const lastFetchedIso = new Date(lastFetchedAt).toISOString();
        const recentChanges = await this.api.GetAccountChangesByAccount(
          account.accountId,
          { gt: lastFetchedIso }, // updatedAt > lastFetchedAt
          ModelSortDirection.DESC,
          { entityType: { eq: EntityType.AccountMembership } },
          1 // Only need 1 to know if changes exist
        );
        if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
          return;
        }

        const hasRecentChanges = recentChanges?.items?.length > 0;
        if (!hasRecentChanges) {
          // No changes since cache - try to use cached data
          const cachedUsers = await localforage.getItem<AccountMembership[]>(dataKey);
          if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
            return;
          }
          if (cachedUsers && cachedUsers.length > 0) {
            this.logger.log('Users cache valid for account (no recent changes), using cached data. Count:', cachedUsers.length);
            this.processAndSetUsers(cachedUsers, sessionKey);
            return;
          }
        } else {
          this.logger.log('Account changes detected since last cache, invalidating cache');
        }
      }
    }

    // Cache invalid, expired, has changes, or force refresh - fetch from API
    await this.fetchUsersFromApi(account, sessionKey, requestEpoch, tsKey, dataKey);
  }

  private async fetchUsersFromApi(account: AccountMembership, sessionKey: string, requestEpoch: number, tsKey: string, dataKey: string): Promise<void> {
    try {
      const users = await fetchAllUsersByAccount(this.api, account.accountId);
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      this.logger.log('All Users Fetched for the account. Count:', users.length);
      // Save to localforage for future reloads
      localforage.setItem(tsKey, Date.now());
      localforage.setItem(dataKey, users);
      // Process and set in DataShareService
      this.processAndSetUsers(users, sessionKey);
    } catch (e) {
      if (!this.isAccountRequestCurrent(sessionKey, requestEpoch)) {
        return;
      }
      this.trialAppStatusRefreshing = false;
      this.logger.log('Error Fetching Users for the account', e);
      this.showErrorInToastr(e, 'Error Fetching Users');
    }
  }

  private processAndSetUsers(users: AccountMembership[], sessionKey: string) {
    this.trialAppStatusRefreshing = false;
    this.fetchedUsers = users;
    let fectehdUserCopy = _.cloneDeep(this.fetchedUsers);
    this.fetchedActiveUsers = fectehdUserCopy.filter(function (el) {
      return el.userAccountStatus == UserStatus.ACTIVE;
    });
    this.dataService.setAllUsersInAccount(_.cloneDeep(this.fetchedActiveUsers), sessionKey);
    if (this.activeAccount && (this.activeAccount.authorizationLevel == AuthorizationLevel.SUPERADMIN || this.activeAccount.authorizationLevel == AuthorizationLevel.ADMIN))
      this.allUsers = this.fetchedActiveUsers;
    // Always refresh member status when users are fetched (e.g., on workspace switch)
    this.memberStatusNeedsToBeRefreshed = true;
    this.getMemberStatus();
    let allUsers = this.fetchedActiveUsers.map(item => item.user)
    allUsers = allUsers.map(item => {
      if (item && item.profilePictureUrl !== null && item.profilePictureUrl !== undefined) {
        // Skip if already transformed (has thumbnail/ prefix)
        if (item.profilePictureUrl.includes('thumbnail/')) {
          return item;
        }
        if (item.profilePictureUrl.startsWith("public/")) {
          item.profilePictureUrl = item.profilePictureUrl.replace("public/", "");
          item.profilePictureUrl = "public/thumbnail/" + item.profilePictureUrl + ".png";
        }
        else {
          item.profilePictureUrl = "thumbnail/" + item.profilePictureUrl + ".png";
        }
      }
      return item;
    });
    let userMap = keyBy(allUsers, 'id')
    this.dataService.setMapAllUsersInAccount(_.cloneDeep(userMap), sessionKey);
    this.dataService.setAllIncludingInactiveUsersInAccount(_.cloneDeep(this.fetchedUsers), sessionKey);
    this.accountsInNeedOfNumberChangeApproval = _filter(this.fetchedUsers, function (item) {
      return item.userAccountStatus == UserStatus.NUMBER_CHANGED;
    });
    allUsers = this.fetchedUsers.map(item => item.user)
    allUsers = allUsers.map(item => {
      if (item && item.profilePictureUrl !== null && item.profilePictureUrl !== undefined) {
        // Skip if already transformed (has thumbnail/ prefix)
        if (item.profilePictureUrl.includes('thumbnail/')) {
          return item;
        }
        if (item.profilePictureUrl.startsWith("public/")) {
          item.profilePictureUrl = item.profilePictureUrl.replace("public/", "");
          item.profilePictureUrl = "public/thumbnail/" + item.profilePictureUrl + ".png";
        }
        else {
          item.profilePictureUrl = "thumbnail/" + item.profilePictureUrl + ".png";
        }
      }
      return item;
    });
    userMap = keyBy(allUsers, 'id')
    this.dataService.setMapAllUsersInAccountIncludingInactive(_.cloneDeep(userMap), sessionKey)
    this.userMap = userMap;
    this.updateTrialActivationProgress(this.fetchedUsers);
    this.runDailyHealthCheck();
  }

  private runDailyHealthCheck(): void {
    if (!this.activeAccount || this.activeAccount.authorizationLevel !== AuthorizationLevel.SUPERADMIN) return;
    const today = new Date().toISOString().slice(0, 10);
    const prefix = `${this.HEALTH_KEY_PREFIX}${this.activeAccount.accountId}_${this.activeAccount.userId}`;
    const lastDismissed = localStorage.getItem(`${prefix}_dismissed`);
    if (lastDismissed === today) return;

    const permissionsMap = this.appHealthService.parseAccountPermissions(this.activeAccount?.account?.permissions);
    const report = this.appHealthService.diagnoseAll(this.fetchedUsers, permissionsMap);
    const count = report.counts.needsAction + report.counts.notInstalled;
    localStorage.setItem(`${prefix}_lastRun`, today);
    localStorage.setItem(`${prefix}_count`, String(count));

    if (count > 0) {
      this.healthBannerIssueCount = count;
      this.showHealthBanner = true;
      this.startHealthBannerCountdown();
    }
  }

  private startHealthBannerCountdown(): void {
    if (this.healthBannerTimer || !this.showHealthBanner || !this.onDashboard) return;
    this.healthBannerCountdown = this.HEALTH_BANNER_AUTO_HIDE_SECONDS;
    this.healthBannerTimer = setInterval(() => {
      this.healthBannerCountdown--;
      if (this.healthBannerCountdown <= 0) {
        this.dismissHealthBanner();
      }
    }, 1000);
  }

  private stopHealthBannerCountdown(): void {
    if (this.healthBannerTimer) {
      clearInterval(this.healthBannerTimer);
      this.healthBannerTimer = null;
    }
  }

  dismissHealthBanner(): void {
    this.stopHealthBannerCountdown();
    this.showHealthBanner = false;
    if (!this.activeAccount) return;
    const today = new Date().toISOString().slice(0, 10);
    const prefix = `${this.HEALTH_KEY_PREFIX}${this.activeAccount.accountId}_${this.activeAccount.userId}`;
    localStorage.setItem(`${prefix}_dismissed`, today);
  }

  goToAppHealth(): void {
    this.dismissHealthBanner();
    this.router.navigate(['/admin/users'], { queryParams: { tab: 'app' } });
  }

  // Recursively drop sidebar items (and children) whose url the current account
  // cannot reach, per the shared route-access policy. Returns new arrays/objects so
  // the imported nav definitions are never mutated.
  private filterNavByAccess(items: any[]): any[] {
    if (!Array.isArray(items)) return items;
    return items
      .filter(item => !item?.url || canAccessNavRoute(String(item.url), this.activeAccount))
      .map(item => (item?.children ? { ...item, children: this.filterNavByAccess(item.children) } : item));
  }

  updateNav() {
    // Shallow clone object + shallow clone arrays (ContextualTab objects are immutable)
    this.contextualMap = Object.fromEntries(
      Object.entries(this.contextualMapOriginal).map(([key, value]) => [key, [...value]])
    );
    if (this.activeAccount && this.activeAccount.authorizationLevel == AuthorizationLevel.SUPERADMIN) {
      this.speedDialFabButtons = this.speedDialFabButtonsAdmin;
    }
    else {
      this.speedDialFabButtons = this.speedDialFabButtonsNonAdmin;
    }
    this.quickActionsService.setActiveAccount(this.activeAccount);
    if (this.activeAccount.accountId == environment.salesmaxAccountId) {
      this.isDemoEnabledAccount = true;
    }
    else {
      this.isDemoEnabledAccount = false;
      this.demoModeEnabled = false;
      const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
      if (sessionKey) {
        this.dataService.setDemoMode(false, sessionKey);
      }
    }

    const supportSection = {
      route: '/salesmax-support/accounts',
      label: '',
      icon: 'support_agent',
      sectionKey: 'support'
    };

    if (
      this.activeAccount.accountId === environment.salesmaxAccountId
    ) {
      const alreadyExists = this.mainSections.some(section => section.sectionKey === 'support');
      if (!alreadyExists) {
        this.mainSections.push(supportSection);
      }
    } else {
      // Remove Support if present
      this.mainSections = this.mainSections.filter(section => section.sectionKey !== 'support');
    }

    // Work Floor: feature-flagged, next to To-dos.
    if (isFeatureEnabled('workCockpit', this.activeAccount)) {
      this.mainSections = this.mainSections.filter(section => section.sectionKey !== 'work');
      const todoIndex = this.mainSections.findIndex(section => section.sectionKey === 'todo');
      this.mainSections.splice(todoIndex + 1, 0, {
        route: '/work/floor',
        label: 'Work',
        icon: 'assignment_turned_in',
        sectionKey: 'work'
      });
    } else {
      this.mainSections = this.mainSections.filter(section => section.sectionKey !== 'work');
    }


    // Hide contextual tabs the current account cannot actually reach, using the same
    // policy the route guard uses (so no tab redirects into an error). Runs for all
    // roles: members lose the blockMembers/documents/custom routes; managers lose
    // custom-report (customReportAccess); admins keep everything. updateNav rebuilds
    // contextualMap from the pristine original each call, so this never accumulates.
    const filteredMap: Record<string, ContextualTab[]> = {};
    for (const sectionKey in this.contextualMap) {
      const options = this.contextualMap[sectionKey];
      filteredMap[sectionKey] = options.filter(tab => canAccessNavRoute(String(tab.route), this.activeAccount));
    }
    this.contextualMap = filteredMap;

    const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
    if (sessionKey) {
      this.dataService.setDateFormatPreference(this.activeAccount?.account?.dateTimeViewStyle, sessionKey);
    }
    GlobalPreferenceService.getInstance().setFormatPreference(this.activeAccount?.account?.dateTimeViewStyle);

    if (this.activeAccount.account.permissions && this.activeAccount.account.permissions.length > 0) {
      let permissions = JSON.parse(this.activeAccount.account.permissions[0]);
      let closed_leads_permission = permissions["hide-closed-leads"];
      if (closed_leads_permission && closed_leads_permission[this.activeAccount.authorizationLevel.toLowerCase()] == true) {
        this.contextualMap['leads'] = this.contextualMap['leads'].filter(
          item => item.label !== 'Worked Leads'
        );
        this.contextualOptions = this.contextualOptions.filter(
          item => item.label !== 'Worked Leads'
        );
      }
      let lead_source_permission = permissions["hide-lead-sources"];
      if (lead_source_permission && lead_source_permission[this.activeAccount.authorizationLevel.toLowerCase()] == true) {
        this.contextualMap['dashboard'] = this.contextualMap['dashboard'].filter(
          item => item.label !== 'Source Reports' && item.label !== 'User Leads'
        );
      }
    }

    //Handling the nav scenario
    if (this.activeAccount.accountId == environment.salesmaxAccountId)
      this.navItems = navItemsSalesmax
    else if (this.activeAccount.account && this.activeAccount.account.enableCustomCharts && this.activeAccount.authorizationLevel != AuthorizationLevel.MEMBER)
      this.navItems = navItemsAnalysis

    if (this.activeAccount.authorizationLevel == AuthorizationLevel.MEMBER)
      this.navItems = navItemsRep
    else
      this.navItems = navItems

    // Hide sidebar items the account cannot reach (same policy as the guard), so there
    // are no dead links that redirect (e.g. Custom Reports for non-admin/non-allowlisted).
    this.navItems = this.filterNavByAccess(this.navItems);

    if (this.activeAccount.account.permissions && this.activeAccount.account.permissions.length > 0) {
      let permissions = JSON.parse(this.activeAccount.account.permissions[0]);
      let closed_leads_permission = permissions["hide-closed-leads"];
      if (closed_leads_permission && closed_leads_permission[this.activeAccount.authorizationLevel.toLowerCase()] == true) {
        let matchingIndex = this.navItems.findIndex(item => item.name == "Leads");
        if (matchingIndex != null && matchingIndex != -1) {
          let children = this.navItems[matchingIndex].children;
          if (children && children.length > 0) {
            let positionIndex = children.findIndex(item => item.name == "Already Worked Leads");
            if (positionIndex != null && positionIndex != -1) {
              this.navItems[matchingIndex].children.splice(positionIndex, 1);
              this.navItems[matchingIndex].children = [...this.navItems[matchingIndex].children];
              this.navItems = [...this.navItems];
              console.log("final nav items is ", this.navItems);
            }
          }
        }
      }
      let lead_source_permission = permissions["hide-lead-sources"];
      if (lead_source_permission && lead_source_permission[this.activeAccount.authorizationLevel.toLowerCase()] == true) {
        let matchingIndex = this.navItems.findIndex(item => item.name == "Metrics");
        if (matchingIndex != null && matchingIndex != -1) {
          let children = this.navItems[matchingIndex].children;
          if (children && children.length > 0) {
            let positionIndex = children.findIndex(item => item.name == "Source Reports");
            if (positionIndex != null && positionIndex != -1) {
              this.navItems[matchingIndex].children.splice(positionIndex, 1);
              this.navItems[matchingIndex].children = [...this.navItems[matchingIndex].children];
              this.navItems = [...this.navItems];
              console.log("final nav items is ", this.navItems);
            }
          }

          let children2 = this.navItems[matchingIndex].children;
          if (children && children.length > 0) {
            let positionIndex = children.findIndex(item => item.name == "User Lead Position");
            if (positionIndex != null && positionIndex != -1) {
              this.navItems[matchingIndex].children.splice(positionIndex, 1);
              this.navItems[matchingIndex].children = [...this.navItems[matchingIndex].children];
              this.navItems = [...this.navItems];
              console.log("final nav items is ", this.navItems);
            }
          }
        }
      }
    }
  }



  ngOnDestroy(): void {
    this.componentDestroyed = true;
    this.invalidateAccountRequests();
    // Clear interval timer
    if (this.currentTimeInterval) {
      clearInterval(this.currentTimeInterval);
      this.currentTimeInterval = null;
    }
    this.stopHealthBannerCountdown();
    this.clearPendingChatRefreshTimers();
    this.clearPendingWebCallReplayTimer();
    this.clearTrialCountdownTimer();
    if (this.trialDashboardOrientationTimer != null) {
      window.clearTimeout(this.trialDashboardOrientationTimer);
      this.trialDashboardOrientationTimer = undefined;
    }

    this.visibilityChangeSubscription.unsubscribe();
    this.observer.disconnect();
    this.changes.disconnect();
    this.closeActiveSubscriptions();
    this.clearWorkspaceConfirmationTimers();
    this.pendingWorkspaceConfirmation = undefined;
    if (this.previousRouteSubscription && !this.previousRouteSubscription.closed)
      this.previousRouteSubscription.unsubscribe();

    if (this.totalWhatsappNewCountSubscription && !this.totalWhatsappNewCountSubscription.closed)
      this.totalWhatsappNewCountSubscription.unsubscribe();

    if (this.totalTeamChatNewCountSubscription && !this.totalTeamChatNewCountSubscription.closed)
      this.totalTeamChatNewCountSubscription.unsubscribe();

    if (this.lastViewedChatNotificationSubscription && !this.lastViewedChatNotificationSubscription.closed)
      this.lastViewedChatNotificationSubscription.unsubscribe();

    if (this.alertSound) {
      this.alertSound.pause();
      this.alertSound.removeEventListener('canplaythrough', this.playAudio);
      this.alertSound.src = '';
      this.alertSound = null;
    }
    if (this.alertSoundTeamChat) {
      this.alertSoundTeamChat.pause();
      this.alertSoundTeamChat.removeEventListener('canplaythrough', this.playAudioTeamChat);
      this.alertSoundTeamChat.src = '';
      this.alertSoundTeamChat = null;
    }
    // Clean up button elements
    if (this.playButton) {
      this.document.body.removeChild(this.playButton);
      this.playButton = null;
    }
    if (this.playButtonTeamChat) {
      this.document.body.removeChild(this.playButtonTeamChat);
      this.playButtonTeamChat = null;
    }
    if (this.upcomingTaskSnackBar) {
      this.upcomingTaskSnackBar.dismiss();
      this.upcomingTaskSnackBar = null;
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  closeActiveSubscriptions(): void {
    // Close all GraphQL subscriptions (managed by GraphqlSubscriptionManagerService)
    if (this.sub_memberStatus_update && !this.sub_memberStatus_update.closed)
      this.sub_memberStatus_update.unsubscribe();
    if (this.sub_web_calls && !this.sub_web_calls.closed)
      this.sub_web_calls.unsubscribe();
    if (this.sub_memberStatus_update_user && !this.sub_memberStatus_update_user.closed)
      this.sub_memberStatus_update_user.unsubscribe();
    if (this.sub_activity_create && !this.sub_activity_create.closed)
      this.sub_activity_create.unsubscribe();
    if (this.sub_engagement_create && !this.sub_engagement_create.closed)
      this.sub_engagement_create.unsubscribe();
    if (this.sub_engagement_update && !this.sub_engagement_update.closed)
      this.sub_engagement_update.unsubscribe();
    if (this.sub_account_update && !this.sub_account_update.closed)
      this.sub_account_update.unsubscribe();
    if (this.sub_account_update_by_user && !this.sub_account_update_by_user.closed)
      this.sub_account_update_by_user.unsubscribe();
    if (this.sub_entityActionDefinition_update && !this.sub_entityActionDefinition_update.closed)
      this.sub_entityActionDefinition_update.unsubscribe();
    if (this.sub_entityActionDefinition_create && !this.sub_entityActionDefinition_create.closed)
      this.sub_entityActionDefinition_create.unsubscribe();
    if (this.sub_chatParticipant_update && !this.sub_chatParticipant_update.closed)
      this.sub_chatParticipant_update.unsubscribe();
    if (this.sub_activity_contact_assigned && !this.sub_activity_contact_assigned.closed)
      this.sub_activity_contact_assigned.unsubscribe();
    if (this.sub_cloud_calls_create && !this.sub_cloud_calls_create.closed)
      this.sub_cloud_calls_create.unsubscribe();
    if (this.sub_cloud_calls_update && !this.sub_cloud_calls_update.closed)
      this.sub_cloud_calls_update.unsubscribe();
    if (this.sub_gmeet_update && !this.sub_gmeet_update.closed)
      this.sub_gmeet_update.unsubscribe();
    if (this.sub_user_account_update_create && !this.sub_user_account_update_create.closed)
      this.sub_user_account_update_create.unsubscribe();

    // Close data service subscriptions (these are RxJS observables, not GraphQL)
    if (this.currentTimeSubscription && !this.currentTimeSubscription.closed)
      this.currentTimeSubscription.unsubscribe();
    if (this.webCallIdSubscription && !this.webCallIdSubscription.closed)
      this.webCallIdSubscription.unsubscribe();
    if (this.totalWhatsappNewCountSubscription && !this.totalWhatsappNewCountSubscription.closed)
      this.totalWhatsappNewCountSubscription.unsubscribe();
    if (this.totalTeamChatNewCountSubscription && !this.totalTeamChatNewCountSubscription.closed)
      this.totalTeamChatNewCountSubscription.unsubscribe();
    if (this.lastViewedChatNotificationSubscription && !this.lastViewedChatNotificationSubscription.closed)
      this.lastViewedChatNotificationSubscription.unsubscribe();
    if (this.usersRefreshSubscription && !this.usersRefreshSubscription.closed)
      this.usersRefreshSubscription.unsubscribe();
  }

  createOrganzationButtonClicked(): void {
    this.dialogService.open(CreateTeamAccountComponent, {
    });
  }

  addMemberButtonClicked(): void {
    this.dialogService.open(AddEmployeeBulkComponent, {
      data: { accountMembership: this.activeAccount }
    }, 1);
  }

  showSearchDialog(event) {
    this.dialogService.open(SearchComponent, {}, 1);
  }

  openAdminActions() {
    let ref = this.dialogService.open(AdminActionsComponent, {}, 1);
    ref.afterClosed.pipe(take(1)).subscribe(result => {
      console.log('Dialog closed', result);
      if (result) {
        if (result == 'update-account') {
          this.updateAccount();
        }
        else if (result == 'update-account-default') {
          this.updateAccountDefault();
        }
      }
    })
  }

  openUserActions() {
    let ref = this.dialogService.open(UserActionsComponent, { data: { accounts: this.dropdownToChooseAccount } }, 1);
    ref.afterClosed.pipe(take(1)).subscribe(result => {
      console.log('Dialog closed', result);
      if (result != null) {
        if (result.action == 'switch' && result.item)
          this.changeActiveAccount(result.item as AccountMembership)
        else if (result.action == 'admin')
          this.openAdminActions()
      }
    })
  }

  openUnifiedPalette(): void {
    if (this.unifiedPalette) {
      this.unifiedPalette.open();
    }
  }

  updateAccount() {
    let ref = null;
    ref = this.dialogService.open(UpdateAccountComponent, {
      data: {}
    });

    ref.afterClosed.pipe(take(1)).subscribe(result => {
      console.log('Dialog closed', result);
      if (result != null) {
        this.activeAccount = result;
        setTimeout(() => {
          this.evaluateWidths()
        }, 300);
        this.updateNav();
        this.refreshActiveAccountInSharedService();
      }
    });
  }

  updateAccountDefault() {
    let ref = this.dialogService.open(UpdateAccountDefaultsComponent, {
      data: {}
    });
    ref.afterClosed.pipe(take(1)).subscribe(result => {
      console.log('Dialog closed', result);
      if (result != null) {
        this.activeAccount = result;
        setTimeout(() => {
          this.evaluateWidths()
        }, 300);
        this.updateNav();
        this.refreshActiveAccountInSharedService();
      }
    });
  }

  refreshActiveAccountInSharedService() {
    this.dataService.setActiveAccount(this.activeAccount);
  }

  showGlobalFilterDialog() {
    this.dialogService.open(GlobalFilterComponent, {

    });
  }

  viewNotifications() {
    this.newNotificationCount = 0;
    this.dialogService.open(NotificationsComponent, {
      data: {}
    });
  }

  viewMentions() {
    this.newMentionCount = 0;
  }

  showGloabFilterOptions() {

  }

  subscribe() {
    this.router.navigate(['/subscribe', this.activeAccount.id]);
  }

  items: string[] = [
    'The first choice!',
    'And another choice for you.',
    'but wait! A third!'
  ];

  onHidden(): void {
    this.logger.log('Dropdown is hidden');
  }
  onShown(): void {
    this.logger.log('Dropdown is shown');
  }
  isOpenChange(): void {
    this.logger.log('Dropdown state is changed');
  }

  async changeActiveAccount(account: AccountMembership): Promise<void> {
    if (this.accountSwitchInProgress) {
      console.warn('Account switch already in progress');
      return;
    }

    const accountChanged = this.activeAccount?.id !== account.id;
    this.accountSwitchInProgress = true;
    try {
      // Same token-claim guard as cold bootstrap: refresh once if the target
      // account is missing from the token, and stay on the current account
      // rather than entering one whose queries would all be denied.
      const hasTokenAccess = await this.auth.ensureAccountInToken(account.accountId);
      if (!hasTokenAccess) {
        const accountName = account.account?.accountName || 'this workspace';
        this.toastr.error(
          `Your access to ${accountName} is not active yet. Try again in a moment or ask an admin to check your membership.`,
          'Workspace unavailable'
        );
        return;
      }
      this.invalidateAccountRequests();

      //Reset objects and subscriptions belonging to previously selected account
      await this.resetAllSavedDataInService();
      this.closeActiveSubscriptions();

      // Reset dropdown state
      this.hoveredDropdownIndex = null;

      this.activeAccount = account;
      this.dataService.setActiveAccount(_.cloneDeep(this.activeAccount));
      setTimeout(() => {
        this.evaluateWidths()
      }, 300);
      this.updateNav();
      // Immediately update contextual options to reflect navigation state
      this.updateContextualOptions(this.router.url);

      if (this.activeAccount && (this.activeAccount.authorizationLevel == AuthorizationLevel.ADMIN || this.activeAccount.authorizationLevel == AuthorizationLevel.SUPERADMIN))
        this.setDashboardGlobalFilter("admin");
      else if (this.activeAccount && this.activeAccount.authorizationLevel == AuthorizationLevel.MEMBER)
        this.setDashboardGlobalFilter("member");
      let accountIdToBeRemoved = this.activeAccount.accountId;
      this.dropdownToChooseAccount = cloneDeep(this.userAccountMemberships);
      remove(this.dropdownToChooseAccount, function (n) {
        return n.accountId == accountIdToBeRemoved;
      });
      let isTrialRemaining = this.getTrialDaysRemaining();
      if (!isTrialRemaining) {
        return;
      }
      this.initializeOnboardingProgress();
      if (!this.checkIfWebAccessDisabled() || !this.checkIfAccountToBeBlocked()) {
        return;
      }
      if (accountChanged) {
        this.scheduleWorkspaceConfirmation(account.account.accountName, 'switched');
      }
      if (this.activeAccount.account.accountType != AccountType.INDIVIDUAL) {
        this.createSubscriptions();
      }
      this.updateLastActiveAccountWeb();

      await this.loadAccountBootstrapData('account switch');
    } finally {
      this.accountSwitchInProgress = false;
    }
  }

  resetAllSavedDataInService() {
    this.dataService.disableSampleDataMode();
    this.recentActivities = [];
    this.recentMentions = [];
    this.myTasksOverdue = [];
    this.myTasksDueToday = [];
    this.notifications = [];
    this.freshLeads = [];
    this.unassignedTasks = [];
    this.unassignedLeads = [];
    this.trialActivationMetrics = {
      representativeCount: 0,
      installedRepresentativeCount: 0,
      readyRepresentativeCount: 0,
      trackedCallCount: 0,
      representatives: [],
    };
    this.trialReward = deriveTrialReward(this.trialActivationMetrics, 0);
    this.trialRewardCallCountReady = false;
    this.trialRewardCallCountRefreshing = false;
    this.trialRewardCallCountInFlightKey = null;
    this.trialActivationReady = false;
    this.trialAppStatusRefreshing = false;
    this.trialCountdown = null;
    this.clearTrialCountdownTimer();

    this.fetchedTeams = [];
    this.fetchedUsers = [];
    this.fetchedActiveUsers = [];
    this.fetchedTeamMemberships = [];
    this.directTeamsAsTL = [];
    this.allDirectTeams = [];
    this.directTeamsAsReportee = [];
    this.directReportees = [];
    this.indirectTeamsAsLead = [];
    this.inDirectReportees = [];

    this.dataService.setActiveAccount(null);
    this.newNotificationCount = 0;
    this.newMentionCount = 0;
    this.newTaskCount = 0;
    this.newActivityCount = 0;
    this.newPendingAssignmentCount = 0;
    this.stopHealthBannerCountdown();
    this.showHealthBanner = false;
    this.healthBannerIssueCount = 0;
    this.reuseStrategy.clearStoredHandles();
  }

  updateLastActiveAccountWeb() {
    localforage.setItem('lastActiveAccountSelectedInBrowser', this.activeAccount.accountId);
    let input = <UpdateUserInput>{};
    input.lastSelectedAccountWeb = this.activeAccount.accountId;
    input.id = this.userId;
    this.api.UpdateUser(input).then(event => {
      this.logger.log('Last Active Account Web Updated : ', event);
    })
      .catch(e => {
        this.logger.log('error updating last active account for user', e);
      });
  }

  updateMembership(membership): void {
    this.membershipToBeUpdated = membership;

  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  async verifyEmail(template: TemplateRef<any>) {
    await this.getUnverifiedEmailAccounts(this.userId)
    this.logger.log("the accounts with unverified emails are :", this.unVerifiedEmailAccounts)
    this.modalRef = this.modalService.show(template);
  }

  private async getUnverifiedEmailAccounts(userId): Promise<any> {
    let filter = { and: [{ accountEmail: { attributeExists: true } }, { accountEmailVerified: { ne: true } }] }
    await this.api.AccountsByUser(userId, null, null, filter).then(event => {
      this.logger.log('User Account Memberships with unverified emails Fetched : ', event);
      this.unVerifiedEmailAccounts = event.items;
    })
      .catch(e => {
        this.logger.log('error fetching user account memberships', e);
      });

  }

  createNeedAttentionDataset() {
    //If a requested member needs approval
    var needsApproval: AccountMembership[] = [];
    if (this.activeAccount?.authorizationLevel == AuthorizationLevel.SUPERADMIN || this.activeAccount?.authorizationLevel == AuthorizationLevel.ADMIN) {
      needsApproval = this.fetchedUsers.filter(function (el) {
        return el.userAccountStatus == UserStatus.REQUESTED
      });
    }
    //New Member joined Organization
    var newOrgMembers: AccountMembership[] = [];
    var start = new Date();
    var pastDate = start.getDate() - 7;
    start.setDate(pastDate);
    newOrgMembers = this.fetchedUsers.filter(function (el) {
      return el.addedOn > start.toISOString() &&
        el.userAccountStatus == UserStatus.ACTIVE;
      ;
    });
    //If email verification is pending for user
    let userEmailVerificationPending: boolean = false;
    if (!this.registeredUser?.registeredEmailVerified)
      userEmailVerificationPending = true;

    //If email verification is pending in account
    let accountEmailVerificationPending: boolean = false;
    if (!this.activeAccount?.accountEmailVerified && this.activeAccount?.accountEmail != this.registeredUser?.registeredEmail)
      accountEmailVerificationPending = true;

    //Check if any account membership needs accept/reject
    let needAcceptRejectMembership: AccountMembership[] = [];
    needAcceptRejectMembership = this.userAccountMemberships.filter(function (el) {
      return el.userAccountStatus == UserStatus.APPROVED;
    });

    //get New Teams Created
    let newTeamsCreated: Team[] = [];
    if (this.activeAccount?.authorizationLevel == AuthorizationLevel.SUPERADMIN || this.activeAccount?.authorizationLevel == AuthorizationLevel.ADMIN) {
      newTeamsCreated = this.fetchedTeams.filter(function (el) {
        return el.createdAt > start.toISOString();
      });
    } else {
      if (this.activeAccount?.authorizationLevel == AuthorizationLevel.MANAGER) {
        let managerId = this.registeredUser.id;
        newTeamsCreated = this.fetchedTeams.filter(function (el) {
          return el.createdAt > start.toISOString() &&
            el.createdById == managerId;
        });
      }
    }
  }

  private async getAsideLeadVisibility(account: AccountMembership): Promise<SearchableContactFilterInput> {
    let teamIds: string[] = [];
    if (account.authorizationLevel === AuthorizationLevel.MANAGER) {
      const memberships = await firstValueFrom(this.dataService.getDirectTeamsAsTL().pipe(
        filter((value): value is TeamMember[] => Array.isArray(value)),
        timeout({ first: 8000 }),
        catchError(() => of([] as TeamMember[])), // Missing memberships may only narrow visibility to self.
        take(1),
        takeUntil(this.destroy$)
      ));
      teamIds = getDirectlyManagedTeamIds(memberships.filter(member =>
        member?.accountId === account.accountId && member.userId === account.userId && member.teamRole === TeamRole.TEAM_LEADER));
    }
    const viewer = [AuthorizationLevel.ADMIN, AuthorizationLevel.SUPERADMIN, AuthorizationLevel.MANAGER].includes(account.authorizationLevel)
      ? account : { ...account, authorizationLevel: AuthorizationLevel.MEMBER };
    return buildContactSearchVisibilityFilter(viewer, teamIds);
  }

  async getFreshLeads() {
    if (this.sampleDataModeEnabled) return;
    this.freshLeads = [];
    const account = { ...this.activeAccount };
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!sessionKey) return;
    const requestEpoch = this.accountRequestEpoch;
    const isCurrent = () => this.isAccountRequestCurrent(sessionKey, requestEpoch) &&
      this.activeAccount?.authorizationLevel === account.authorizationLevel && !this.sampleDataModeEnabled;
    const selectedTeamIds = (this.selectedTeam || []).map(team => team.id).filter(Boolean);
    const start = new Date();
    start.setHours(0, 0, 0, 0);
    try {
      const visibility = await this.getAsideLeadVisibility(account);
      if (!isCurrent()) return;
      const isAdmin = account.authorizationLevel === AuthorizationLevel.SUPERADMIN || account.authorizationLevel === AuthorizationLevel.ADMIN;
      const filter: SearchableContactFilterInput = { and: [visibility,
        { leadLifecycleStage: { eq: LeadLifecycleStage.UNCONTACTED_NEW } },
        isAdmin ? { createdAt: { gt: start.toISOString() } } : { updatedAt: { gt: start.toISOString() } }
      ] };
      if (account.authorizationLevel === AuthorizationLevel.MANAGER && selectedTeamIds.length > 0) {
        filter.and.push({ or: selectedTeamIds.map(id => ({ primaryTeamId: { eq: id } })) });
      }
      const sort: SearchableContactSortInput = { field: SearchableContactSortableFields.createdAt, direction: SearchableSortDirection.desc };
      const event = await this.api.SearchContacts(filter, sort, 20, undefined);
      if (!isCurrent()) return;
      this.logger.log("Searching contacts for fresh leads :", event);
      if (event.items) {
        this.freshLeads = event.items as Contact[];
      }
    } catch (e) {
      if (isCurrent()) this.logger.log('Error Fetching Fresh Leads', e);
    }
  }

  async getUnassignedLeads() {
    if (this.sampleDataModeEnabled) return;
    this.unassignedLeads = [];
    const account = { ...this.activeAccount };
    const sessionKey = this.dataService.getSessionKeyForAccount(account);
    if (!sessionKey) return;
    const requestEpoch = this.accountRequestEpoch;
    const isCurrent = () => this.isAccountRequestCurrent(sessionKey, requestEpoch) &&
      this.activeAccount?.authorizationLevel === account.authorizationLevel && !this.sampleDataModeEnabled;
    try {
      const visibility = await this.getAsideLeadVisibility(account);
      if (!isCurrent()) return;
      const filter: SearchableContactFilterInput = { and: [visibility, { toBeAssigned: { eq: ContactAssignmentStatus.UNASSIGNED } }] };
      const sort: SearchableContactSortInput = { field: SearchableContactSortableFields.updatedAt, direction: SearchableSortDirection.desc };
      const event = await this.api.SearchContacts(filter, sort, 20, undefined);
      if (!isCurrent()) return;
      this.logger.log("Searching unassigned leads :", event);
      if (event.items) {
        this.unassignedLeads = <Contact[]>event.items
      }
    } catch (e) {
      if (isCurrent()) this.logger.log('Error Unassigned Leads', e);
    }
  }

  getUnassignedTasks() {
    if (this.sampleDataModeEnabled) return;
    let filter = <SearchableEngagementFilterInput>{};
    let sort = <SearchableEngagementSortInput>{};
    //TODO: for manager rule will be different, based on teams. For Rep dont show unassigned tasks
    filter = { and: [{ accountId: { eq: this.activeAccount.accountId } }, { toBeAssigned: { eq: ContactAssignmentStatus.UNASSIGNED } }, { engagementType: { eq: EngagementType.TASK } }] };
    sort = { field: SearchableEngagementSortableFields.updatedAt, direction: SearchableSortDirection.desc };
    this.api.SearchEngagementsOnlyTask(filter, sort, 20, undefined).then(event => {
      this.logger.log("Searching unassigned tasks :", event);
      if (event.items) {
        this.unassignedTasks = <Engagement[]>event.items
      }

    })
      .catch(e => {
        this.logger.log('Error Unassigned Tasks', e);
      });
  }

  goToCreateTask() {
    this.dialogService.open(CreateTasksComponent, {
      data: {}
    });
  }

  trackById(index: number, item: any): string {
    return item?.id ?? `${index}`;
  }

  reloadWindow(): void {
    window.location.reload();
  }

  openRelatedObject(act: Activity) {
    const dialogRef = this.dialogService.open(TaskPreviewComponent, { data: { previewTask: act.activityRelatedObjectId } });
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        this.logger.log(e.errors[_i].message);
      }
    }
  }

  openSnackBar(data: any) {
    this.currentSnackBar = this.snackBar.openFromComponent(InCallNotification, {
      data: data,
      ...this.configSuccess
    });
  }

  openEntityActionSnackBar(data: EntityActionDefinition) {
    this.entityActionSnackBar = this.snackBar.openFromComponent(EntityActionNotification, {
      data: data,
      ...this.configEntityAction
    });
  }

  openNewLeadSnackBar(data: number) {
    this.newLeadSnackBar = this.snackBar.openFromComponent(NewLeadNotification, {
      data: data,
      ...this.configNewLead
    });

    const afterDismissedSubscription = this.newLeadSnackBar.afterDismissed().subscribe(() => {
      this.newlyAssignedLeads = [];
      this.newLeadSnackBar = null;
      this.newLeadAssignedAfter = (new Date()).toISOString();
      this.setNewLeadAssignedCutoff(this.newLeadAssignedAfter);
      afterDismissedSubscription.unsubscribe();
    });
  }

  closeSnackBar() {
    if (this.currentSnackBar) {
      this.currentSnackBar.dismiss();
      this.currentSnackBar = null;
    }
  }

  closeEntityActionSnackBar() {
    if (this.entityActionSnackBar) {
      this.entityActionSnackBar.dismiss();
      this.entityActionSnackBar = null;
    }
  }

  closeNewLeadSnackBar() {
    if (this.newLeadSnackBar) {
      this.newLeadSnackBar.dismiss();
      this.newLeadSnackBar = null;
    }
  }

  // ── Upcoming Task Notification ──

  private startUpcomingTaskPolling(): void {
    timer(10000, 25 * 60 * 1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.checkUpcomingTasks());
  }

  private checkUpcomingTasks(): void {
    if (!this.activeAccount || this.sampleDataModeEnabled) return;

    const now = new Date();
    const thirtyMinLater = new Date(now.getTime() + 30 * 60 * 1000);

    const f = <SearchableEngagementFilterInput>{
      and: [
        { accountId: { eq: this.activeAccount.accountId } },
        { ownerId: { eq: this.activeAccount.userId } },
        { engagementType: { eq: EngagementType.TASK } },
        { engagementStatus: { eq: EngagementStatus.ACTIVE } },
        {
          or: [
            { and: [{ dueDateTime: { gte: now.toISOString() } }, { dueDateTime: { lte: thirtyMinLater.toISOString() } }] },
            { and: [{ nextFollowUpOn: { gte: now.toISOString() } }, { nextFollowUpOn: { lte: thirtyMinLater.toISOString() } }] }
          ]
        }
      ]
    };

    this.api.SearchEngagementsMinimal(f, undefined, 100, undefined).then(result => {
      if (!result?.items?.length) return;

      const tasks = result.items.filter((t: any) => !this.dismissedUpcomingTaskIds.has(t.id));
      if (tasks.length === 0 || this.upcomingTaskSnackBar) return;

      this.openUpcomingTaskSnackBar(tasks.length, tasks.map((t: any) => t.id));
    }).catch(e => {
      console.error('Error checking upcoming tasks:', e);
    });
  }

  private openUpcomingTaskSnackBar(count: number, taskIds: string[]): void {
    this.upcomingTaskSnackBar = this.snackBar.openFromComponent(UpcomingTaskNotification, {
      data: count,
      ...this.configUpcomingTask
    });

    this.upcomingTaskSnackBar.afterDismissed().subscribe(() => {
      taskIds.forEach(id => this.dismissedUpcomingTaskIds.add(id));
      this.upcomingTaskSnackBar = null;
    });
  }

  // \u2500\u2500 Missed Call Reminder \u2500\u2500
  // Foreground-only banner. First eligible check runs 30s after foreground,
  // then no more than once per 60 minutes from the last actual check.
  // Backgrounding clears the pending timer; returning to foreground resumes
  // from the persisted last-check gate instead of restarting the hour.
  // The separate last-shown gate keeps banner display throttled as well.

  private missedCallTimer: any = null;

  private startMissedCallPolling(): void {
    if (this.isVisible) void this.scheduleMissedCallCheckRespectingGate(30_000);

    // Separate from the global visibility listener: this owns only the
    // missed-call timer and relies on the shared listener to update isVisible.
    fromEvent(window, 'visibilitychange')
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (document.visibilityState === 'hidden') {
          this.clearMissedCallTimer();
        } else {
          void this.scheduleMissedCallCheckRespectingGate(30_000);
        }
      });
  }

  private async scheduleMissedCallCheckRespectingGate(defaultDelayMs: number): Promise<void> {
    this.clearMissedCallTimer();

    let delayMs = defaultDelayMs;
    try {
      const lastChecked = await localforage.getItem<number>(this.missedCallCheckKey);
      if (typeof lastChecked === 'number') {
        const remainingMs = this.MISSED_CALL_THROTTLE_MS - (Date.now() - lastChecked);
        if (remainingMs > 0) {
          delayMs = remainingMs;
        }
      }
    } catch (e) {
      // Read failure: keep the normal foreground delay.
    }

    if (this.isVisible) {
      this.scheduleMissedCallCheck(delayMs);
    }
  }

  private scheduleMissedCallCheck(delayMs: number): void {
    this.clearMissedCallTimer();
    this.missedCallTimer = setTimeout(async () => {
      await this.checkMissedCalls();
      if (this.isVisible) {
        this.scheduleMissedCallCheck(this.MISSED_CALL_THROTTLE_MS);
      }
    }, delayMs);
  }

  private clearMissedCallTimer(): void {
    if (this.missedCallTimer) {
      clearTimeout(this.missedCallTimer);
      this.missedCallTimer = null;
    }
  }

  private async checkMissedCalls(): Promise<void> {
    if (!this.activeAccount || this.sampleDataModeEnabled) return;
    if (!this.isVisible) return;
    if (this.missedCallSnackBar) return;

    // Gate checks as well as display, so repeated foreground events cannot
    // force an API search more than once per MISSED_CALL_THROTTLE_MS.
    try {
      const lastChecked = await localforage.getItem<number>(this.missedCallCheckKey);
      if (typeof lastChecked === 'number' && (Date.now() - lastChecked) < this.MISSED_CALL_THROTTLE_MS) {
        return;
      }
      await localforage.setItem(this.missedCallCheckKey, Date.now());
    } catch (e) {
      // Read/write failure: fall through and allow the check.
    }

    // Gate: at least MISSED_CALL_THROTTLE_MS since last show
    try {
      const lastShown = await localforage.getItem<number>(this.missedCallGateKey);
      if (typeof lastShown === 'number' && (Date.now() - lastShown) < this.MISSED_CALL_THROTTLE_MS) {
        return;
      }
    } catch (e) {
      // Read failure \u2014 fall through and allow the banner.
    }

    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);

    const accountId = this.activeAccount.accountId;
    const userId = this.activeAccount.userId;
    const filter = <SearchableContactFilterInput>{
      and: [
        { accountId: { eq: this.activeAccount.accountId } },
        { lastCallUserId: { eq: this.activeAccount.userId } },
        { lastCalledTime:    { gt: startOfToday.toISOString() } },
        { lastCallDirection: { eq: CallDirection.INCOMING } },
        { lastCallDuration:  { eq: 0 } },
      ]
    };

    try {
      if (this.activeAccount.authorizationLevel === AuthorizationLevel.MEMBER) {
        filter.and.push({ ownerId: { eq: userId } });
      }
      const result = await this.api.SearchContacts(filter, undefined, 1, undefined, undefined);
      if (accountId !== this.activeAccount?.accountId || userId !== this.activeAccount?.userId) return;
      const count = result?.total ?? 0;
      if (count <= 0) return;
      if (!this.isVisible) return;     // may have backgrounded during the query
      this.openMissedCallSnackBar(count, filter);
    } catch (e) {
      console.error('Error checking missed calls:', e);
    }
  }

  private openMissedCallSnackBar(count: number, filter: SearchableContactFilterInput): void {
    this.missedCallSnackBar = this.snackBar.openFromComponent(MissedCallNotification, {
      data: { count, filter },
      ...this.configMissedCall
    });

    // Persist the gate AT SHOW TIME (not dismiss) so a fresh missed call later
    // still has to wait a full hour from now.
    localforage.setItem(this.missedCallGateKey, Date.now()).catch(e => {
      console.error('Error persisting missed-call gate:', e);
    });

    this.missedCallSnackBar.afterDismissed().subscribe(() => {
      this.missedCallSnackBar = null;
    });
  }

  private dismissMissedCallSnackBar(): void {
    if (this.missedCallSnackBar) {
      this.missedCallSnackBar.dismiss();
      this.missedCallSnackBar = null;
    }
  }

  //Functions related to member status
  getMemberStatus() {
    if (!this.activeAccount || this.sampleDataModeEnabled)
      return;
    // Honor a refresh that a visibility return deferred while off-view: once a
    // member-status view is back in scope, promote it to a forced refresh so the
    // route throttle below can't suppress the catch-up fetch.
    const onMemberStatusView =
      (this.currentMainSection == 'dashboard' && this.selectedContextTab == 'Default') ||
      (this.isAsideOpen && this.activeAsideTab === 'status');
    if (this.memberStatusVisibilityRefreshPending && onMemberStatusView) {
      this.memberStatusNeedsToBeRefreshed = true;
    }
    if ((this.currentMainSection == 'dashboard' && this.selectedContextTab == 'Default') || this.memberStatusNeedsToBeRefreshed) {
      const now = Date.now();
      const routeRefreshOnly = !this.memberStatusNeedsToBeRefreshed;
      if (
        routeRefreshOnly &&
        this.fetchedCurrentMemberStatus?.length > 0 &&
        (now - this.lastMemberStatusFetchedAt) < this.MEMBER_STATUS_ROUTE_REFRESH_THROTTLE_MS
      ) {
        return;
      }
      let o = <ModelIDKeyConditionInput>{};
      // o = { eq: this.activeAccount.userId };
      fetchAllAccountMemberActivities(this.api, this.activeAccount.accountId, {
        sortDirection: ModelSortDirection.ASC
      }).then(activities => {
        console.log('Members Current Status Fetched. Count:', activities.length);
        this.fetchedCurrentMemberStatus = activities;
        this.lastMemberStatusFetchedAt = Date.now();
        this.allMemberStatusData = [];
        this.createAllMemberStatusData();
      })
        .catch(e => {
          console.log('Error Fetching Members Current Status', e);
          this.showErrorInToastr(e, 'Error Fetching Members Current Status')
        })
        .finally(() => {
          this.memberStatusNeedsToBeRefreshed = false;
          // Any completed fetch makes the snapshot fresh, so the deferred marker is
          // satisfied regardless of what triggered this fetch.
          this.memberStatusVisibilityRefreshPending = false;
        });
    }
  }

  createAllMemberStatusData() {
    this.allMemberStatusData = []
    const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
    if (!sessionKey) {
      return;
    }
    const def_val = '--';
    let members: any[] = []
    members = this.allUsers
    for (var _i = 0; _i < members.length; _i++) {
      let rowData = <MemberStatusData>{};
      let item = members[_i];
      const memberActivity = (_filter(
        this.fetchedCurrentMemberStatus,
        status => status.userId == item.userId,
      ) as AccountMemberActivity[])[0];
      rowData.userId = item.userId;
      rowData.name = item.user?.name;
      rowData.role = item.authorizationLevel;
      rowData.email = item.accountEmail;
      rowData.userProfilePic = item.user?.profilePictureUrl;
      rowData.lastActivityId = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastActivityId || null;
      rowData.lastActivity = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastActivity || null;
      rowData.lastActivityTime = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastActivityTime || def_val;
      rowData.lastActivityType = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastActivityType || def_val;
      rowData.lastActivityBody = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastActivityBody || def_val;
      rowData.lastCallLogged = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastCallLogged || def_val;
      rowData.lastNoteAdded = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastNoteAdded || def_val;
      rowData.lastTaskCreated = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastTaskCreated || def_val;
      rowData.lastTaskCompleted = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastTaskCompleted || def_val;
      rowData.lastVisitLogged = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastVisitLogged || def_val;
      rowData.lastCommentAdded = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastCommentAdded || def_val;
      rowData.lastContactAdded = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastContactAdded || def_val;
      rowData.lastKnownLocation = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastKnownLocation || def_val;
      rowData.lastKnownLocationTime = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.lastKnownLocationTime || def_val;
      rowData.activeVisitEngagementId = memberActivity?.activeVisitEngagementId || null;
      rowData.activeVisitContactId = memberActivity?.activeVisitContactId || null;
      rowData.activeVisitContactName = memberActivity?.activeVisitContactName || null;
      rowData.activeVisitStartedAt = memberActivity?.activeVisitStartedAt || null;
      rowData.inVideoCall = memberActivity?.inVideoCall ?? null;
      rowData.activeVideoCallEngagementId = memberActivity?.activeVideoCallEngagementId || null;
      rowData.lastVideoCallEventAt = memberActivity?.lastVideoCallEventAt || null;
      rowData.updatedAt = (_filter(this.fetchedCurrentMemberStatus, status => status.userId == item.userId) as AccountMemberActivity[])[0]?.updatedAt || def_val;
      rowData.lastActivityTimeStamp = this.getLastActivityTimestamp(rowData.lastActivityTime);
      this.allMemberStatusData.push(rowData);
    }
    this.allMemberStatusData = orderBy(this.allMemberStatusData, ['lastActivityTime'], ['desc']);
    this.dataService.setAllMemberStatusData(_.cloneDeep(this.allMemberStatusData), sessionKey);
    console.log("Member Status data is :", this.allMemberStatusData);
  }


  updateMemberStatusWithNewData(newMemberStatus: AccountMemberActivity) {
    var index = findIndex(this.allMemberStatusData, { userId: newMemberStatus.userId });
    if (index != -1) {
      let rowData = this.allMemberStatusData[index];
      rowData.lastActivityId = newMemberStatus.lastActivityId;
      rowData.lastActivity = newMemberStatus.lastActivity;
      rowData.lastActivityTime = newMemberStatus.lastActivityTime;
      rowData.lastActivityType = newMemberStatus.lastActivityType;
      rowData.lastActivityBody = newMemberStatus.lastActivityBody;
      rowData.lastCallLogged = newMemberStatus.lastCallLogged;
      rowData.lastNoteAdded = newMemberStatus.lastNoteAdded;
      rowData.lastTaskCreated = newMemberStatus.lastTaskCreated;
      rowData.lastTaskCompleted = newMemberStatus.lastTaskCompleted;
      rowData.lastVisitLogged = newMemberStatus.lastVisitLogged;
      rowData.lastCommentAdded = newMemberStatus.lastCommentAdded;
      rowData.lastContactAdded = newMemberStatus.lastContactAdded;
      rowData.lastKnownLocation = newMemberStatus.lastKnownLocation;
      rowData.lastKnownLocationTime = newMemberStatus.lastKnownLocationTime;
      rowData.activeVisitEngagementId = newMemberStatus.activeVisitEngagementId;
      rowData.activeVisitContactId = newMemberStatus.activeVisitContactId;
      rowData.activeVisitContactName = newMemberStatus.activeVisitContactName;
      rowData.activeVisitStartedAt = newMemberStatus.activeVisitStartedAt;
      rowData.inVideoCall = newMemberStatus.inVideoCall ?? null;
      rowData.activeVideoCallEngagementId = newMemberStatus.activeVideoCallEngagementId;
      rowData.lastVideoCallEventAt = newMemberStatus.lastVideoCallEventAt;
      rowData.updatedAt = newMemberStatus.updatedAt;
      rowData.lastActivityTimeStamp = this.getLastActivityTimestamp(rowData.lastActivityTime);
      this.allMemberStatusData.splice(index, 1, rowData);
      this.allMemberStatusData = orderBy(this.allMemberStatusData, ['lastActivityTime'], ['desc']);
      const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
      if (sessionKey) {
        this.dataService.setAllMemberStatusData(_.cloneDeep(this.allMemberStatusData), sessionKey);
      }
    }
  }

  getLastActivityTimestamp(dateString: string): number {
    let toReturn = null;
    var date = parseISO(dateString);
    if (<any>date != 'Invalid Date') {
      toReturn = date.getTime();
    }
    return toReturn;
  }

  getUnreadChatsAsParticipant() {
    if (this.sampleDataModeEnabled) return;
    this.fetchedChats = [];
    let f = <SearchableChatParticipantFilterInput>{};
    let s = <SearchableChatParticipantSortInput>{};
    f = { accountId: { eq: this.activeAccount.accountId }, participantId: { eq: this.activeAccount.userId }, unreadMessageCount: { gt: 0 }, channelType: { ne: "INTERNAL" } }
    s = { field: SearchableChatParticipantSortableFields.updatedAt, direction: SearchableSortDirection.desc }
    this.api.SearchChatParticipants(f, s, 20, undefined, undefined).then(event => {
      console.log('Fetched Unread Chat Channels : ', event);
      if (event && event.items) {
        this.fetchedChats = event.items as ChatParticipant[];
        this.fetchedChats = globalFunctions.setUser(this.fetchedChats, ['participantId'], ['participant'], this.userMap)
        this.fetchedChats = [...this.fetchedChats]
      }
      if (event && event.total)
        this.totalWhatsappUnreadCount = event.total;
    })
      .catch(e => {
        console.log('Error Fetching Chat Channels', e);
        this.showErrorInToastr(e, 'Error Fetching Chat Channels')
      });
  }

  getNewChatsAsParticipant(newIncomingMessageFromWebSocket = true) {
    if (this.sampleDataModeEnabled) return;
    console.log("in function getNewChatsAsParticipant");
    const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
    if (!sessionKey) {
      return;
    }
    let f = <SearchableChatParticipantFilterInput>{};
    let s = <SearchableChatParticipantSortInput>{};
    f = { accountId: { eq: this.activeAccount.accountId }, participantId: { eq: this.activeAccount.userId }, unreadMessageCount: { gt: 0 }, channelType: { ne: "INTERNAL" } }
    s = { field: SearchableChatParticipantSortableFields.updatedAt, direction: SearchableSortDirection.desc }
    // lastViewedChatNotification filter removed — unreadMessageCount > 0 and
    // lastQuickInboxDismissedAt are sufficient; the old filter wiped quick-inbox
    // notifications whenever the user closed the full inbox.
    if (this.lastQuickInboxDismissedAt) {
      f = { and: [{ updatedAt: { gt: this.lastQuickInboxDismissedAt } }, f] };
    }

    this.api.SearchChatParticipants(f, s, 25, undefined, undefined).then(event => {
      console.log('Fetched New Chat Channels : ', event);
      if (!newIncomingMessageFromWebSocket && event && event.items) {
        this.externalChatParticipants = event.items;
      }
      if (event && event.total != null) {
        this.totalWhatsappNewCount = event.total;
        this.dataService.setTotalWhatsappNewCount(this.totalWhatsappNewCount, sessionKey);
        if (newIncomingMessageFromWebSocket && this.totalWhatsappNewCount > 0)
          generateFavicon(this.totalWhatsappNewCount);
        else
          resetFavicon();
      }
    })
      .catch(e => {
        console.log('Error Fetching Chat Channels', e);
        this.showErrorInToastr(e, 'Error Fetching Chat Channels')
      });
  }

  getNewChatsAsParticipantInternal(newIncomingMessageFromWebSocket = true) {
    if (this.sampleDataModeEnabled) return;
    console.log("in function getNewChatsAsParticipantInternal");
    const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
    if (!sessionKey) {
      return;
    }
    let f = <SearchableChatParticipantFilterInput>{};
    let s = <SearchableChatParticipantSortInput>{};
    f = { accountId: { eq: this.activeAccount.accountId }, participantId: { eq: this.activeAccount.userId }, unreadMessageCount: { gt: 0 }, channelType: { eq: "INTERNAL" } }
    s = { field: SearchableChatParticipantSortableFields.updatedAt, direction: SearchableSortDirection.desc }
    if (this.lastQuickInboxDismissedAt) {
      f = { and: [{ updatedAt: { gt: this.lastQuickInboxDismissedAt } }, f] };
    }

    this.api.SearchChatParticipants(f, s, 25, undefined, undefined).then(event => {
      console.log('Fetched New Chat Channels : ', event);
      if (!newIncomingMessageFromWebSocket && event && event.items) {
        this.internalChatParticipants = event.items;
      }
      if (event && event.total != null) {
        this.totalTeamChatNewCount = event.total;
        this.dataService.setTotalTeamChatNewCount(this.totalTeamChatNewCount, sessionKey);
      }
    })
      .catch(e => {
        console.log('Error Fetching Chat Channels', e);
        this.showErrorInToastr(e, 'Error Fetching Chat Channels')
      });
  }

  viewWhatsappUnread() {
    this.getUnreadChatsAsParticipant();
  }

  goToSelectedChat(chat: ChatParticipant) {
    let selectedContactId = chat.channel.contactId
    if (selectedContactId) {
      // Close the WhatsApp dropdown before opening dialog
      if (this.whatsappDropdown) {
        this.whatsappDropdown.hide();
      }

      let ref = this.dialogService.open(SharedInboxComponent, {
        data: { selectedContactId: selectedContactId, viewMode: 'dialog-mode' }
      }, 1);
    }
  }

  getMembersOfSelectedTeam() {
    this.selectedTeamMembers = [];
    console.log("All team memberships", this.fetchedTeamMemberships);
    this.selectedTeamMembers = this.fetchedTeamMemberships.filter(teamMembership =>
      this.selectedTeam.some(team => team.id === teamMembership.teamId)
    );

    console.log("Selected team memberships", this.selectedTeamMembers);
  }

  selectPeriod(period) {
    this.selectedPeriod = period.value;
    this.selectedPeriodText = period.viewValue;
    this.setDashboardGlobalFilter();

  }

  onTeamSelectChange(e) {
    console.log("Team changed", e);
    this.selectedUser = [];
    this.selectedTeamMember = [];
    if (this.selectedTeam.length > 0 && this.fetchedTeamMemberships.length > 0)
      this.getMembersOfSelectedTeam();
    this.setDashboardGlobalFilter();
  }

  onTeamMemberSelectChange(e) {
    console.log("Team Member changed", e);
    this.selectedUser = [];
    this.setDashboardGlobalFilter();
  }

  onUserSelectChange(e) {
    console.log("User changed", e);
    this.selectedTeam = [];
    this.selectedTeamMember = [];
    this.setDashboardGlobalFilter();
  }

  /**
   * A route initialization or refresh can find a component still waiting on an
   * undefined session value after a login-time bootstrap failure. Re-run only the
   * missing bootstrap producers; their existing session-scoped streams will wake
   * the waiting route automatically.
   */
  private recoverMissingAccountBootstrapData(sessionKey: string): void {
    combineLatest({
      authorization: this.dataService.getUserAuthorization(),
      users: this.dataService.getAllUsersInAccount(),
      inactiveUsersMap: this.dataService.getMapAllUsersInAccountIncludingInactive(),
      teams: this.dataService.getTeams(),
      teamMemberships: this.dataService.getTeamMemberships(),
      teamsMap: this.dataService.getMapAllTeamsInAccount(),
      customPropertiesMap: this.dataService.getMapAllCustomProperties(),
      dealStages: this.dataService.getDealStages(),
      callOutcomes: this.dataService.getCallOutcomeTypes()
    }).pipe(take(1)).subscribe(snapshot => {
      const account = this.activeAccount;
      if (!account || this.dataService.getSessionKeyForAccount(account) !== sessionKey) {
        return;
      }

      const missing: string[] = [];
      const customPropertiesMissing = !snapshot.customPropertiesMap ||
        !Array.isArray(snapshot.dealStages) || snapshot.dealStages.length === 0;
      const callOutcomesMissing =
        !Array.isArray(snapshot.callOutcomes) || snapshot.callOutcomes.length === 0;
      if (customPropertiesMissing || callOutcomesMissing) {
        if (customPropertiesMissing) {
          missing.push('custom-properties/deal-stages');
        }
        if (callOutcomesMissing) {
          missing.push('call-outcomes');
        }
        void this.getCustomPropertyDefinitions();
      }

      if (!snapshot.authorization) {
        // Authorization is the parent producer: on success it starts the user,
        // team and team-membership fetches, so do not race those children here.
        missing.push('authorization');
        void this.getUserAuthorization();
      } else {
        const usersMissing = !Array.isArray(snapshot.users) || !snapshot.inactiveUsersMap;
        if (usersMissing) {
          missing.push('users');
          // This is an explicit recovery request. Bypass localforage so a failed
          // cache read cannot strand the same prerequisite a second time.
          void this.getAllUsersInAccount(true).catch(error => {
            this.logger.log('Error recovering account users', error);
          });
        }

        const teamsMissing = !Array.isArray(snapshot.teams) || !snapshot.teamsMap;
        const teamMembershipsMissing = !Array.isArray(snapshot.teamMemberships);
        if (account.account?.accountType === AccountType.INDIVIDUAL) {
          // Individual accounts intentionally skip the team APIs. Publish their
          // valid empty state so consumers do not wait forever for these streams.
          if (teamsMissing) {
            missing.push('teams');
            this.dataService.setTeams([], sessionKey);
            this.dataService.setMapAllTeamsInAccount({}, sessionKey);
          }
          if (teamMembershipsMissing) {
            missing.push('team-memberships');
            this.dataService.setAllTeamMemberships([], sessionKey);
            this.dataService.setAllDirectTeams([], sessionKey);
            this.dataService.setDirectTeamsAsTL([], sessionKey);
            this.dataService.setDirectTeamsAsReportee([], sessionKey);
            this.dataService.setIndirectTeamsAsLead([], sessionKey);
            this.dataService.setDirectReportees([], sessionKey);
            this.dataService.setInDirectReportees([], sessionKey);
          }
        } else {
          if (teamsMissing) {
            missing.push('teams');
            void this.getAllTeams();
          }
          if (teamMembershipsMissing) {
            missing.push('team-memberships');
            void this.getAllTeamMemberships();
          }
        }
      }

      if (missing.length > 0) {
        console.warn('Recovering missing account bootstrap data.', {
          accountId: account.accountId,
          missing
        });
      }
    });
  }

  refreshData(ev) {
    this.setDashboardGlobalFilter();
    const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
    if (sessionKey) {
      this.recoverMissingAccountBootstrapData(sessionKey);
      this.dataService.setGlobalRefresh(true, sessionKey);
    }
    // Also refresh aside panel data
    this.refreshAsideData();
  }

  refreshAsideData() {
    // Member status is consumed globally (profile dots, etc.), so refresh it
    // unconditionally - unless the active aside tab will fetch it itself.
    if (!this.isAsideOpen || this.activeAsideTab !== 'status') {
      this.memberStatusNeedsToBeRefreshed = true;
      this.getMemberStatus();
    }

    // Aside-only tabs: skip when collapsed (most users), refresh only the
    // currently visible tab when open.
    if (!this.isAsideOpen) return;
    if (!this.activeAsideTab) return;
    this.onSelect(this.activeAsideTab);
  }

  openSupport() {
    if (this.canCustomizeWorkspace())
      this.dialogService.open(AdminActionsComponent, {}, 1);
    else {
      this.dialogService.open(SupportComponent, {}, 1);
    }
  }

  canCustomizeWorkspace(): boolean {
    return canCustomizeWorkspaceForAccount(this.activeAccount);
  }

  goToWallet(): void {
    if (!isFeatureEnabled('wallet', this.activeAccount)) return;
    // The chip opens the usage wallet journey. /billing/wallet stays as the Billing module tab.
    this.router.navigate(['/wallet']);
  }

  /** Chip warning from the ListWalletsByClientAccount balance (empty = stopped, below the threshold = low). */
  get walletAlert(): WalletAlert {
    return this.walletBalanceService.alert;
  }

  get walletChipTooltip(): string {
    if (this.walletBalanceError) return 'Balance unavailable. Click refresh to retry';
    if (this.walletAlert === 'stopped') return 'Wallet is empty: wallet features are stopped. Add funds to restart them';
    if (this.walletAlert === 'low') return 'Low balance - top up to keep services running';
    return 'Open wallet';
  }

  refreshWallet(event: Event): void {
    event.stopPropagation();
    if (this.walletRefreshing || !isFeatureEnabled('wallet', this.activeAccount)) return;
    this.walletBalanceService.refresh(this.activeAccount.accountId).catch(error => {
      this.toastr.error('Could not refresh wallet balance');
      this.logger.warn('Could not refresh wallet balance', error);
    });
  }

  setDashboardGlobalFilter(level: string = null) {
    if (level) {
      let allTeams = this.selectedTeam;
      if (this.activeAccount && this.activeAccount.authorizationLevel == AuthorizationLevel.MANAGER) {
        if (this.directTeamsAsTL && this.directTeamsAsTL.length > 0 && (!this.selectedTeam || this.selectedTeam.length == 0)) {
          allTeams = _map(this.directTeamsAsTL, 'team');
        }
        else if ((!this.directTeamsAsTL || this.directTeamsAsTL.length == 0) && (!this.selectedTeam || this.selectedTeam.length == 0)) {

        }
      }
      let currentFilter = { level: level, user: this.selectedUser, team: allTeams, teamMember: this.selectedTeamMember, period: this.selectedPeriod };
      const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
      if (sessionKey) {
        this.dataService.setDashboardGlobalFilter(_.cloneDeep(currentFilter), sessionKey);
      }
      this.currentGlobalFilter = currentFilter
    }
    else {
      let allTeams = this.selectedTeam;
      if (this.activeAccount && this.activeAccount.authorizationLevel == AuthorizationLevel.MANAGER) {
        if (this.directTeamsAsTL && this.directTeamsAsTL.length > 0 && (!this.selectedTeam || this.selectedTeam.length == 0)) {
          allTeams = _map(this.directTeamsAsTL, 'team');
        }
        else if ((!this.directTeamsAsTL || this.directTeamsAsTL.length == 0) && (!this.selectedTeam || this.selectedTeam.length == 0)) {

        }
      }
      let currentFilter = { level: this.currentGlobalFilter["level"], user: this.selectedUser, team: allTeams, teamMember: this.selectedTeamMember, period: this.selectedPeriod };
      const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
      if (sessionKey) {
        this.dataService.setDashboardGlobalFilter(_.cloneDeep(currentFilter), sessionKey)
      }
      this.currentGlobalFilter = currentFilter
    }
  }

  removeTopFilter(type: string) {
    if (type == 'team') {
      this.selectedTeam = [];
      this.selectedTeamMember = [];
    }
    else if (type == 'teamMember') {
      this.selectedTeamMember = [];
    }
    else if (type == 'user') {
      this.selectedUser = [];
    }
    this.setDashboardGlobalFilter();
  }

  private getPendingWebCallLogKey(callPlacementId: string): string {
    return `${this.pendingWebCallLogPrefix}${callPlacementId}`;
  }

  private getDeadWebCallLogKey(callPlacementId: string): string {
    return `${this.deadWebCallLogPrefix}${callPlacementId}`;
  }

  private async getQueuedWebCallLog(callPlacementId: string): Promise<{ event: any, cacheKey: string } | null> {
    if (!callPlacementId) {
      return null;
    }
    const namespacedKey = this.getPendingWebCallLogKey(callPlacementId);
    const namespacedEvent = await localforage.getItem(namespacedKey);
    if (namespacedEvent) {
      return { event: namespacedEvent, cacheKey: namespacedKey };
    }
    const legacyEvent = await localforage.getItem(callPlacementId);
    if (legacyEvent) {
      return { event: legacyEvent, cacheKey: callPlacementId };
    }
    return null;
  }

  private async persistQueuedWebCallLog(
    pendingLog: PendingWebCallOutcome,
    cacheKey?: string
  ): Promise<string> {
    if (!pendingLog.callPlacementId) {
      throw new Error('Cannot persist a web-call outcome without callPlacementId');
    }

    const namespacedKey = this.getPendingWebCallLogKey(pendingLog.callPlacementId);
    await localforage.setItem(namespacedKey, pendingLog);
    if (cacheKey && cacheKey !== namespacedKey) {
      await localforage.removeItem(cacheKey);
    }
    return namespacedKey;
  }

  private async handleCompletedWebCallOutcome(callPlacementId: string): Promise<void> {
    const queued = await this.getQueuedWebCallLog(callPlacementId);
    if (!queued?.event) return;

    const now = Date.now();
    const completionWasAlreadyReceived = !!queued.event.completionReceivedAt;
    const completionReceivedAt = queued.event.completionReceivedAt || new Date(now).toISOString();
    const pendingLog: PendingWebCallOutcome = {
      ...queued.event,
      callPlacementId,
      completionReceivedAt,
      expiresAt: queued.event.expiresAt
        || new Date(now + WEB_CALL_OUTCOME_RETRY_WINDOW_MS).toISOString()
    };
    const existingNextAttemptAt = new Date(queued.event.nextAttemptAt || '').getTime();
    const firstAttemptAt = completionWasAlreadyReceived && Number.isFinite(existingNextAttemptAt)
      ? existingNextAttemptAt
      : now + WEB_CALL_OUTCOME_RETRY_OFFSETS_MS[0];
    pendingLog.nextAttemptAt = new Date(firstAttemptAt).toISOString();

    await this.persistQueuedWebCallLog(pendingLog, queued.cacheKey);
    this.logger.log('Web-call completed; queued outcome reconciliation scheduled', {
      callPlacementId,
      firstAttemptAt: pendingLog.nextAttemptAt,
      expiresAt: pendingLog.expiresAt
    });
    this.schedulePendingWebCallReplay(firstAttemptAt);
  }

  @HostListener('document:pending-web-call-outcome-queued', ['$event'])
  onPendingWebCallOutcomeQueued(event: CustomEvent<{ callPlacementId?: string }>): void {
    const callPlacementId = event?.detail?.callPlacementId;
    if (!callPlacementId) return;
    void this.scheduleNewlyQueuedWebCallOutcome(callPlacementId);
  }

  private async scheduleNewlyQueuedWebCallOutcome(callPlacementId: string): Promise<void> {
    try {
      const queued = await this.getQueuedWebCallLog(callPlacementId);
      if (!queued?.event) return;

      const now = Date.now();
      const queuedAt = new Date(queued.event.queuedAt || '').getTime();
      const fallbackAttemptAt = (Number.isFinite(queuedAt) ? queuedAt : now)
        + WEB_CALL_OUTCOME_QUEUE_FALLBACK_DELAY_MS;
      const pendingLog: PendingWebCallOutcome = {
        ...queued.event,
        callPlacementId,
        expiresAt: queued.event.expiresAt
          || new Date((Number.isFinite(queuedAt) ? queuedAt : now) + WEB_CALL_OUTCOME_RETRY_WINDOW_MS).toISOString(),
        nextAttemptAt: queued.event.nextAttemptAt
          || new Date(fallbackAttemptAt).toISOString()
      };

      await this.persistQueuedWebCallLog(pendingLog, queued.cacheKey);
      this.schedulePendingWebCallReplay(new Date(pendingLog.nextAttemptAt).getTime());
    } catch (error) {
      this.logger.error('Error scheduling newly queued web-call outcome', error);
    }
  }

  private schedulePendingWebCallReplay(at: number): void {
    if (!Number.isFinite(at)) return;
    if (
      this.pendingWebCallReplayTimer != null
      && this.pendingWebCallReplayDueAt != null
      && this.pendingWebCallReplayDueAt <= at
    ) {
      return;
    }

    this.clearPendingWebCallReplayTimer();
    this.pendingWebCallReplayDueAt = at;
    this.pendingWebCallReplayTimer = window.setTimeout(() => {
      this.pendingWebCallReplayTimer = null;
      this.pendingWebCallReplayDueAt = null;
      void this.replayPendingWebCallLogsOnBoot(true);
    }, Math.max(0, at - Date.now()));
  }

  private clearPendingWebCallReplayTimer(): void {
    if (this.pendingWebCallReplayTimer != null) {
      window.clearTimeout(this.pendingWebCallReplayTimer);
    }
    this.pendingWebCallReplayTimer = null;
    this.pendingWebCallReplayDueAt = null;
  }

  private async replayPendingWebCallLogsOnBoot(silentSuccess = true): Promise<void> {
    if (this.replayingPendingWebCallLogs || !this.activeAccount) {
      return;
    }
    this.replayingPendingWebCallLogs = true;
    try {
      const keys = await localforage.keys();
      const pendingKeys = keys.filter(key => key.startsWith(this.pendingWebCallLogPrefix));
      for (const key of pendingKeys) {
        const pendingLog = await localforage.getItem<PendingWebCallOutcome>(key);
        if (!pendingLog) {
          continue;
        }
        if (!pendingLog.callPlacementId) {
          pendingLog.callPlacementId = key.substring(this.pendingWebCallLogPrefix.length);
        }
        if (pendingLog.accountId && pendingLog.accountId !== this.activeAccount.accountId) {
          continue;
        }
        if (pendingLog.userId && pendingLog.userId !== this.activeAccount.userId) {
          continue;
        }

        const now = Date.now();
        const expired = webCallOutcomeIsExpired(pendingLog, now);
        const nextAttemptAt = initialWebCallOutcomeAttemptAt(pendingLog, now);
        if (!expired && nextAttemptAt > now) {
          this.schedulePendingWebCallReplay(nextAttemptAt);
          continue;
        }

        this.logger.warn('Replaying pending web-call outcome from browser storage', {
          callPlacementId: pendingLog.callPlacementId,
          contactId: pendingLog.contactId,
          queuedAt: pendingLog.queuedAt,
          retryCount: pendingLog.retryCount,
          finalAttempt: expired
        });
        await this.saveCallLogFromWeb(pendingLog, key, {
          silentSuccess,
          finalAttempt: expired
        });
      }
    } catch (e) {
      this.logger.error('Error scanning pending web-call outcomes', e);
    } finally {
      this.replayingPendingWebCallLogs = false;
    }
  }

  private async removeQueuedWebCallLog(callPlacementId: string, cacheKey?: string): Promise<void> {
    const removals = [];
    if (cacheKey) {
      removals.push(localforage.removeItem(cacheKey));
    }
    if (callPlacementId) {
      removals.push(localforage.removeItem(this.getPendingWebCallLogKey(callPlacementId)));
      removals.push(localforage.removeItem(callPlacementId));
    }
    await Promise.allSettled(removals);
  }

  /**
   * LogCall closes a web-call dialog with the saved engagement only after the outcome reached the server;
   * a queued outcome (or a dismissed dialog) closes without it, and a queued outcome also leaves its
   * pending key in storage. Only a real save tells the lead grids/detail to refresh.
   */
  private async announceWebCallOutcomeSaved(
    closeResult: any,
    callPlacementId: string,
    accountId: string,
    contactId: string
  ): Promise<void> {
    if (!closeResult || !callPlacementId || !accountId || !contactId) {
      return;
    }
    try {
      if (await this.getQueuedWebCallLog(callPlacementId)) {
        return;
      }
    } catch (e) {
      this.logger.warn('Could not check the web-call outcome queue after the log-call dialog closed', e);
    }
    this.dataService.setLeadOutcomeSaved({ accountId, contactId });
  }

  private async deadLetterQueuedWebCallLog(
    event: PendingWebCallOutcome,
    cacheKey?: string,
    reason = 'RETRY_WINDOW_EXPIRED',
    lastError?: string
  ): Promise<void> {
    const callPlacementId = event?.callPlacementId;
    if (!callPlacementId) {
      return;
    }
    const deadLetter = {
      ...event,
      deadLetteredAt: new Date().toISOString(),
      deadLetterReason: reason,
      lastError: lastError || event.lastError
    };
    await localforage.setItem(this.getDeadWebCallLogKey(callPlacementId), deadLetter);
    await this.removeQueuedWebCallLog(callPlacementId, cacheKey);
  }

  async saveCallLogFromWeb(
    rawEvent: PendingWebCallOutcome,
    cacheKey: string = null,
    options: { silentSuccess?: boolean, finalAttempt?: boolean } = {}
  ): Promise<boolean> {
    const pendingLog: PendingWebCallOutcome = {
      ...rawEvent,
      completedSteps: { ...(rawEvent.completedSteps || {}) }
    };
    const callPlacementId = pendingLog.callPlacementId;
    const updateEngagement = pendingLog.updateEngagement;
    if (!callPlacementId || !updateEngagement) {
      await this.deadLetterQueuedWebCallLog(
        pendingLog,
        cacheKey,
        'INVALID_PENDING_OUTCOME',
        'Missing callPlacementId or updateEngagement payload'
      );
      this.toastr.error(this.webCallOutcomeNotSavedMessage(pendingLog));
      return false;
    }

    pendingLog.lastAttemptAt = new Date().toISOString();
    delete pendingLog.nextAttemptAt;
    cacheKey = await this.persistQueuedWebCallLog(pendingLog, cacheKey);

    let existingEngagement: Engagement;
    try {
      existingEngagement = await this.api.GetEngagement(callPlacementId) as Engagement;
    } catch (error) {
      return this.handleQueuedWebCallReplayFailure(
        pendingLog,
        cacheKey,
        error,
        classifyWebCallOutcomeError(error),
        options
      );
    }

    if (!existingEngagement) {
      return this.handleQueuedWebCallReplayFailure(
        pendingLog,
        cacheKey,
        new Error(`Engagement ${callPlacementId} is not available yet`),
        'ENGAGEMENT_NOT_FOUND',
        options
      );
    }

    if (
      pendingLog.accountId
      && existingEngagement.accountId
      && pendingLog.accountId !== existingEngagement.accountId
    ) {
      return this.handleQueuedWebCallReplayFailure(
        pendingLog,
        cacheKey,
        new Error('Engagement account does not match the queued outcome account'),
        'PERMANENT_ERROR',
        options
      );
    }

    try {
      let updatedEngagement: { id: string } = existingEngagement;
      const remainingSteps = new Set(remainingWebCallOutcomeSteps(pendingLog));
      if (remainingSteps.has('outcome')) {
        updatedEngagement = await this.api.UpdateEngagement({
          ...updateEngagement,
          id: callPlacementId,
          updatedAt: new Date().toISOString()
        });
        pendingLog.completedSteps.outcome = new Date().toISOString();
        cacheKey = await this.persistQueuedWebCallLog(pendingLog, cacheKey);
      }

      if (remainingSteps.has('customForm')) {
        await this.saveCustomFormValue(
          pendingLog.customFormData,
          updatedEngagement.id,
          pendingLog.contactId,
          !!options.silentSuccess
        );
        pendingLog.completedSteps.customForm = new Date().toISOString();
        cacheKey = await this.persistQueuedWebCallLog(pendingLog, cacheKey);
      }

      if (remainingSteps.has('nextStep')) {
        await this.createNextStep(
          updatedEngagement.id,
          pendingLog.nextStepTaskId,
          pendingLog.nextStepTaskForm,
          pendingLog.nextStepTaskType,
          pendingLog.contactId,
          updatedEngagement,
          !!options.silentSuccess
        );
        pendingLog.completedSteps.nextStep = new Date().toISOString();
        cacheKey = await this.persistQueuedWebCallLog(pendingLog, cacheKey);
      }

      if (remainingSteps.has('followUp')) {
        await this.setFollowUpOnLead(
          pendingLog.nextFollowUp,
          updatedEngagement.id,
          pendingLog.contactId,
          pendingLog.contactName
        );
        pendingLog.completedSteps.followUp = new Date().toISOString();
        cacheKey = await this.persistQueuedWebCallLog(pendingLog, cacheKey);
      }

      if (remainingSteps.has('deal')) {
        const dealResponse = await this.api.CreateDealOnContact(null, {
          input: {
            ...pendingLog.dealInput,
            parentEngagementId: updatedEngagement.id
          }
        });
        pendingLog.createdDealId = createdDealIdFromResponse(dealResponse) || undefined;
        pendingLog.completedSteps.deal = new Date().toISOString();
        cacheKey = await this.persistQueuedWebCallLog(pendingLog, cacheKey);
      }

      if (remainingSteps.has('dealCustomForm')) {
        if (!pendingLog.createdDealId) {
          const missingDealIdError = new Error(
            'Created deal response did not contain an id for custom-form reconciliation'
          );
          missingDealIdError.name = 'MalformedRequestException';
          throw missingDealIdError;
        }
        await this.saveCustomFormValue(
          pendingLog.dealCustomFormData,
          pendingLog.createdDealId,
          pendingLog.contactId,
          !!options.silentSuccess
        );
        pendingLog.completedSteps.dealCustomForm = new Date().toISOString();
        cacheKey = await this.persistQueuedWebCallLog(pendingLog, cacheKey);
      }

      await this.removeQueuedWebCallLog(callPlacementId, cacheKey);
      this.logger.log('Queued call outcome reconciliation completed', {
        callPlacementId,
        contactId: pendingLog.contactId,
        completedSteps: Object.keys(pendingLog.completedSteps)
      });
      // A queued outcome just reached the server: always tell the user, even on a silent boot replay.
      this.toastr.success(`Call outcome for ${pendingLog.contactName || 'the lead'} saved.`);
      const savedAccountId = pendingLog.accountId || this.activeAccount?.accountId;
      if (savedAccountId && pendingLog.contactId) {
        this.dataService.setLeadOutcomeSaved({ accountId: savedAccountId, contactId: pendingLog.contactId });
      }
      return true;
    } catch (error) {
      return this.handleQueuedWebCallReplayFailure(
        pendingLog,
        cacheKey,
        error,
        classifyWebCallOutcomeError(error),
        options
      );
    }
  }

  private webCallOutcomeNotSavedMessage(pendingLog: PendingWebCallOutcome): string {
    return `Call outcome for ${pendingLog?.contactName || 'the lead'} could not be saved. Please log it again from the lead.`;
  }

  private async handleQueuedWebCallReplayFailure(
    pendingLog: PendingWebCallOutcome,
    cacheKey: string,
    error: any,
    failureType: WebCallOutcomeFailureType,
    options: { silentSuccess?: boolean, finalAttempt?: boolean }
  ): Promise<false> {
    const errorText = webCallOutcomeErrorText(error);
    const expired = options.finalAttempt || webCallOutcomeIsExpired(pendingLog);
    if (failureType === 'PERMANENT_ERROR' || expired) {
      const deadLetterReason = failureType === 'PERMANENT_ERROR'
        ? 'PERMANENT_RECONCILIATION_ERROR'
        : failureType === 'ENGAGEMENT_NOT_FOUND'
          ? 'ENGAGEMENT_NOT_FOUND_WITHIN_24H'
          : 'RETRY_WINDOW_EXPIRED';
      await this.deadLetterQueuedWebCallLog(pendingLog, cacheKey, deadLetterReason, errorText);
      this.logger.error('Web-call outcome reconciliation stopped', {
        callPlacementId: pendingLog.callPlacementId,
        deadLetterReason,
        error: errorText
      });
      this.toastr.error(this.webCallOutcomeNotSavedMessage(pendingLog));
      return false;
    }

    const retryCount = (pendingLog.retryCount || 0) + 1;
    const nextAttemptAt = nextWebCallOutcomeAttemptAt(pendingLog, retryCount);
    const updatedPendingLog: PendingWebCallOutcome = {
      ...pendingLog,
      retryCount,
      lastAttemptAt: new Date().toISOString(),
      lastFailureType: failureType,
      lastError: errorText,
      nextAttemptAt: new Date(nextAttemptAt).toISOString(),
      expiresAt: pendingLog.expiresAt
        || new Date(webCallOutcomeExpiryTime(pendingLog)).toISOString()
    };

    await this.persistQueuedWebCallLog(updatedPendingLog, cacheKey);
    this.logger.warn('Queued call outcome replay failed; a bounded retry was scheduled.', {
      callPlacementId: pendingLog.callPlacementId,
      retryCount,
      failureType,
      nextAttemptAt: updatedPendingLog.nextAttemptAt,
      expiresAt: updatedPendingLog.expiresAt,
      error: errorText
    });
    this.schedulePendingWebCallReplay(nextAttemptAt);
    return false;
  }

  async saveCustomFormValue(ev: any, object: string, contactId: string, silent = false) {
    try {
      await this.submittedForm.save(ev, object, {
        activeAccount: this.activeAccount,
        contactId: contactId
      });
    } catch (e) {
      if (!silent) {
        this.showErrorInToastr(e, 'Error Saving Custom form data');
      }
      throw e;
    }
  }

  async setFollowUpOnLead(isoDateTimeString: string, engagementId: string, contactId: string, contactName: string) {
    let i = <CreateMissedOpportunitiesInput>{};
    i.accountId = this.activeAccount.accountId;
    i.ownerId = this.activeAccount.userId;
    i.contactId = contactId;
    i.missedOpportunityType = MissedOpportunityType.CALL_LATER;
    i.relatedEngagementId = engagementId;
    i.callLaterDateTime = isoDateTimeString;
    i.messageBody = `This is a reminder to call your lead ${contactName}`
    const existing = await this.api.GetMissedOpportunities(
      i.accountId,
      i.ownerId,
      i.contactId,
      i.missedOpportunityType
    );
    if (existing) {
      await this.api.UpdateMissedOpportunities(<UpdateMissedOpportunitiesInput>{
        ...i,
        updatedAt: new Date().toISOString()
      });
    } else {
      await this.api.CreateMissedOpportunities(i);
    }
  }

  async createNextStep(parentEngagementId, taskId, nextStepTaskForm, nextStepTaskType, contactId, preSelectedCall, silent = false) {
    const existingTask = taskId ? await this.api.GetEngagement(taskId) : null;
    const isUpdate = !!existingTask;
    let payload;
    if (isUpdate)
      payload = <UpdateEngagementInput>{};
    else
      payload = <CreateEngagementInput>{};
    let formValue = cloneDeep(nextStepTaskForm);

    delete formValue.assignToType;
    delete formValue.assignedTeam;
    delete formValue.assignedUser;
    delete formValue.dueDateTime;
    delete formValue.reminderDateTime;
    delete formValue.id;
    delete formValue.transferLead;

    payload = formValue;

    payload.taskType = <any>nextStepTaskType;
    payload.taskHeading = nextStepTaskType;
    payload.parentEngagementId = parentEngagementId;
    payload.engagementStatus = EngagementStatus.ACTIVE;

    if (nextStepTaskForm.assignToType == "SELF") {
      payload.ownerId = this.activeAccount.userId;
      //if account type is non individual then also update primary team id for self
      if (nextStepTaskForm.assignedTeam)
        payload.primaryTeamId = nextStepTaskForm.assignedTeam;
      payload.toBeAssigned = ContactAssignmentStatus.ASSIGNED;
    }
    if (nextStepTaskForm.assignToType == "UNASSIGNED") {
      payload.ownerId = this.activeAccount.userId;
      payload.toBeAssigned = ContactAssignmentStatus.UNASSIGNED;
      // payload.primaryTeamId = null;
    }
    if (nextStepTaskForm.assignToType == "TEAM") {
      payload.primaryTeamId = nextStepTaskForm.assignedTeam;
      // payload.ownerId = null;
      payload.toBeAssigned = ContactAssignmentStatus.UNASSIGNED;
    }
    if (nextStepTaskForm.assignToType == "USER") {
      payload.ownerId = nextStepTaskForm.assignedUser;
      if (nextStepTaskForm.assignedTeam)
        payload.primaryTeamId = nextStepTaskForm.assignedTeam;
      // else
      //   payload.primaryTeamId = null;
      payload.toBeAssigned = ContactAssignmentStatus.ASSIGNED;
    }
    if (nextStepTaskForm.assignToType == "REPORTEE") {
      payload.ownerId = nextStepTaskForm.assignedUser;
      if (nextStepTaskForm.assignedTeam)
        payload.primaryTeamId = nextStepTaskForm.assignedTeam;
      // else
      //   payload.primaryTeamId = null;
      payload.toBeAssigned = ContactAssignmentStatus.ASSIGNED;
    }
    // if (this.parsed_address)
    //   payload.taskLocation = this.parsed_address;

    payload.accountId = this.activeAccount.accountId;
    payload.engagementType = EngagementType.TASK;
    payload.contactId = contactId;
    if (nextStepTaskForm.dueDateTime && globalFunctions.isDate(nextStepTaskForm.dueDateTime))
      payload.dueDateTime = nextStepTaskForm.dueDateTime.toISOString();
    else if (nextStepTaskForm.dueDateTime)
      payload.dueDateTime = nextStepTaskForm.dueDateTime;
    if (nextStepTaskForm.reminderDateTime && globalFunctions.isDate(nextStepTaskForm.reminderDateTime))
      payload.reminderDateTime = nextStepTaskForm.reminderDateTime.toISOString();
    else if (nextStepTaskForm.reminderDateTime)
      payload.reminderDateTime = nextStepTaskForm.reminderDateTime;
    else {
      let dueDateTime = new Date(payload.dueDateTime);
      let newDateObj2 = new Date(dueDateTime.getTime() - 30 * 60000);
      payload.reminderDateTime = newDateObj2.toISOString();
    }
    payload.nextFollowUpOn = payload.dueDateTime;
    payload.nextFollowUpSetBy = "USER";
    payload.id = taskId;
    this.logger.log('Reconciling queued next-step task', {
      taskId,
      parentEngagementId,
      isUpdate
    });
    if (isUpdate) {
      let d = new Date();
      payload.updatedAt = d.toISOString();
      await this.api.UpdateEngagement(payload).then(async () => {
        this.logger.log('Queued next-step task updated', { taskId });
        if (!silent) {
          this.toastr.success('Next Step Successfully Updated');
        }
        if (nextStepTaskForm.transferLead == true) {
          await this.transferLead(nextStepTaskForm, contactId, silent);
        }
      })
        .catch(e => {
          console.log('Error Updating task', e);;
          throw e;
        });
    } else {
      await this.api.CreateEngagement(payload).then(async () => {
        this.logger.log('Queued next-step task created', { taskId });
        if (!silent) {
          this.toastr.success('Next Step Successfully Created');
        }
        if (nextStepTaskForm.transferLead == true) {
          await this.transferLead(nextStepTaskForm, contactId, silent);
        }
      })
        .catch(e => {
          console.log('Error creating task', e);
          throw e;
        });
    }
  }

  async transferLead(nextStepTaskForm, contactId, silent = false) {
    let input = <CreateEntityActionDefinitionInput>{}
    input.accountId = this.activeAccount.accountId;
    input.ownerId = this.activeAccount.userId;
    input.action = "TRANSFER_LEAD";
    let result = {};
    if (nextStepTaskForm.assignedUser) {
      result["assignedUser"] = nextStepTaskForm.assignedUser
      result["assignToType"] = "USER"
      result["migrateEngagement"] = true
      result["migrateDeal"] = true
    }
    else if (nextStepTaskForm.assignedTeam) {
      result["assignedTeam"] = nextStepTaskForm.assignedTeam
      result["assignToType"] = "TEAM"
      result["migrateEngagement"] = true
      result["migrateDeal"] = true
    }
    let date = new Date();
    input.name = "Assign Lead Default Layout " + date.toDateString();
    input.subscriptionType = "ADHOC"
    input.status = "REQUESTED"
    input.createdBy = this.activeAccount.userId;
    input.updatedBy = this.activeAccount.userId;
    input.segment = <Segment>{}
    let selectedFilter = { and: [{ accountId: { eq: this.activeAccount.accountId } }, { id: { IN: [contactId] } }] };
    input.segment.criteria = JSON.stringify(selectedFilter);
    input.target = JSON.stringify(result);
    input.segment.joinStatement = "Contact";
    input.segment.defaultTableName = "contact";
    await this.api.CreateEntityActionDefinition(input).then(() => {
      this.logger.log('Queued lead-transfer action created', { contactId });
      if (!silent) {
        this.toastr.success('Lead Transfer Job Submitted', 'You will be notified once assignment is completed');
      }
    })
      .catch(e => {
        console.log('Error Transferring Leads', e);
        if (!silent) {
          this.showErrorInToastr(e, 'Error Transferring Leads');
        }
        throw e;
      });
  }

  onDemoModeChange(event: any): void {
    this.demoModeEnabled = event.checked;
    const sessionKey = this.dataService.getSessionKeyForAccount(this.activeAccount);
    if (sessionKey) {
      this.dataService.setDemoMode(this.demoModeEnabled, sessionKey);
    }
  }

  /**
   * Removes expired dashboard cache entries and orphaned call placement keys from localforage.
   * Runs on account init and then periodically - non-blocking, fire-and-forget.
   */
  private async cleanupExpiredLocalforageEntries(): Promise<void> {
    const now = Date.now();
    if (
      this.localforageCleanupInProgress ||
      (this.lastLocalforageCleanupAt && now - this.lastLocalforageCleanupAt < this.LOCALFORAGE_CLEANUP_INTERVAL_MS)
    ) {
      return;
    }

    this.localforageCleanupInProgress = true;
    try {
      const expirablePrefixes = [
        'realTimeMetrics_',
        'previousRealTimeMetrics_',
        'leadTransitionStats_',
        'leadMetricsPreviousPeriod_',
        'callTrend_',
        'callTrendPrev_',
        'activityHourly_',
        'activityMetrics_',
        'leadSource_',
        'paymentPace_',
        'pulse_',
        'taskCounts_',
        'userLoad_'
      ];

      const keys = await localforage.keys();
      const todayKey = getLocalDateKey();
      let removedCount = 0;

      const sevenDaysMs = 7 * 86400000;

      for (const key of keys) {
        try {
          // Dashboard cache entries (date-based accumulation)
          const isExpirable = expirablePrefixes.some(p => key.startsWith(p));
          if (isExpirable) {
            const cached = await localforage.getItem<any>(key);

            // Pattern 0 — standardized AggCacheRecord (schemaVersion 2). Must
            // run FIRST: canonical keys embed fromDt, which Pattern 3's
            // first-date regex would misread and delete fresh WEEK/MONTH
            // entries immediately. Expired-fresh entries are NOT deleted —
            // they are the stale-while-revalidate fallback; only staleUntil
            // ends their life.
            const v2Expired = isExpiredAggCacheRecord(cached, now);
            if (v2Expired !== null) {
              if (v2Expired) {
                await localforage.removeItem(key);
                removedCount++;
              }
              continue;
            }

            // Pattern 1: legacy getOrSetCache entries with { expiry, data }.
            // expiry is a FRESHNESS bound, not a delete-by date: keep the
            // entry as stale fallback for the retention window.
            if (cached?.expiry && cached.expiry + staleRetentionMs() < now) {
              await localforage.removeItem(key);
              removedCount++;
              continue;
            }

            // Pattern 2: entries with { data, _cacheTimestamp } (legacy realTimeMetrics_*)
            // Conservative rollout retention from the central config: maximum
            // freshness window + stale retention. A hardcoded 24h here could
            // delete a legacy non-day fallback earlier than the loader would.
            const legacyRetentionMs = aggMetricsCache.nonDayFreshHours * 3600 * 1000 + staleRetentionMs();
            if (cached?._cacheTimestamp && cached._cacheTimestamp < now - legacyRetentionMs) {
              await localforage.removeItem(key);
              removedCount++;
              continue;
            }

            // Pattern 3: legacy raw data entries (previousRealTimeMetrics_*, leadMetricsPreviousPeriod_*)
            // Key contains a date like _2026-02-07 (may be mid-key or at end) - remove if not today
            if (!cached?.expiry && !cached?._cacheTimestamp) {
              const dateMatch = key.match(/(\d{4}-\d{2}-\d{2})/);
              if (dateMatch && dateMatch[1] < todayKey) {
                await localforage.removeItem(key);
                removedCount++;
                continue;
              }
            }
            continue;
          }

          if (key.startsWith('payment_pace_prev_')) {
            await localforage.removeItem(key);
            removedCount++;
            continue;
          }

          if (key.startsWith(this.pendingWebCallLogPrefix)) {
            const pendingLog = await localforage.getItem<PendingWebCallOutcome>(key);
            if (!pendingLog) continue;
            const belongsToActiveSession =
              (!pendingLog.accountId || pendingLog.accountId === this.activeAccount?.accountId)
              && (!pendingLog.userId || pendingLog.userId === this.activeAccount?.userId);
            if (!belongsToActiveSession && webCallOutcomeIsExpired(pendingLog, now)) {
              pendingLog.callPlacementId = pendingLog.callPlacementId
                || key.substring(this.pendingWebCallLogPrefix.length);
              await this.deadLetterQueuedWebCallLog(
                pendingLog,
                key,
                'ABANDONED_PENDING_RETRY_WINDOW_EXPIRED',
                'The original account/user session did not return within the retry window'
              );
              removedCount++;
            }
            continue;
          }

          if (key.startsWith(this.deadWebCallLogPrefix)) {
            const deadLetter = await localforage.getItem<any>(key);
            const deadLetteredAt = deadLetter?.deadLetteredAt
              ? new Date(deadLetter.deadLetteredAt).getTime()
              : 0;
            if (deadLetteredAt && deadLetteredAt < now - this.deadWebCallLogRetentionMs) {
              await localforage.removeItem(key);
              removedCount++;
            }
            continue;
          }

          // Today's Plan snapshots (keyed by accountId + level, e.g. todays_plan_snapshot_abc123_All)
          // Remove if older than 24 hours. Also remove legacy key.
          if (key.startsWith('todays_plan_snapshot_') || key === 'todays_plan_previous_snapshot') {
            const cached = await localforage.getItem<any>(key);
            if (key === 'todays_plan_previous_snapshot' || (cached?.timestamp && cached.timestamp < now - 24 * 60 * 60 * 1000)) {
              await localforage.removeItem(key);
              removedCount++;
            }
            continue;
          }

          // Custom tracking metrics snapshot history (keyed by accountId, e.g. custom_metrics_snapshots_abc123)
          // Prune snapshots older than 2 hours; remove key entirely if all are stale.
          // Also remove legacy keys.
          if (key.startsWith('custom_metrics_snapshots_') || key === 'custom_metrics_snapshots_v2' || key === 'custom_metrics_previous_snapshot') {
            const cached = await localforage.getItem<any>(key);
            if (key === 'custom_metrics_previous_snapshot' || key === 'custom_metrics_snapshots_v2') {
              // Legacy keys — remove unconditionally
              await localforage.removeItem(key);
              removedCount++;
              continue;
            }
            if (Array.isArray(cached)) {
              const twoHoursMs = 2 * 60 * 60 * 1000;
              const pruned = cached.filter((s: any) => s?.timestamp && s.timestamp >= now - twoHoursMs);
              if (pruned.length === 0) {
                await localforage.removeItem(key);
                removedCount++;
              } else if (pruned.length < cached.length) {
                await localforage.setItem(key, pruned);
              }
            } else {
              // Unexpected format — remove
              await localforage.removeItem(key);
              removedCount++;
            }
            continue;
          }

          // S3 file/image cache entries (keys end with 'v1', store { value, lastChecked })
          // Orphaned when user uploads new image (new key, old one abandoned)
          if (key.endsWith('v1')) {
            const cached = await localforage.getItem<any>(key);
            if (cached?.lastChecked && cached.lastChecked < now - sevenDaysMs) {
              await localforage.removeItem(key);
              removedCount++;
            }
          }
        } catch {
          // A read/processing exception is NOT evidence the entry is bad — an
          // IndexedDB read hiccup must never destroy a user's stale fallback.
          // Skip; a genuinely rotten entry is removed by its pattern above
          // once it is actually readable.
        }
      }

      if (removedCount > 0) {
        console.log(`[localforage cleanup] Removed ${removedCount} expired cache entries`);
      }
    } catch (e) {
      console.error('[localforage cleanup] Error during cleanup', e);
    } finally {
      this.lastLocalforageCleanupAt = Date.now();
      this.localforageCleanupInProgress = false;
    }
  }



}

@Component({
  standalone: false,
  selector: 'in-call-notification',
  templateUrl: 'in-call-notification.html',
})
export class InCallNotification {
  constructor(
    private dialogService: DialogService,
    public snackBarRef: MatSnackBarRef<InCallNotification>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any) { }


  viewCallDetail() {
    console.log("function called from snackbar");
    let title = `In Call With ${this.data.inCallWithContactName}`
    // this.snackBarRef.dismiss();
    const callDialogRef = this.dialogService.open(InCallComponent, { data: { contactId: this.data.inCallWithContactId, title: title } });
  }
}


@Component({
  selector: 'entity-action-notification',
  templateUrl: 'entity-action-notification.html',
  imports: [FormatEnumPipe],
})
export class EntityActionNotification {
  constructor(
    private router: Router,
    public snackBarRef: MatSnackBarRef<EntityActionNotification>,
    @Inject(MAT_SNACK_BAR_DATA) public entityAction: EntityActionDefinition) { }

  closeEntityActionSnackBar() {
    this.snackBarRef.dismiss();
  }

  viewExportedData() {
    this.snackBarRef.dismiss();
    this.router.navigate(['/export/exports']);
  }
}


@Component({
  standalone: false,
  selector: 'new-lead-notification',
  templateUrl: 'new-lead-notification.html',
})
export class NewLeadNotification {
  constructor(
    private router: Router,
    public snackBarRef: MatSnackBarRef<NewLeadNotification>,
    @Inject(MAT_SNACK_BAR_DATA) public newLeadCount: number) { }

  closeNewLeadSnackBar() {
    this.snackBarRef.dismiss();
  }

  viewNewLeadsData() {
    this.router.navigate(['/leads'], {
      queryParams: {
        filter: "uncontacted"
      }
    });
  }
}

@Component({
  standalone: false,
  selector: 'upcoming-task-notification',
  templateUrl: 'upcoming-task-notification.html',
})
export class UpcomingTaskNotification {
  constructor(
    private dialogService: DialogService,
    public snackBarRef: MatSnackBarRef<UpcomingTaskNotification>,
    @Inject(MAT_SNACK_BAR_DATA) public taskCount: number) { }

  dismiss() {
    this.snackBarRef.dismiss();
  }

  viewTasks() {
    this.snackBarRef.dismiss();
    this.dialogService.open(AdHocReminderComponent, { data: {} });
  }
}

@Component({
  standalone: false,
  selector: 'missed-call-notification',
  templateUrl: 'missed-call-notification.html',
})
export class MissedCallNotification {
  count: number;
  filter: SearchableContactFilterInput;

  constructor(
    private dialogService: DialogService,
    public snackBarRef: MatSnackBarRef<MissedCallNotification>,
    @Inject(MAT_SNACK_BAR_DATA) data: { count: number; filter: SearchableContactFilterInput }
  ) {
    this.count = data?.count ?? 0;
    this.filter = data?.filter;
  }

  view() {
    this.snackBarRef.dismiss();
    if (this.filter) {
      this.dialogService.open(FilteredContactsComponent, { data: { filter: this.filter } }, 1);
    }
  }
}
